import React, { useState, useCallback, useEffect, useRef, useMemo } from 'react';
import { createPortal } from 'react-dom'; // [PATCH zgornja-reza v1]
import { smerAplikacije, preberiAplikacijo } from '../aplikacije'; // [PATCH aplikacije-fe v3] smer po aktivni aplikaciji
import { useSearchParams } from 'react-router-dom'; // [PATCH obvestila-dokumenti v1]
import { IzdajaPage } from './izdaja/IzdajaPage'; // [PATCH izdaja-dokumenti v1]
import { useIzdajaModul } from '../components/sifranti/SifrantArtiklov'; // [PATCH izdaja-dokumenti v1]
import { useDropzone } from 'react-dropzone';
import { Upload, FileText, CheckCircle, AlertTriangle, Eye, ChevronDown, Trash2, Receipt, Landmark, Wallet, Plus, Search, X, Download, Inbox } from 'lucide-react';
import toast from 'react-hot-toast';
import clsx from 'clsx';
import { api } from '../lib/api';
import { VkrNastavitveKartica } from '../components/nastavitve/VkrNastavitveKartica'; // [PATCH miniblagajna-fe v1]
import { useAuthStore } from '../stores/authStore';
import { useUploadStore } from '../stores/uploadStore';
import { deloSledilec } from '../lib/deloSledilec'; // [PATCH pregled-dela v2]
import { iskanjeKontov } from '../lib/kontoIskanje'; // [PATCH konto-iskanje-naziv v1]
import { useObvestilaStore } from '../stores/obvestilaStore'; // [PATCH obvestila-dokumenti v1]
import { OpombeNit, OPOMBE_DOGODEK } from '../components/opombe/OpombeNit'; // [PATCH opombe-stranka-fe v1]
import { DdvKnjiga, VRSTE_DDV, stopnjaNedolocena, jeOssVrsta, knjigaVrsticeDdv } from '../components/DdvKnjiga'; // [PATCH glava-sync v1] knjigaVrsticeDdv // [PATCH ddv-stopnja-vrata v1] + [PATCH oss-uvoz v1] jeOssVrsta
import { ddvKonto, kategorijaIzVrste } from '../lib/ddvKonto'; // [PATCH ddv-konto-lib v1] en vir resnice
import { KontiranjeEditor } from '../components/KontiranjeEditor';
import { KontoBesedePopup } from '../components/KontoSelector'; // [PATCH ir4a-ui-postavke v1]
import { ZnesekInput } from '../components/ZnesekInput';
import { PdfViewer } from '../components/PdfViewer';
import { PartnerSelector } from '../components/PartnerSelector';
import { PartnerFursModal } from '../components/PartnerFursForm'; // [PATCH partner-uredi-z-racuna v1]
import { VascoSifraBadge } from '../components/VascoSifraBadge';
import { InsolventnostOpozorilo } from '../components/InsolventnostOpozorilo';
import { TIPI_DOK_VSI, jeIzdaniTip, tipiZaMenjavo, oznakaTipa, barvaTipa, oznakaKratka, internaPrikaz, letoIzSerije } from '../utils/docSmer';  /* [PATCH izdani-doctype-fe v2] + [PATCH interne-predpone v1] */
import { MailVhodOznaka } from '../components/MailVhodOznaka';  // [PATCH mail-vhod-D3 v1]

// [PATCH izdani-vrstni-red-knjizb-fe v1] Vrstni red knjizb IZDANIH racunov v UI:
// 12x terjatve -> 26x obracunani DDV -> vse ostalo v obstojecem vrstnem redu.
// Odlocitev Janez, 27.08.2026.
// Sortiranje je stabilno po EKSPLICITNEM indeksu (ne zanasamo se na stabilnost
// Array.prototype.sort), zato se znotraj skupine nic ne premesa.
// Klice se SAMO ob nalaganju obstojecega dokumenta v stanje, nikoli med
// urejanjem -- sicer bi vrstice skakale med tipkanjem.
// Preureditev je varna tudi ob shranjevanju: opal.py knjizbe filtrira po
// tip / konto in nikjer ne dostopa pozicijsko (izmerjeno 27.08.2026).
function _uredKnjizbeIzdani(kont: any, docType: any): any {
  if (!kont || !jeIzdaniTip(docType) || !Array.isArray(kont.knjizbe)) return kont;
  const _skupina = (kb: any) => {
    const _k = String((kb && kb.konto) || '');
    if (_k.startsWith('12')) return 0;
    if (_k.startsWith('26')) return 1;
    return 2;
  };
  const _urejene = kont.knjizbe
    .map((kb: any, i: number) => ({ kb, i }))
    .sort((a: any, b: any) => (_skupina(a.kb) - _skupina(b.kb)) || (a.i - b.i))
    .map((x: any) => x.kb);
  return { ...kont, knjizbe: _urejene };
}

/* [PATCH sop-status-oznake v1] surovi statusi backenda (import_batch /
   import_item) -> slovenske oznake ZA IZPIS. Primerjave v kodi ostajajo na
   surovih vrednostih; prevede se samo besedilo, ki ga vidi uporabnik. */
const OZNAKE_STATUSA: Record<string,string> = {
  v_vrsti: 'v vrsti', priprava: 'priprava', razrez: 'razrez', obdelava: 'obdelava',
  caka: 'čaka', v_obdelavi: 'v obdelavi', koncano: 'končano', napaka: 'napaka',
  preskocen: 'preskočen', izpuscen: 'izpuščen', razveljavljen: 'razveljavljen',
};
const oznakaStatusa = (s: any) => OZNAKE_STATUSA[String(s||'')] || String(s||'');

const fmt = (n: number) => { const x = Number(n||0).toFixed(2); const [c, d] = x.split('.'); return c.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d; };
const fmtDatum = (d: string) => {
  if(!d) return '—';
  try {
    const [y,m,dd] = d.split('-');
    if(y && m && dd) return dd+'.'+m+'.'+y;
    return d;
  } catch { return d; }
};

const statusConfig: Record<string, { label: string; color: string }> = {
  uploaded:{label:'Naložen',color:'gray'}, processing:{label:'Obdelava',color:'blue'},
  extracted:{label:'Prebran',color:'blue'}, validated:{label:'Validiran',color:'green'},
  review_needed:{label:'Pregled',color:'amber'}, approved:{label:'Potrjen',color:'green'},
  exported:{label:'Izvožen',color:'purple'},
};
const colorMap:Record<string,string>={
  gray:'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
  blue:'bg-blue-100 text-blue-600 dark:bg-blue-900 dark:text-blue-300',
  green:'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300',
  amber:'bg-amber-100 text-amber-700 dark:bg-amber-900 dark:text-amber-300',
  purple:'bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-300',
  teal:'bg-teal-100 text-teal-700 dark:bg-teal-900 dark:text-teal-300',
};
function StatusIkona({doc}:{doc:any}){
  let Icon:any=CheckCircle, cls='text-amber-500', tip='Uvožen — za pregled';
  if(doc.exported_at){cls='text-blue-500';tip='Preneseno v računovodski program';}
  else if(doc.status==='approved'){cls='text-green-500';tip='Potrdil računovodja';}
  else if(doc.manjka_podatek){Icon=AlertTriangle;cls='text-red-500';tip='Manjka podatek';}
  return <span title={tip} className="inline-flex"><Icon className={clsx('w-4 h-4',cls)}/></span>;
}
function ZaupanjeBars({raven,zaupanje}:{raven?:string;zaupanje?:number}){
  const n = raven==='visoko'?3:raven==='srednje'?2:1;
  const aktivna = raven==='nizko'?'bg-teal-300 dark:bg-teal-700':'bg-teal-500';
  return (
    <span title={`Zaupanje: ${zaupanje ?? '?'}%`} className="inline-flex items-end gap-0.5 h-4 align-middle">
      {[0,1,2].map(i=>(
        <span key={i} className={clsx('w-1 rounded-sm', i<n?aktivna:'bg-gray-200 dark:bg-gray-700')} style={{height:`${5+i*4}px`}}/>
      ))}
    </span>
  );
}

const TIPI_DOKUMENTOV = [
  { id: 'prejeti_racun', label: 'Prejeti računi', icon: Receipt },
  { id: 'izdani_racun', label: 'Izdani računi', icon: FileText },
  { id: 'bancni_izpisek', label: 'Bančni izpiski', icon: Landmark },
  { id: 'blagajna', label: 'Blagajna', icon: Wallet },
];

// [PATCH seznam-stanje-filter-fe v2] Izbira filtra stanja prezivi odmontiranje strani.
// Modul-scope namenoma: ostane, dokler je aplikacija nalozena v brskalniku
// (menjava menija, preklop zavihka, menjava podjetja), ponovno nalaganje
// strani (F5) pa vrne privzetek 'vsi'.
let _stanjeSticky: 'vsi'|'neprenesen'|'nepotrjen'|'nelikvidiran' = 'vsi'; // [PATCH likvidacija-fe v1]

// Pametno parsiranje datuma: "18" -> 18.{tekoci mesec}.{leto}, "1806" -> 18.06.{leto},
// "18.6" / "18,6" / "18 6" -> 18.06.{leto}, "18.6.26" -> 18.06.2026. Vedno dd.mm.yyyy.
function parseDatumVnos(vnos: string): string | null {
  if (!vnos) return null;
  const danes = new Date();
  const letoFull = (y: string): number => {
    const n = parseInt(y, 10);
    if (y.length === 4) return n;
    if (y.length <= 2) return 2000 + n;  // "26" -> 2026
    return n;
  };
  let d: number, m: number, y: number;
  // ce ima locilo (. , presledek /)
  const cisto = vnos.trim().replace(/[,\/\s]+/g, '.');
  if (cisto.includes('.')) {
    const p = cisto.split('.').filter(x => x !== '');
    if (p.length < 2) {
      d = parseInt(p[0], 10); m = danes.getMonth() + 1; y = danes.getFullYear();
    } else {
      d = parseInt(p[0], 10);
      m = parseInt(p[1], 10);
      y = p[2] ? letoFull(p[2]) : danes.getFullYear();
    }
  } else {
    // samo stevke
    const num = vnos.replace(/\D/g, '');
    if (num.length <= 2) {            // "18" -> dan
      d = parseInt(num, 10); m = danes.getMonth() + 1; y = danes.getFullYear();
    } else if (num.length === 3) {    // "186" -> 1.8.6? raje d=1,m=8? -> vzemi ddm dvoumno: d=num[0..1]? 
      d = parseInt(num.slice(0, 1), 10); m = parseInt(num.slice(1, 3), 10); y = danes.getFullYear();
    } else if (num.length === 4) {    // "1806" -> 18.06.{leto}
      d = parseInt(num.slice(0, 2), 10); m = parseInt(num.slice(2, 4), 10); y = danes.getFullYear();
    } else if (num.length === 6) {    // "180626" -> 18.06.2026
      d = parseInt(num.slice(0, 2), 10); m = parseInt(num.slice(2, 4), 10); y = letoFull(num.slice(4, 6));
    } else if (num.length === 8) {    // "18062026"
      d = parseInt(num.slice(0, 2), 10); m = parseInt(num.slice(2, 4), 10); y = parseInt(num.slice(4, 8), 10);
    } else {
      return null;
    }
  }
  if (!d || !m || d < 1 || d > 31 || m < 1 || m > 12) return null;
  // [PATCH likvidacija-fe v3] leto 2000-2100 in koledarska veljavnost (31.02. -> null); zrcali backend validacija_vnosa.py
  if (!Number.isFinite(y) || y < LETO_MIN || y > LETO_MAX) return null;
  const _dt = new Date(Date.UTC(y, m - 1, d));
  if (_dt.getUTCFullYear() !== y || _dt.getUTCMonth() !== m - 1 || _dt.getUTCDate() !== d) return null;
  const mm = String(m).padStart(2, '0');
  const dd = String(d).padStart(2, '0');
  return `${y}-${mm}-${dd}`;  // interni format
}
// ===== [PATCH likvidacija-fe v3] logicne kontrole glave -- zrcalo backend services/validacija_vnosa.py =====
// Ista pravila in ista sporocila: datumi veljavni (leto 2000-2100), obdobje MM.LLLL, osnova+DDV=skupaj (0,01),
// vsote DDV evidence samo pri izkljucno domacih vrsticah (DOM_*). Velja ob Shrani / Likvidiraj / Potrdi, NE pri prikazu.
const LETO_MIN = 2000, LETO_MAX = 2100;
const TOLERANCA_ZNESKI = 0.01;
const NAZIVI_DATUMOV: Array<[string, string]> = [
  ['datum_racuna', 'Datum računa'], ['datum_storitve', 'Datum storitve'], ['datum_valute', 'Datum valute'],
  ['datum_knjizenja', 'Datum knjiženja'], ['datum_ddv', 'Datum za DDV'],
];
// strog parser shranjene vrednosti (ISO 'YYYY-MM-DD' ali 'DD.MM.YYYY'), brez pametnega dopolnjevanja
function datumVeljaven(v: any): boolean {
  const s = String(v ?? '').trim();
  let y: number, m: number, d: number;
  let mt = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(s);
  if (mt) { y = +mt[1]; m = +mt[2]; d = +mt[3]; }
  else { mt = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(s); if (!mt) return false; d = +mt[1]; m = +mt[2]; y = +mt[3]; }
  if (y < LETO_MIN || y > LETO_MAX) return false;
  const dt = new Date(Date.UTC(y, m - 1, d));
  return dt.getUTCFullYear() === y && dt.getUTCMonth() === m - 1 && dt.getUTCDate() === d;
}
function obdobjeVeljavno(v: any): boolean {
  const mt = /^(\d{2})\.(\d{4})$/.exec(String(v ?? '').trim());
  if (!mt) return false;
  const m = +mt[1], y = +mt[2];
  return m >= 1 && m <= 12 && y >= LETO_MIN && y <= LETO_MAX;
}
const _numV = (x: any): number => {
  if (typeof x === 'number') return Number.isFinite(x) ? x : 0;
  let t = String(x ?? '').trim().replace(/\s/g, '');
  if (!t) return 0;
  if (t.includes(',')) t = t.replace(/\./g, '').replace(',', '.');
  const n = parseFloat(t); return Number.isFinite(n) ? n : 0;
};
const _r2 = (n: number) => Math.round(n * 100) / 100;
type NapakaGlave = { polje: string; sporocilo: string };
function napakeGlaveIzracun(datumi: any, zneski: any, ddvKnjiga?: any[] | null): NapakaGlave[] {
  const nap: NapakaGlave[] = [];
  const dd = datumi || {};
  for (const [k, naziv] of NAZIVI_DATUMOV) {
    const v = dd[k];
    if (v === undefined || v === null || v === '') continue;
    if (!datumVeljaven(v)) nap.push({ polje: k, sporocilo: `${naziv} '${String(v).includes('-') ? String(v).split('-').reverse().join('.') : v}' ni veljaven datum (DD.MM.LLLL, leto ${LETO_MIN}–${LETO_MAX})` });
  }
  if (dd.obdobje !== undefined && dd.obdobje !== null && dd.obdobje !== '' && !obdobjeVeljavno(dd.obdobje))
    nap.push({ polje: 'obdobje', sporocilo: `Obdobje '${dd.obdobje}' mora biti v obliki MM.LLLL (npr. 06.2026)` });
  const z = zneski || {};
  const osnova = _r2(_numV(z.skupaj_brez_ddv)), ddv = _r2(_numV(z.znesek_ddv)), skupaj = _r2(_numV(z.skupaj_z_ddv));
  const ostalo = _r2(_numV(z.ostalo)); // [PATCH likvidacija-fe v4] neobdavceno (postavke izven DDV)
  const _ostTxt = ostalo ? ` + ostalo (${fmt(ostalo)})` : '';
  if (osnova || ddv || skupaj || ostalo) {
    if (Math.abs((osnova + ddv + ostalo) - skupaj) > TOLERANCA_ZNESKI + 1e-9)
      nap.push({ polje: 'zneski', sporocilo: `Osnova (${fmt(osnova)}) + DDV (${fmt(ddv)})${_ostTxt} = ${fmt(osnova + ddv + ostalo)}, vpisano skupaj pa je ${fmt(skupaj)}` });
    const vrstice = (ddvKnjiga || []).filter((v: any) => v && typeof v === 'object' && !v._avans_link); // [PATCH glava-avans-izvzem-fe v1] storno DDV avansa ni del glave (zrcalo BE)
    if (vrstice.length && vrstice.every((v: any) => String(v.vrsta || '').toUpperCase().startsWith('DOM_'))) {
      const tol = TOLERANCA_ZNESKI * Math.max(1, vrstice.length) + 1e-9;
      const vo = _r2(vrstice.reduce((s: number, v: any) => s + _numV(v.osnova), 0));
      const vd = _r2(vrstice.reduce((s: number, v: any) => s + _numV(v.znesek_ddv), 0));
      if (Math.abs((vo + vd + ostalo) - skupaj) > tol)
        nap.push({ polje: 'ddv_knjiga', sporocilo: `DDV evidenca: vsota osnov (${fmt(vo)}) + vsota DDV (${fmt(vd)})${_ostTxt} = ${fmt(vo + vd + ostalo)}, skupaj z DDV pa je ${fmt(skupaj)}` });
      else if (Math.abs(vo - osnova) > tol || Math.abs(vd - ddv) > tol)
        nap.push({ polje: 'ddv_knjiga', sporocilo: `DDV evidenca (${fmt(vo)} + ${fmt(vd)}) se ne ujema z glavo (${fmt(osnova)} + ${fmt(ddv)})` });
    }
  }
  return nap;
}
// ===== konec [PATCH likvidacija-fe v3] pomozne =====

// Obdobje MM.YYYY iz ISO datuma (YYYY-MM-DD)
function obdobjeIzDatuma(iso: string): string {
  if (!iso || iso.length < 7) return '';
  return iso.slice(5,7) + '.' + iso.slice(0,4);
}
/* [PATCH ddv-obdobje-opomnik-fe v1] pricakovana davcna blokada.
   mesecno = konec meseca, kvartalno = konec kvartala; opozorimo po +dni dneh.
   Vrne 'YYYY-MM' zadnjega obdobja, ki je ze poteklo, ali '' (brez opozorila). */
function _konecObdobjaDdv(leto:number, mesec:number):Date { return new Date(leto, mesec, 0); }
function pricakovanaBlokada(obdobje:string, dni:number, danes:Date):string {
  if(obdobje!=='mesecno' && obdobje!=='kvartalno') return '';
  let l=danes.getFullYear();
  let m=danes.getMonth()+1;
  if(obdobje==='kvartalno') m=Math.ceil(m/3)*3;
  for(let i=0;i<24;i++){
    const konec=_konecObdobjaDdv(l,m);
    const meja=new Date(konec.getFullYear(),konec.getMonth(),konec.getDate()+dni);
    if(meja<=danes) return `${l}-${String(m).padStart(2,'0')}`;
    m-=(obdobje==='kvartalno'?3:1);
    if(m<=0){ m+=12; l-=1; }
  }
  return '';
}
/* [PATCH stevilka-doc-number-prva v1] stevilka dokumenta za prikaz in primerjavo: doc_number (vanj gre vsak
   popravek in iz njega izvoz) ima prednost; ocr.stevilka je surovi zapis OCR in se ob popravku NE spremeni. */
const stDok=(d:any):string=>String(d?.doc_number||d?.ocr?.stevilka||'');
/* [PATCH ddv-blokada v1] blokada = 'YYYY-MM' (zaklenjeno do vkljucno) */
function jeZaklenjeno(iso: string, blokada: string): boolean {
  return !!(blokada && iso && iso.length >= 10 && iso.slice(0,7) <= blokada);
}
function prviOdprtiDan(blokada: string): string {
  const y=+blokada.slice(0,4), m=+blokada.slice(5,7);
  return m===12 ? `${y+1}-01-01` : `${y}-${String(m+1).padStart(2,'0')}-01`;
}
function mmyyyy(b: string): string { return b ? `${b.slice(5,7)}.${b.slice(0,4)}` : ''; }
/* [PATCH dokument-tip v1] rocna zamenjava tipa dokumenta.
   Zamenja SAMO doc_type; zneskov in kontiranja se ne dotakne. Potrjen dokument
   je zaklenjen (backend vrne 409).
   [PATCH izdani-doctype-fe v2] menjava je odslej mozna tudi ZNOTRAJ
   izdane smeri (izdani racun <-> izdani avans <-> izdani dobropis); med
   smerema jo backend se naprej zavrne (locena serija IR<leto>).
   Nabora sta v utils/docSmer.ts, da se pravilo ne podvaja. */
const TIPI_DOK = TIPI_DOK_VSI;
function TipDokumentaBadge({doc, companyId, onSaved, samoBranje}:{doc:any;companyId:string;onSaved:(t:string)=>void;samoBranje?:boolean}) {  // [PATCH stranka-skrij-sifro-interno v1]
  const [edit,setEdit]=useState(false);
  const [val,setVal]=useState('prejeti_racun');
  const [busy,setBusy]=useState(false);
  const tip=String(doc?.doc_type||'prejeti_racun');
  const potrjen=String(doc?.status||'')==='approved';
  useEffect(()=>{ setEdit(false); setVal(String(doc?.doc_type||'prejeti_racun')); },[doc?.id]);
  const shrani=async(nov:string)=>{
    if(nov===tip){setEdit(false);return;}
    setBusy(true);
    try{
      await api.put(`/dokumenti/${companyId}/${doc.id}/tip`,{doc_type:nov});
      toast.success(`Tip dokumenta: ${(TIPI_DOK.find(t=>t.v===nov)?.label)||nov}`);
      onSaved(nov); setEdit(false);
    }catch(e:any){ toast.error(e?.response?.data?.detail||'Napaka pri spremembi tipa'); }
    finally{ setBusy(false); }
  };
  // [PATCH izdani-doctype-fe v2] izdani racun odslej NI vec izvzet: znacka je
  // edina pot, po kateri uporabnik izdani racun spremeni v avans ali dobropis.
  const oznaka=oznakaTipa(tip);
  const barva=barvaTipa(tip);
  if(!edit) return (
    <button onClick={()=>{ if(samoBranje) return; /* [PATCH stranka-skrij-sifro-interno v1] */ if(potrjen){toast.error("Dokument je potrjen. Najprej uporabi 'Prekliči potrditev'.");return;} setVal(tip); setEdit(true); }}
      title={potrjen?'Potrjen dokument — najprej prekliči potrditev':'Spremeni tip dokumenta'}
      className={clsx('text-[10px] px-1.5 py-0.5 rounded-full font-semibold',barva,potrjen?'opacity-60':'hover:ring-1 hover:ring-blue-400')}>
      {oznaka}{samoBranje ? '' : ' ✎'}
    </button>
  );
  return (
    <span className="flex items-center gap-1">
      <select autoFocus value={val} onChange={e=>setVal(e.target.value)} disabled={busy}
        title="Tip dokumenta"
        className="bg-gray-800 text-white text-xs rounded px-1.5 py-0.5 outline-none border border-gray-600">
        {/* [PATCH izdani-doctype-fe v2] ponudi samo vrste ISTE smeri */}
        {tipiZaMenjavo(tip).map(t=>(<option key={t.v} value={t.v}>{t.label}</option>))}
      </select>
      <button onClick={()=>shrani(val)} disabled={busy} className="text-xs px-1.5 py-0.5 rounded bg-blue-600 text-white disabled:opacity-50">Shrani</button>
      <button onClick={()=>setEdit(false)} disabled={busy} className="text-xs px-1.5 py-0.5 rounded text-gray-400 hover:text-gray-300">×</button>
    </span>
  );
}
/* [PATCH gotovinski-predpona v2] oznaka gotovinskega izdanega racuna (vpliva samo na predpono interne st.).
   Spremeniti jo je mogoce samo pred potrditvijo in dokler dokument nima interne st. */
function GotovinskiBadge({doc, companyId, onSaved}:{doc:any;companyId:string;onSaved:(g:boolean)=>void}) {
  const [busy,setBusy]=useState(false);
  const got=!!doc?.gotovinski;
  const zaklenjen=String(doc?.status||'')==='approved'||(doc?.interno_st!==null&&doc?.interno_st!==undefined&&doc?.interno_st!=='');
  const preklopi=async()=>{
    if(zaklenjen||busy) return;
    setBusy(true);
    try{
      await api.put(`/dokumenti/${companyId}/${doc.id}/gotovinski`,{gotovinski:!got});
      toast.success(!got?'Označen kot gotovinski račun':'Oznaka gotovinski odstranjena');
      onSaved(!got);
    }catch(e:any){ toast.error(e?.response?.data?.detail||'Napaka pri spremembi oznake'); }
    finally{ setBusy(false); }
  };
  if(zaklenjen&&!got) return null;
  return (
    <button type="button" onClick={preklopi} disabled={zaklenjen||busy}
      title={zaklenjen?'Gotovinski račun (oznaka je zaklenjena — dokument ima interno številko)':'Gotovinski račun: vpliva samo na predpono interne številke'}
      className={clsx('text-[10px] px-1.5 py-0.5 rounded-full border flex-shrink-0', got?'bg-amber-100 text-amber-800 border-amber-300 dark:bg-amber-900/40 dark:text-amber-300 dark:border-amber-700':'bg-white text-gray-400 border-gray-300 hover:text-gray-600 dark:bg-gray-800 dark:border-gray-700', (zaklenjen||busy)&&'cursor-default opacity-80')}>
      {got?'Gotovinski':'+ gotovinski'}
    </button>
  );
}
function InternoStBadge({doc, companyId, onSaved}:{doc:any;companyId:string;onSaved:(n:number,ser?:string)=>void}) {
  // [PATCH interna-serija-edit v1] urejanje stevilke IN serije (leta)
  // [PATCH interna-ob-potrditvi v1] izdani: serija 'IR<leto>' je skrita
  // (prikaz in vnos) -- vidna je samo stevilka, npr. 260049
  const [edit,setEdit]=useState(false);
  const [val,setVal]=useState('');
  const [ser,setSer]=useState('');
  const potrjen=String(doc?.status||'')==='approved';  // [PATCH zaklep-potrjenega-fe v1]
  useEffect(()=>{ setEdit(false); setVal(String(doc?.interno_st??'')); setSer(String(doc?.interno_st_serija??'')); },[doc?.id]);
  const shrani=async()=>{
    const n=parseInt(val,10);
    if(!Number.isInteger(n)||n<=0){toast.error('Vnesi pozitivno celo število');return;}
    /* [PATCH interne-predpone v1] serija sme nositi predpono iz profila; vzorec zrcali backend (dokumenti.py) */
    if(ser && !/^[A-Za-z0-9ČŠŽčšžĆćĐđ\-_.]{0,10}(IR)?\d{4}$/.test(ser)){toast.error('Serija: leto (2026) ali predpona+leto (A2026)');return;}
    try{
      await api.put(`/dokumenti/${companyId}/${doc.id}/interno-st`,{interno_st:n, interno_st_serija:ser});
      toast.success(`Interna št. = ${n}${(ser && !jeIzdaniTip(doc?.doc_type))?'/'+ser:''}`);
      onSaved(n, ser); setEdit(false);
    }catch(e:any){ toast.error(e?.response?.data?.detail||'Napaka pri shranjevanju'); }
  };
  /* [PATCH izdani-interna-originalna v1] dokument z interno OZNAKO (predpona +
     st. racuna) se ureja prek stevilke racuna, ne prek tega badgea -> brez ✎ */
  if(doc?.interna_oznaka) return (
    <span className="text-base font-bold text-blue-500 font-mono" title="Interna oznaka = predpona + številka računa (nastavitev: originalna). Ureja se prek številke računa.">{internaPrikaz(doc)}</span>
  );
  if(!edit) return (
    <button onClick={()=>{ if(potrjen){toast.error("Dokument je potrjen. Najprej uporabi 'Prekliči potrditev'.");return;} /* [PATCH zaklep-potrjenega-fe v1] */ setVal(String(doc?.interno_st??''));setSer(String(doc?.interno_st_serija??''));setEdit(true);}}
      title={potrjen?'Potrjen dokument — najprej prekliči potrditev':'Uredi interno številko'}
      /* [PATCH interne-predpone v1] prikaz s predpono; vnosni polji nize ostaneta surovi */
      className="text-base font-bold text-blue-500 font-mono hover:text-blue-400">{internaPrikaz(doc)} ✎</button>
  );
  return (
    <span className="flex items-center gap-1">
      <span className="text-blue-500 font-mono font-bold">#</span>
      <input autoFocus type="text" inputMode="numeric" value={val} onChange={e=>setVal(e.target.value.replace(/[^0-9]/g,''))}
        onKeyDown={e=>{if(e.key==='Enter')shrani();if(e.key==='Escape')setEdit(false);}}
        className="w-24 bg-gray-800 text-white text-sm rounded px-1.5 py-0.5 outline-none border border-gray-600 font-mono"/>
      {!jeIzdaniTip(doc?.doc_type) && (<>
      <span className="text-gray-500 font-mono">/</span>
      <input type="text" inputMode="numeric" maxLength={4} value={ser} onChange={e=>setSer(e.target.value.replace(/[^0-9]/g,''))}
        onKeyDown={e=>{if(e.key==='Enter')shrani();if(e.key==='Escape')setEdit(false);}}
        title="Serija (leto)"
        className="w-16 bg-gray-800 text-white text-sm rounded px-1.5 py-0.5 outline-none border border-gray-600 font-mono"/>
      </>)}
      <button onClick={shrani} className="text-xs px-1.5 py-0.5 rounded bg-blue-600 text-white">Shrani</button>
      <button onClick={()=>setEdit(false)} className="text-xs px-1.5 py-0.5 rounded text-gray-400 hover:text-gray-300">×</button>
    </span>
  );
}

// [PATCH fe-bsi-valuta v2] klik-za-urejanje: stevilka z decimalno VEJICO (2 ali 6 dec)
function DevZnesek({value,decimals=2,bold=false,sufiks='',onCommit}:{value:any;decimals?:number;bold?:boolean;sufiks?:string;onCommit:(v:number)=>void}) {
  const [edit,setEdit]=useState(false);
  const [raw,setRaw]=useState('');
  const preklic=useRef(false);
  const prikaz=(v:any)=>{
    const n=Number(v);
    if(v==null||v===''||!Number.isFinite(n))return '\u2014';
    return decimals<=2?fmt(n):String(parseFloat(n.toFixed(decimals))).replace('.',',');
  };
  const zacetni=(v:any)=>{
    const n=Number(v);
    if(v==null||v===''||!Number.isFinite(n))return '';
    return (decimals<=2?n.toFixed(2):String(parseFloat(n.toFixed(decimals)))).replace('.',',');
  };
  const potrdi=()=>{
    if(preklic.current){preklic.current=false;setEdit(false);return;}
    setEdit(false);
    let t=String(raw||'').trim().replace(/\s/g,'');
    if(t.includes(','))t=t.replace(/\./g,'').replace(',','.');
    const n=parseFloat(t);
    if(Number.isFinite(n)&&n>0)onCommit(n);
  };
  if(!edit)return(
    <button type="button" title="Klikni za urejanje" onClick={()=>{preklic.current=false;setRaw(zacetni(value));setEdit(true);}}
      className={clsx('font-mono cursor-pointer hover:text-blue-400 border-b border-dotted border-gray-500',bold&&'font-bold')}>
      {prikaz(value)}{sufiks?` ${sufiks}`:''}
    </button>
  );
  return(
    <input autoFocus type="text" inputMode="decimal" value={raw}
      onChange={e=>setRaw(e.target.value)}
      onKeyDown={e=>{if(e.key==='Enter')potrdi();if(e.key==='Escape'){preklic.current=true;setEdit(false);}}}
      onBlur={potrdi}
      className="w-28 bg-gray-800 border border-gray-700 rounded px-2 py-1 text-sm text-white text-right font-mono"/>
  );
}
// [PATCH fe-bsi-valuta v3] klik-za-urejanje: datum s pametnim tipkanjem
// (parseDatumVnos kot pri ostalih datumih: 3006 -> 30.06.2026, 180626 -> 18.06.2026)
function DevDatum({value,onCommit}:{value:any;onCommit:(v:string)=>void}) {
  const [edit,setEdit]=useState(false);
  const [raw,setRaw]=useState('');
  const preklic=useRef(false);
  const potrdi=()=>{
    if(preklic.current){preklic.current=false;setEdit(false);return;}
    setEdit(false);
    const t=String(raw||'').trim();
    if(!t)return;
    const iso=parseDatumVnos(t);
    if(iso)onCommit(iso);
    else toast.error('Neveljaven datum — npr. 3006 ali 30.06.2026');
  };
  if(!edit)return(
    <button type="button" title="Klikni za urejanje" onClick={()=>{preklic.current=false;setRaw(value?String(value).split('-').reverse().join('.'):'');setEdit(true);}}
      className="font-mono cursor-pointer hover:text-blue-400 border-b border-dotted border-gray-500">
      {fmtDatum(String(value||''))}
    </button>
  );
  return(
    <input autoFocus type="text" value={raw} placeholder="DD.MM.YYYY"
      onChange={e=>setRaw(e.target.value)}
      onKeyDown={e=>{if(e.key==='Enter')potrdi();if(e.key==='Escape'){preklic.current=true;setEdit(false);}}}
      onBlur={potrdi}
      className="w-28 bg-gray-800 border border-gray-700 rounded px-2 py-1 text-sm text-white text-right font-mono"/>
  );
}

function ObdobjeInput({label,value,onChange,tabIndex,napaka}:{label:string;value:string;onChange:(v:string)=>void;tabIndex?:number;napaka?:string}) {
  // [PATCH likvidacija-fe v3] napaka -> rdeca obroba + tooltip (MM.LLLL)
  return (
    <div className="flex flex-col gap-1">
      <label className="text-xs text-gray-400">{label}</label>
      <input tabIndex={tabIndex} type="text" value={value} placeholder="MM.YYYY" title={napaka||undefined}
        onChange={e=>onChange(e.target.value)}
        className={`bg-gray-800 border rounded px-2 py-1 text-sm text-white ${napaka ? 'border-red-500 ring-1 ring-red-500/60' : 'border-gray-700'}`} />
    </div>
  );
}
function DatumInput({label,value,onChange,tabIndex,id,napaka}:{label:string;value:string;onChange:(v:string)=>void;tabIndex?:number;id?:string;napaka?:string}) {
  const displayVal = value ? value.split('-').reverse().join('.') : '';
  const [lokalni, setLokalni] = useState<string | null>(null);
  // prikazana vrednost: med tipkanjem lokalni, sicer iz value
  const prikaz = lokalni !== null ? lokalni : displayVal;
  const potrdi = () => {
    if (lokalni === null) return;
    if (lokalni.trim() === '') { onChange(''); setLokalni(null); return; }
    const parsano = parseDatumVnos(lokalni);
    if (parsano) onChange(parsano);
    else toast.error(`${label}: '${lokalni}' ni veljaven datum (DD.MM.LLLL, leto ${LETO_MIN}–${LETO_MAX})`); // [PATCH likvidacija-fe v3] prej tiho zavrzeno
    setLokalni(null);  // sprosti -> prikaz spet iz value
  };
  return (
    <div className="flex flex-col gap-1">
      <label className="text-xs text-gray-400">{label}</label>
      <input id={id} tabIndex={tabIndex} type="text" value={prikaz} title={napaka||undefined}
        onChange={e=>setLokalni(e.target.value)}
        onBlur={potrdi}
        onKeyDown={e=>{ if(e.key==='Enter'){ (e.target as HTMLInputElement).blur(); } if(e.key==='Escape'){ setLokalni(null); } /* [PATCH likvidacija-fe v3] Esc zavrze natipkano */ }}
        placeholder="DD.MM.YYYY"
        className={`px-2 py-1.5 text-xs bg-gray-800 border rounded-lg text-white outline-none focus:border-blue-500 ${(!value || napaka) ? "border-red-500" : "border-gray-700"} ${napaka ? 'ring-1 ring-red-500/60' : ''}`}/>
    </div>
  );
}

function KontoSelector({value, companyId, onChange}:{value:string;companyId:string;onChange:(k:string,n:string)=>void}) {
  const [open,setOpen]=useState(false);
  const [showModal,setShowModal]=useState(false);
  const [q,setQ]=useState('');
  const [konti,setKonti]=useState<any[]>([]);
  const ref=useRef<HTMLDivElement>(null);

  useEffect(()=>{
    if(companyId){
      api.get(`/sifranti/kontni-plan/${companyId}`).then(r=>setKonti(r.data)).catch(e=>console.error(e));
    }
  },[companyId]);

  const filtered = useMemo(()=>{
    // [PATCH konto-iskanje-naziv v1] Iscemo SAMO po analiticnih kontih (>=4
    // mesta). Sinteticni konti (npr. "75") ostanejo izven predlogov -- knjizba
    // nanje bi bila racunovodska napaka, ki gre naravnost v VOD/KN-21.
    const analiticki = konti.filter((k:any)=>String(k.code).length>=4);
    // Stevilke -> sifra, crke -> naziv (lib/kontoIskanje). Prazna poizvedba
    // ohrani dosedanjo semantiko: prvih 50 analiticnih kontov.
    if(q.trim()) return iskanjeKontov(analiticki, q, 50);
    return analiticki.slice(0,50);
  },[q,konti]);

  useEffect(()=>{
    const h=(e:MouseEvent)=>{if(ref.current&&!ref.current.contains(e.target as Node)){setOpen(false);setQ('');}};
    document.addEventListener('mousedown',h);
    return ()=>document.removeEventListener('mousedown',h);
  },[]);

  return (
    <div className="relative inline-block" ref={ref}>
      <button onClick={()=>setOpen(!open)}
        className="flex items-center gap-1 px-2 py-1 rounded bg-blue-600/20 hover:bg-blue-600/40 border border-blue-500/40 text-blue-400 font-mono text-xs font-bold transition">
        {value||'???'}<ChevronDown className="w-3 h-3"/>
      </button>
      {open&&(
        <div className="absolute left-0 top-8 w-80 bg-gray-900 border border-gray-700 rounded-xl shadow-2xl z-[9999]">
          <div className="p-2 border-b border-gray-800">
            <input autoFocus value={q} onChange={e=>setQ(e.target.value)}
              className="bg-gray-800 text-xs text-white outline-none w-full px-2 py-1 rounded" placeholder="Išči po številki ali nazivu..."/>{/* [PATCH konto-iskanje-naziv v1] */}
          </div>
          <div className="max-h-56 overflow-y-auto">
            {/* [PATCH konto-iskanje-naziv v1] prazen rezultat je pri iskanju po nazivu realen; isto sporocilo kot v KontoSelector */}
            {filtered.length===0 && <div className="px-3 py-4 text-xs text-gray-500 text-center">Ni rezultatov</div>}
            {filtered.map((k:any)=>(
              <button key={k.code} onClick={()=>{onChange(k.code,k.name);setOpen(false);setQ('');}}
                className="w-full text-left px-3 py-2 hover:bg-gray-800 transition flex items-center gap-3">
                <span className="font-mono text-xs text-blue-400 w-16 flex-shrink-0">{k.code}</span>
                <span className="text-xs text-gray-300 truncate">{k.name}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}


// [PATCH rocni-vnos-fe v3] Inline iskanje partnerja (ob stevilki racuna).
// Tipkas naziv/davcno; ↑↓ + Enter izbere; Enter brez zadetkov / ＋ odpre
// obrazec za novega dobavitelja. Seznam se nalozi lenobno ob prvem fokusu.
function PartnerIsci({ companyId, vrednost, onIzberi, onNov, id, tabIndex }: {
  companyId: string; vrednost: string;
  onIzberi: (p: any) => void; onNov: () => void;
  id?: string; tabIndex?: number;
}) {
  const [q, setQ] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const [seznam, setSeznam] = useState<any[]>([]); // [PATCH partner-isci-server v1] rezultat streznika (naziv/davcna/sifra), ne lokalni seznam 5000
  const [aktiven, setAktiven] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const zapSt = useRef(0); // [PATCH partner-isci-server v1] pozen odgovor ne sme prepisati novejsega
  const nalozi = () => { /* [PATCH partner-isci-server v1] seznam se ne nalaga vec vnaprej; iskanje tece v useEffect na q */ };
  const prikaz = q !== null ? q : (vrednost || '');
  useEffect(() => { // [PATCH partner-isci-server v1] prazen niz -> prvih 5 (kot prej), sicer streznisko iskanje z zakasnitvijo
    if (q === null || !companyId) return;
    const s = q.trim();
    const moj = ++zapSt.current;
    const t = setTimeout(() => {
      api.get(`/sifranti/partnerji/${companyId}`, { params: s ? { q: s, limit: 20, neaktivni: 1 /* [PATCH partner-isci-neaktivni v1] */ } : { limit: 5 } })
        .then(r => { if (moj === zapSt.current) setSeznam(r.data || []); })
        .catch(() => {});
    }, s ? 250 : 0);
    return () => clearTimeout(t);
  }, [q, companyId]);
  const filtered = useMemo(() => seznam.slice(0, 5), [seznam]); // [PATCH partner-isci-server v1] filtrira streznik; prikaz ostane 5 + Nov partner
  useEffect(() => { setAktiven(0); }, [q]);
  useEffect(() => {
    const h = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) { setOpen(false); setQ(null); } };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);
  const izberi = (p: any) => { if (p?.is_active === false) { toast.error(`Partner ${p.vasco_code || ''} ${p.name || ''} je neaktiven (zaprt v Opalu/Vascu) — izberi drugega.`); return; } setQ(null); setOpen(false); onIzberi(p); }; // [PATCH partner-isci-neaktivni v1]
  return (
    <div className="relative" ref={ref}>
      <input id={id} tabIndex={tabIndex} value={prikaz} autoComplete="off"
        onFocus={() => { nalozi(); setQ(vrednost || ''); setOpen(true); }}
        onChange={e => { setQ(e.target.value); setOpen(true); }}
        onKeyDown={e => {
          if (e.key === 'ArrowDown') { e.preventDefault(); setAktiven(a => Math.min(a + 1, Math.max(filtered.length - 1, 0))); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); setAktiven(a => Math.max(a - 1, 0)); }
          else if (e.key === 'Enter') { e.preventDefault(); if (filtered.length) izberi(filtered[aktiven] || filtered[0]); else if ((q || '').trim()) onNov(); }
          else if (e.key === 'Escape') { setOpen(false); setQ(null); }
        }}
        onBlur={() => setTimeout(() => { setOpen(false); setQ(null); }, 150)}
        placeholder="Partner (naziv / davčna / šifra)"
        className="w-64 px-2 py-1 rounded border border-blue-400 bg-white dark:bg-gray-800 text-gray-900 dark:text-white text-sm outline-none focus:ring-1 focus:ring-blue-400"/>
      {open && ( // [PATCH_PARTNER_DROPDOWN_V1] odprto ze ob kliku
        <div className="absolute left-0 top-9 w-96 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl z-[9999] max-h-64 overflow-y-auto">
          {filtered.map((p: any, ix: number) => (
            <button key={p.id} onMouseDown={() => izberi(p)} title={p.is_active === false ? 'Partner je neaktiven (zaprt v Opalu/Vascu) — ni ga mogoče izbrati' : undefined}
              className={clsx('w-full text-left px-3 py-2 flex items-center gap-2', p.is_active === false ? 'opacity-50 cursor-not-allowed' : ix === aktiven ? 'bg-blue-50 dark:bg-gray-800' : 'hover:bg-gray-50 dark:hover:bg-gray-800')}>
              <span className="text-sm text-gray-900 dark:text-white flex-1 truncate">{p.name}</span>
              {p.tax_number && <span className="text-xs text-gray-400 font-mono">{p.tax_number}</span>}
              {p.vasco_code && <span className="text-[10px] px-1 rounded bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300 font-mono">{p.vasco_code}</span>}
              {/* [PATCH partner-isci-neaktivni v1] */}{p.is_active === false && <span className="text-[10px] px-1 rounded bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300 font-semibold">NEAKTIVEN</span>}
            </button>
          ))}
          {filtered.length === 0 && (
            <div className="px-3 py-2 text-xs text-gray-400">Ni zadetkov — Enter ali ＋ za novega</div>
          )}
          <button onMouseDown={() => { setOpen(false); setQ(null); onNov(); }}
            className="w-full text-left px-3 py-2 text-xs text-blue-500 hover:bg-gray-50 dark:hover:bg-gray-800 border-t border-gray-100 dark:border-gray-800">＋ Nov partner</button>
        </div>
      )}
    </div>
  );
}

export function DokumentiPage() {
  const { selectedCompany } = useAuthStore();
  const [dokumenti,setDokumenti]=useState<any[]>([]);
  const [uvozZap,setUvozZap]=useState<Record<string,{ob:string,zap:number}>>({}); /* [PATCH uvoz-zaporedje v1] document_id -> {cas sopa, zaporedje v PDF} */
  const [iskanje,setIskanje]=useState('');
  const [uploading,setUploading]=useState(false);
  const [uploadProgress,setUploadProgress]=useState(0);
  const [selected,setSelected]=useState<any>(null);
  const [kontiranje,setKontiranje]=useState<any>(null);
  const [stevilkaEdit,setStevilkaEdit]=useState<string>(''); // SEJA E: urejanje stevilke racuna
  useEffect(()=>{ if(selected?._rocni) return; setStevilkaEdit(''); setEditMode(false); },[selected?.id]); // SEJA E: reset + izhod iz urejanja ob menjavi dokumenta; [PATCH rocni-vnos-fe v1] rocni preskoci
  const [kontiPlan,setKontiPlan]=useState<any[]>([]);
  const [placnikProfil,setPlacnikProfil]=useState<any>({});      // [PATCH placnik-saldakonto-pogoj v1] profil "Racun = placan", prejeti
  const [placnikProfilIzd,setPlacnikProfilIzd]=useState<any>({});// [PATCH placnik-saldakonto-pogoj v1] isto za izdane (pri FIZIANU prazen)
  const [postavkeOdprte,setPostavkeOdprte]=useState(false);
  const [postavkaOpisi,setPostavkaOpisi]=useState<any|null>(null); // [PATCH ir4a-ui-postavke v1] {konto,kategorija}
  const vloga = useAuthStore((s: any) => s.role);
  const jeStranka = vloga === 'stranka';
  const [opombaText, setOpombaText] = useState('');
  const shraniOpombo = async () => {
    if (!selected) return;
    try {
      await api.put(`/stranka/${companyId}/racuni/${selected.id}`, { opomba: opombaText });
      toast.success('Opomba shranjena');
      setDokumenti((ds: any) => ds.map((d: any) => d.id === selected.id ? { ...d, opomba: opombaText } : d));
    } catch (e: any) { toast.error(e?.response?.data?.detail || 'Napaka pri shranjevanju'); }
  };
  const [sklicData,setSklicData]=useState({model:'SI',modelSt:'00',sklicSt:''});
  const [datumi,setDatumi]=useState({datum_knjizenja:'',datum_ddv:'',datum_storitve:'',datum_racuna:'',datum_valute:'',obdobje:''});
  const [ddvBlokada,setDdvBlokada]=useState(''); /* [PATCH ddv-blokada v1] 'YYYY-MM' ali '' */
  const [letoZaklenjeno,setLetoZaklenjeno]=useState(0); /* [PATCH zaklep-leta-fe v1] leto_zaklenjeno_do iz GET ddv-blokada (0 = izklop) */
  const [companyId,setCompanyId]=useState('');
  /* [PATCH ddv-blokada v1a] useEffect pod deklaracijo companyId (TS2448) */
  useEffect(()=>{ setDdvBlokada(''); setLetoZaklenjeno(0); if(!companyId) return; api.get(`/companies/${companyId}/ddv-blokada`).then(r=>{ setDdvBlokada(r.data?.ddv_blokada_do||''); setLetoZaklenjeno(Number(r.data?.leto_zaklenjeno_do)||0); /* [PATCH zaklep-leta-fe v1] */ }).catch(()=>{}); },[companyId]);
  /* [PATCH ddv-obdobje-opomnik-fe v1] opomnik na zaostalo davcno blokado */
  const [opomnikBlok,setOpomnikBlok]=useState<any|null>(null);
  const [opomnikVnos,setOpomnikVnos]=useState('');
  const [opomnikBusy,setOpomnikBusy]=useState(false);
  useEffect(()=>{ setOpomnikBlok(null); if(!companyId) return;
    api.get(`/companies/${companyId}/ddv-blokada`).then(r=>{
      const obd=String(r.data?.ddv_obdobje||'brez');
      if(obd==='brez'||r.data?.ddv_opomnik===false) return;
      const dni=Number.isFinite(Number(r.data?.ddv_opomnik_dni))?Number(r.data.ddv_opomnik_dni):10;
      const bl=String(r.data?.ddv_blokada_do||'');
      const prc=pricakovanaBlokada(obd,dni,new Date());
      if(!prc||(bl&&bl>=prc)) return;
      const kljuc=`aicount_ddv_opomnik_${companyId}_${prc}`;
      try{ if(sessionStorage.getItem(kljuc)==='1') return; sessionStorage.setItem(kljuc,'1'); }catch{}
      setOpomnikVnos(`${prc.slice(5,7)}.${prc.slice(0,4)}`);
      api.get(`/companies/${companyId}/ddv-blokada/nepotrjeni?obdobje=${prc}`)
        .then(n=>setOpomnikBlok({stara:bl,nova:prc,...(n.data||{})}))
        .catch(()=>setOpomnikBlok({stara:bl,nova:prc}));
    }).catch(()=>{});
  },[companyId]);
  const prestaviBlokado=async()=>{
    const m=(opomnikVnos||'').trim().match(/^(0[1-9]|1[0-2])\.(\d{4})$/);
    if(!m){ toast.error('Vnesi obdobje kot MM.YYYY, npr. 06.2026.'); return; }
    const kanon=`${m[2]}-${m[1]}`;
    setOpomnikBusy(true);
    try{
      await api.put(`/companies/${companyId}/ddv-blokada`,{ddv_blokada_do:kanon,vir:'opomnik'});
      setDdvBlokada(kanon);
      setOpomnikBlok(null);
      toast.success(`Davčna blokada nastavljena do vključno ${m[1]}.${m[2]}`);
    }catch(e:any){ toast.error(e?.response?.data?.detail||'Shranjevanje ni uspelo.'); }
    finally{ setOpomnikBusy(false); }
  };
  const [izvozLeto,setIzvozLeto]=useState(new Date().getFullYear());
  const [izvozMesec,setIzvozMesec]=useState(new Date().getMonth()+1);
  const [ddvKonti,setDdvKonti]=useState<any>({});
  const [izvozProgram,setIzvozProgram]=useState('vasco');
  const [showUpload,setShowUpload]=useState(false);
  const [showSop,setShowSop]=useState(false);
  const [sopPretekli,setSopPretekli]=useState<any>(null); /* [PATCH sop-kos-pdf v1] pretekli sop, odprt iz Nedavnih uvozov */
  const [sopFilter,setSopFilter]=useState<string>(''); /* [PATCH sop-kos-pdf v1] '' | koncano | preskocen | napaka */
  // [PATCH vod-uvoz-fe v1] uvoz izdanih računov iz XML (VOD)
  const [vodOpen,setVodOpen]=useState(false);
  const [vodBusy,setVodBusy]=useState(false);
  const [vodFile,setVodFile]=useState<File|null>(null);
  const [vodPredogled,setVodPredogled]=useState<any>(null);
  const [vodPorocilo,setVodPorocilo]=useState<any>(null);
  const [vodUstvari,setVodUstvari]=useState(true);
  const [vodVse,setVodVse]=useState(false);
  /* [PATCH sop-napredek-fe v1] lokalno stanje sopBatch je odstranjeno.
     Edini vir resnice je uploadStore.sopPoPodjetju[companyId] — deklaracija
     stoji nizje, pod blokom obvestil, ker je companyId sele tam dokazano
     definiran (deps array ucinka "videno" ga uporablja). */
  const [sopBusy,setSopBusy]=useState(false);
  // ===== [PATCH razveljavi-uvoz-fe v1] razveljavitev uvoza sopa =====
  const [razvOpen,setRazvOpen]=useState(false);
  const [razvInfo,setRazvInfo]=useState<any>(null);
  const [razvBusy,setRazvBusy]=useState(false);
  const [blokData,setBlokData]=useState<any>(null);   // 409: {preneseni:[], povezave_placila:[]}
  const [blokObseg,setBlokObseg]=useState<string>('zadnji_uvoz');
  // ===== [PATCH nedavni-uvozi-fe v1] seznam nedavnih sop uvozov =====
  const [razvBatchId,setRazvBatchId]=useState<string>('');
  const [nedavniOpen,setNedavniOpen]=useState(false);
  const [nedavni,setNedavni]=useState<any[]>([]);
  const [nedavniBusy,setNedavniBusy]=useState(false);
  // ===== konec [PATCH nedavni-uvozi-fe v1] =====
  // ===== [PATCH prestevilci-sop-fe v1] interno preštevilčenje šopa =====
  const [prestOpen,setPrestOpen]=useState(false);
  const [prestBatchId,setPrestBatchId]=useState<string>('');
  const [prestInfo,setPrestInfo]=useState<any>(null);
  const [prestVnos,setPrestVnos]=useState<Record<string,string>>({});
  const [prestBusy,setPrestBusy]=useState(false);
  const [prestNapake,setPrestNapake]=useState<any>(null);
  // ===== konec [PATCH prestevilci-sop-fe v1] state =====
  // ===== konec [PATCH razveljavi-uvoz-fe v1] =====
  const [epBusy,setEpBusy]=useState(false); // [PATCH bizbox-prevzem v1]
  const [epModal,setEpModal]=useState(false); // [PATCH bizbox-prevzem v2]
  const [epUser,setEpUser]=useState('');
  const [epPass,setEpPass]=useState('');
  const [epOkolje,setEpOkolje]=useState('demo'); // [PATCH bizbox-prevzem v5]
  const [epNastavljeno,setEpNastavljeno]=useState(false);
  const [showSekvenca,setShowSekvenca]=useState(false);
  const [sekvenca,setSekvenca]=useState({next_number:1,prefix:''});
  // ===== [PATCH obvestila-dokumenti v1] "videno" + ?tip= (obvestila zvonec) =====
  const [searchParams,setSearchParams]=useSearchParams(); // [PATCH izdaja-dokumenti v1]
  const obvVnosi=useObvestilaStore((s:any)=>s.vnosi);
  const obvOznaciVideno=useObvestilaStore((s:any)=>s.oznaciVideno);
  const OBV_ZAVIHKI=['prejeti_racun','izdani_racun','bancni_izpisek','blagajna'];
  /* lazy init iz ?tip= — ob skoku iz zvonca se odpre pravi zavihek BREZ vmesnega
     prikaza prejetih (in brez prezgodnjega "videno" za prejete) */
  const [aktivniTip,setAktivniTip]=useState(()=>{ const t=searchParams.get('tip'); return (t&&OBV_ZAVIHKI.indexOf(t)>=0)?t:(smerAplikacije(preberiAplikacijo())||'prejeti_racun'); }); /* [PATCH aplikacije-fe v3] privzeto smer aplikacije */
  /* skok iz zvonca, ko smo ZE na /dokumenti (zvonec doda &ts= za spremembo params) */
  useEffect(()=>{ const t=searchParams.get('tip'); if(t&&OBV_ZAVIHKI.indexOf(t)>=0&&t!==aktivniTip) setAktivniTip(t);
  },[searchParams]);
  useEffect(()=>{ /* [PATCH aplikacije-fe v3] varovalka: racun nasprotne smeri ni dosegljiv v tej aplikaciji (Prodaja=izdani, Nabava=prejeti) */
    const s=smerAplikacije(preberiAplikacijo()); const t=searchParams.get('tip');
    if(s&&(t==='prejeti_racun'||t==='izdani_racun')&&t!==s){ const sp=new URLSearchParams(searchParams); sp.set('tip',s); sp.delete('pogled'); setSearchParams(sp,{replace:true}); return; }
    /* [PATCH prodajni-tok v9] stranka v Prodaji nima racunovodske obdelave: vsili pogled=rocni (register) */
    else if(s==='izdani_racun'&&useAuthStore.getState().role==='stranka'&&['rocni','ponudbe','narocila','dobavnice','cmr'].indexOf(searchParams.get('pogled')||'')<0){/* [PATCH izdaja-prodajni-dok-ui v1] */ /* [PATCH dobavnica-cmr-fe v1] */ const sp=new URLSearchParams(searchParams); sp.set('tip','izdani_racun'); sp.set('pogled','rocni'); setSearchParams(sp,{replace:true}); }
  },[searchParams]);
  // [PATCH izdaja-dokumenti v1] pogled znotraj Izdanih: 'prenos' (OCR/uvoz -> Opal/Vasco) ali 'rocni' (rocni vnos, prej stran /izdaja); iz URL ?pogled=
  const izdajaModul=useIzdajaModul((selectedCompany as any)?.id||'');
  const _pg=searchParams.get('pogled'); /* [PATCH izdaja-prodajni-dok-ui v1] pogledi: prenos | rocni | ponudbe | narocila */
  const pogledIzdani=(aktivniTip==='izdani_racun'&&izdajaModul===true&&(_pg==='rocni'||_pg==='ponudbe'||_pg==='narocila'||_pg==='dobavnice'||_pg==='cmr'))?_pg:'prenos'; /* [PATCH dobavnica-cmr-fe v1] */
  /* obisk (podjetje, zavihek) = videno */
  useEffect(()=>{ if(!companyId) return; obvOznaciVideno(companyId,aktivniTip);
  },[companyId,aktivniTip]);
  /* dokument konca obdelavo, medtem ko smo ze na tej strani -> samodejno videno + osvezi seznam */
  useEffect(()=>{ if(!companyId) return;
    const z=obvVnosi.find((v:any)=>v.company_id===companyId&&v.zavihek===aktivniTip);
    if(!z) return;
    obvOznaciVideno(companyId,aktivniTip);
    naloziDokumente(companyId,aktivniTip,iskanje);
  },[obvVnosi]);
  // ===== konec [PATCH obvestila-dokumenti v1] =====
  /* ===== [PATCH sop-napredek-fe v1] napredek SOPA iz uploadStore =====
     Polling ne zivi vec tukaj, ampak v uploadStore.zacniSop — zato tece
     naprej, ko uporabnik zapre okno ali zapusti stran, in ga po osvezitvi
     strani (F5) prevzame obnoviSop v UvozIndikator. */
  const sopStanje=useUploadStore((s:any)=>companyId?s.sopPoPodjetju[companyId]:undefined);
  const sopBatch=sopPretekli||(sopStanje&&sopStanje.podatki)||null; /* [PATCH sop-kos-pdf v1] */
  useEffect(()=>{ if(!showSop){ setSopPretekli(null); setSopFilter(''); } },[showSop]); /* [PATCH sop-kos-pdf v1] */
  const odpriKosPdf=async(bid:string,zap:number)=>{ /* [PATCH sop-kos-pdf v1] PDF kosa v novem zavihku */ try{const r=await api.get(`/dokumenti/${companyId}/batch/${bid}/kos/${zap}/pdf-token`);window.open(`${process.env.REACT_APP_API_URL||'/api/v1'}/dokumenti/${companyId}/batch/${bid}/kos/${zap}/pdf-public?token=${r.data.token}`,'_blank');}catch{toast.error('PDF kosa ni na voljo');} };
  const [vseenoBusy,setVseenoBusy]=useState<number|null>(null); /* [PATCH vseeno-dvojnik v1] */
  const vseenoUvozi=async(bid:string,zap:number)=>{ /* [PATCH vseeno-dvojnik v1] uvoz dvojnika na zahtevo -> '<st> DVOJNIK' */ if(!window.confirm('Račun s to številko je za tega dobavitelja že v bazi. Vseeno uvozim kot DVOJNIK?'))return; setVseenoBusy(zap); try{const r=await api.post(`/dokumenti/${companyId}/batch/${bid}/kos/${zap}/vseeno`);const b=await api.get(`/dokumenti/${companyId}/batch/${bid}`);setSopPretekli(b.data);naloziDokumente(companyId,aktivniTip);toast.success(`Uvožen kot ${r.data?.doc_number||'DVOJNIK'}`);}catch(e:any){const d=e?.response?.data?.detail;toast.error(typeof d==='string'?d:(d?.sporocilo||'Uvoz ni uspel'));}finally{setVseenoBusy(null);} };
  const odpriSopIzNedavnih=async(bid:string)=>{ /* [PATCH sop-kos-pdf v1] pretekli sop v oknu Uvoz s filtrom preskocen */ try{const r=await api.get(`/dokumenti/${companyId}/batch/${bid}`);setSopPretekli(r.data);setSopFilter('preskocen');setNedavniOpen(false);setShowSop(true);}catch{toast.error('Šopa ni mogoče naložiti');} };
  /* lupina: obstojeca klicna mesta setSopBatch(…) (= pocisti) ostanejo
     nespremenjena; vrednost razen null se ne postavlja od nikoder vec. */
  const setSopBatch=(_v:any)=>{ if(_v===null&&companyId) useUploadStore.getState().pozabiSop(companyId); };
  const sopZakljucenRef=useRef<number>(0);
  /* zakljucek sopa: osvezi seznam in — ce je okno zaprto — pokazi zakljucni
     toast. To je logika, ki je bila prej v pollu (uploadSop/sopPoll). */
  useEffect(()=>{
    const z=(sopStanje&&sopStanje.zakljucenOb)||0;
    if(!z||z===sopZakljucenRef.current) return;
    sopZakljucenRef.current=z;
    if(!companyId) return;
    naloziDokumente(companyId,aktivniTip);
    if(!showSop){
      const d:any=(sopStanje&&sopStanje.podatki)||{};
      const _deli=[`${d.st_koncano||0} uvoženih`];
      if(d.st_preskoceno)_deli.push(`${d.st_preskoceno} preskočenih`);
      if(d.st_napak)_deli.push(`${d.st_napak} napak`);
      (d.st_napak?toast.error:toast.success)(`Uvoz končan: ${_deli.join(', ')}`,{duration:8000});
    }
  },[sopStanje&&sopStanje.zakljucenOb]);  /* [PATCH sop-napredek-fe v1a] namenoma samo zakljucenOb: ucinek sme steci izkljucno ob prehodu sopa v koncno stanje */
  /* skok s cipa zgoraj levo od zvonca: /dokumenti?sop=<batchId> odpre okno */
  useEffect(()=>{ if(searchParams.get('sop')) setShowSop(true); },[searchParams]);
  // ===== konec [PATCH sop-napredek-fe v1] =====
  const [izbranoLeto,setIzbranoLeto]=useState(String(new Date().getFullYear()));
  const [showLeta,setShowLeta]=useState(false);
  const [nalagam,setNalagam]=useState(false);
  // [PATCH seznam-limit-fe v1] rastoci limit seznama.
  // Ref, ker naloziDokumente zivi v vec closurih (useEffect :777 in 11 klicnih mest)
  // in bi state tam lahko obtical na stari vrednosti. State je le za ponovni izris gumba.
  // [PATCH seznam-1000-isci-vse v1] korak seznama 100 -> 1000.
  // Izmerjeno 25.08.2026: najvecja letnica pri katerikoli stranki ima 681
  // dokumentov (FIZIAN), zato se pri 1000 nalozi vse. Odgovor zraste z
  // ~0,2 MB na ~1,5 MB (kontiranje 1,2 kB + ocr 1,0 kB na dokument;
  // raw_text je iz seznama ze odstranjen). Strop 5000 v dokumenti.py ostane.
  const LIMIT_KORAK_SEZ=1000;
  // [PATCH seznam-1000-isci-vse v1] med iskanjem letni filter seznama NE velja: iskanje
  // tece na strezniku cez vse dokumente, zadetek iz druge letnice pa je
  // doslej prisel in ga je letni filter skril.
  const _isceSe=()=>!!(iskanje&&iskanje.trim());
  const limitSezRef=useRef<number>(LIMIT_KORAK_SEZ);
  const [limitSez,setLimitSez]=useState<number>(LIMIT_KORAK_SEZ);
  // ===== [PATCH seznam-stanje-filter-fe v1] filter stanja seznama =====
  // 'vsi' | 'neprenesen' (exported_at IS NULL) | 'nepotrjen' (status <> approved).
  // Ref iz istega razloga kot limitSezRef: naloziDokumente zivi v vec closurih
  // in bi state tam lahko obtical na stari vrednosti. State je le za izris gumbov.
  // Izbira prezivi preklop zavihka; ob osvezitvi strani se vrne na 'vsi' (namerno).
  type StanjeFilter='vsi'|'neprenesen'|'nepotrjen'|'nelikvidiran'; // [PATCH likvidacija-fe v1] + nelikvidiran
  const [stanjeFilter,setStanjeFilter]=useState<StanjeFilter>(_stanjeSticky);  // [PATCH seznam-stanje-filter-fe v2]
  const stanjeRef=useRef<StanjeFilter>(_stanjeSticky);  // [PATCH seznam-stanje-filter-fe v2] ref se inicializira PRED effectom -> prvo nalaganje ze filtrirano
  const stanjeQS=()=>(stanjeRef.current&&stanjeRef.current!=='vsi')?`&stanje=${stanjeRef.current}`:'';
const [contentH,setContentH]=useState(0); useEffect(()=>{ const f=()=>{ const tp=containerRef.current?.getBoundingClientRect().top||0; setContentH(Math.max(300, window.innerHeight - tp - 8)); }; f(); const tm=setTimeout(f,100); window.addEventListener("resize",f); return ()=>{ clearTimeout(tm); window.removeEventListener("resize",f); }; },[]);
  const [editMode,setEditMode]=useState(false);
  const [rawZneski,setRawZneski]=useState<Record<string,string>>({});
  // ===== [PATCH rocni-vnos-fe v1] rocni vnos + tab-veriga =====
  const [trrEdit,setTrrEdit]=useState('');
  const [izIzdaje,setIzIzdaje]=useState<any>(null); /* [PATCH prodajni-tok v3] {poslovni_dok_id, stevilka, tip, status} | null — dokument je nastal z izdajo v Prodaji */
  const [partnerIbani,setPartnerIbani]=useState<string[]>([]);
  const [opisVnos,setOpisVnos]=useState('');
  const [skupajRocno,setSkupajRocno]=useState(false);
  const [rocniFile,setRocniFile]=useState<File|null>(null);
  const rocniFileRef=useRef<HTMLInputElement>(null);
  const [rocniPreviewUrl,setRocniPreviewUrl]=useState<string>(''); // [PATCH rocni-vnos-fe v2]
  useEffect(()=>{
    if(rocniFile){ const u=URL.createObjectURL(rocniFile); setRocniPreviewUrl(u); return ()=>URL.revokeObjectURL(u); }
    setRocniPreviewUrl(''); return undefined;
  },[rocniFile]);
  const [partnerModalNacin,setPartnerModalNacin]=useState<'obstojeci'|'nov'>('obstojeci'); // [PATCH rocni-vnos-fe v3]
  const [devValuta,setDevValuta]=useState(''); const [devZnesek,setDevZnesek]=useState(''); const [devDatum,setDevDatum]=useState(''); // [PATCH rocni-vnos-fe v5]
  const [ddvRocno,setDdvRocno]=useState(false); // [PATCH rocni-vnos-fe v7] rocno popravljen DDV se ne preracunava
  const jeRocni = Boolean(selected?._rocni);
  const jeRocniDok = Boolean(selected?._rocni || selected?.ocr?.rocni_vnos); // [PATCH_ROCNI_UVOZ_PARTNER_V1] rocni (osnutek/shranjen) vs uvoz
  const urejanje = editMode || jeRocni;
  // [PATCH zaklep-potrjenega-fe v1] potrjen dokument se ne ureja. `!jeRocni`, ker rocni vnos
  // ustvari dokument s statusom 'approved' (dokumenti.py:1941) in bi bil sicer
  // neurejljiv ze med vnasanjem. Sifrant partnerja (svincnik) ostaja odprt.
  // Ograje: iskati po nizu `fieldset disabled={potrjenDok}` (3 mesta:
  // datumi, DDV knjiga, kontiranje) — v njih markerja ni, ker JSX komentar
  // na tistih mestih ni dovoljen (regresija v1a, 01.08.2026).
  const potrjenDok = String(selected?.status||'')==='approved' && !jeRocni;
  // ===== [PATCH likvidacija-fe v1] likvidacija prejetih racunov =====
  // Stanje modula + pravica trenutnega uporabnika za to bazo (GET .../likvidacija/stanje).
  // Stranka ureja vse, kar vidi, dokler racun ni likvidiran/potrjen; s pravico lahko_likvidira
  // likvidira/preklice. Racunovodja lahko potrdi sele po likvidaciji (ce je modul vklopljen).
  const [likvStanje,setLikvStanje]=useState<{modul:boolean;lahko_likvidira:boolean;je_stranka:boolean}>({modul:false,lahko_likvidira:false,je_stranka:false}); // [PATCH likvidacija-fe v6] privzeto IZKLOPLJENO (kot backend: ni vrstice = false)
  useEffect(()=>{ if(!companyId) return; api.get(`/dokumenti/${companyId}/likvidacija/stanje`).then(r=>setLikvStanje({modul:r.data?.modul===true,lahko_likvidira:!!r.data?.lahko_likvidira,je_stranka:!!r.data?.je_stranka})).catch(()=>{}); },[companyId]);
  const likvPredmet=(d:any)=>!!d && likvStanje.modul && !jeIzdaniTip(d.doc_type) && !d._rocni;
  const likvidiranDok=(d:any)=>!!d?.likvidiran_at;
  // stranka sme urejati: ni potrjen in (ni predmet likvidacije ali ni likvidiran)
  const strankaSmeUrejati=(d:any)=>!jeStranka || (String(d?.status||'')!=='approved' && !(likvPredmet(d)&&likvidiranDok(d)));
  const strankaZaklenjen = jeStranka && !!selected && !strankaSmeUrejati(selected);
  // ograje v glavi (sklic, opis, datumi): potrjen ALI za stranko likvidiran
  const zaklenjenDok = potrjenDok || strankaZaklenjen;
  /* [PATCH prodajni-tok v3] dokument iz izdaje: vsebina izdanega racuna (datumi, sklic, TRR, stevilka, zneski) zaklenjena; kontiranje odprto */
  const zaklenjenIzdaja = !!izIzdaje && !!selected;
  const zaklenjenGlava = zaklenjenDok || zaklenjenIzdaja;
  // racunovodja: potrditev blokirana, dokler stranka ne likvidira
  const potrditevBlokirana = !jeRocni && !!selected && likvPredmet(selected) && !likvidiranDok(selected);
  // [PATCH racun-placan-gumb v1] gumb 'Racun je placan' (Janez 08.09.2026): ISTI klic kot Placila -> 'Oznaci za placano'
  // (POST /stranka/{cid}/racuni/{id}/placano, DocumentPayment za odprti znesek, paid_at = zdaj, _sync_status -> is_paid).
  // Viden: prejeti (ne izdani), ni rocni vnos, ni urejanje, se ni v celoti placan; ce je modul likvidacije vklopljen in je
  // dokument njen predmet, sele po likvidaciji (BE _preveri_placilo_dnevnik to vseeno zavrne s 409). Vidijo vsi (stranka, racunovodja, admin).
  const jePlacanDok=(d:any)=>{ if(!d) return false; const _t=Number(d.amount_total||0), _p=Number(d.placano_znesek||0); return d.status==='placano'||(_t>0.01&&_p>=_t-0.01); };
  const placanGumbViden = !jeRocni && !editMode && !!selected && !jeIzdaniTip(selected?.doc_type) && !jePlacanDok(selected) && (!likvPredmet(selected) || likvidiranDok(selected));
  const [placanBusy,setPlacanBusy]=useState(false);
  const oznaciRacunPlacan=async()=>{
    const d=selected; if(!d||placanBusy) return;
    if(!window.confirm(`Označim račun ${d.doc_number||''} kot plačan v celoti (${fmt(Number(d.amount_total||0))} EUR, danes)?`)) return;
    setPlacanBusy(true);
    try{
      await api.post(`/stranka/${companyId}/racuni/${d.id}/placano`,{placano:true});
      const _tot=Number(d.amount_total||0);
      setSelected((sel:any)=>sel&&sel.id===d.id?{...sel,placano_znesek:_tot}:sel);
      setDokumenti(prev=>prev.map((x:any)=>x.id===d.id?{...x,placano_znesek:_tot}:x));
      toast.success('Račun označen kot plačan');
      naloziDokumente(companyId, aktivniTip, iskanje);
    }catch(e:any){ toast.error(e?.response?.data?.detail||'Označevanje ni uspelo'); }
    finally{ setPlacanBusy(false); }
  };
  // [PATCH likv-kljukice-stran v1] mnozicna likvidacija odstranjena iz UI (Janez 08.09.2026: likvidira se vsak racun posebej);
  // BE endpoint POST .../likvidiraj-mnozicno ostane (morebitna vrnitev). likvBusy ostane (Likvidiraj / Preklici).
  const [likvBusy,setLikvBusy]=useState(false);
  const _posodobiLikvLokalno=(id:string,likvidiran_at:string|null,likvidiral:string|null)=>{
    setDokumenti(prev=>prev.map(d=>d.id===id?{...d,likvidiran_at,likvidiral}:d));
    setSelected((sel:any)=>sel&&sel.id===id?{...sel,likvidiran_at,likvidiral}:sel);
  };
  const likvidirajDokument=async(d:any)=>{
    if(!d||likvBusy) return;
    if(selected?.id===d.id && napakeGlave.length){ toast.error('Račun ima napake: '+napakeGlaveTxt,{duration:8000}); return; } // [PATCH likvidacija-fe v3] (backend enako, 400)
    setLikvBusy(true);
    try{ const r=await api.post(`/dokumenti/${companyId}/${d.id}/likvidiraj`); _posodobiLikvLokalno(d.id,r.data?.likvidiran_at||new Date().toISOString(),r.data?.likvidiral||null); toast.success('Račun likvidiran'); }
    catch(e:any){ toast.error(e?.response?.data?.detail||'Likvidacija ni uspela'); }
    finally{ setLikvBusy(false); }
  };
  const prekliciLikvidacijo=async(d:any)=>{
    if(!d||likvBusy) return; setLikvBusy(true);
    try{ await api.post(`/dokumenti/${companyId}/${d.id}/preklici-likvidacijo`); _posodobiLikvLokalno(d.id,null,null); toast.success('Likvidacija preklicana — račun lahko urejate'); }
    catch(e:any){ toast.error(e?.response?.data?.detail||'Preklic ni uspel'); }
    finally{ setLikvBusy(false); }
  };
  // [PATCH likv-kljukice-stran v1] funkcija mnozicne likvidacije odstranjena (klic likvidiraj-mnozicno iz UI ne obstaja vec)
  // ===== konec [PATCH likvidacija-fe v1] =====
  // ===== [PATCH likvidacija-fe v2] urejanje glave: Shrani / Preklici namesto zgornjega "Koncaj" =====
  // Ob vstopu v urejanje (vstopiUrejanje) se shrani posnetek glave: stevilka, partner, datumi,
  // zneski/kontiranje, sklic, TRR, opis, devizno. Shrani = isti klic kot prej "Koncaj"
  // (shraniPopravke), Preklici / Esc = vrne posnetek in nic ne poslje. Velja za vse vloge.
  // Rocni vnos (jeRocni) ima svoj tok (potrdiRocni / zavrzi) in te vrstice ne uporablja.
  type UrejanjePosnetek={stevilkaEdit:string;kontiranje:any;sklicData:typeof sklicData;datumi:typeof datumi;trrEdit:string;partnerIbani:string[];opisVnos:string;devValuta:string;devZnesek:string;devDatum:string;skupajRocno:boolean;ddvRocno:boolean;rawZneski:Record<string,string>;partner:any;partner_najden:any};
  const [urejanjePosnetek,setUrejanjePosnetek]=useState<UrejanjePosnetek|null>(null);
  const _kopija=(x:any)=>x==null?x:JSON.parse(JSON.stringify(x));
  const vstopiUrejanje=()=>{
    if(editMode) return;
    setUrejanjePosnetek({stevilkaEdit,kontiranje:_kopija(kontiranje),sklicData:{...sklicData},datumi:{...datumi},trrEdit,partnerIbani:[...partnerIbani],opisVnos,devValuta,devZnesek,devDatum,skupajRocno,ddvRocno,rawZneski:{...rawZneski},partner:_kopija(selected?.partner),partner_najden:selected?.partner_najden});
    if(!stevilkaEdit) setStevilkaEdit(stDok(selected));
    setEditMode(true);
  };
  const prekliciUrejanje=()=>{
    // [PATCH likvidacija-fe v3] BUG Esc: DatumInput hrani natipkano lokalno in jo ob blur zapise prek onChange;
    // pri Esc je blur prisel SELE PO povrnitvi posnetka in je vtipkano vrednost zapisal nazaj (vidno sele ob
    // ponovnem nalaganju racuna). Zato najprej blur aktivnega polja (commit se zgodi zdaj), sele nato povrnitev --
    // oba setState sta v istem dogodku, zadnji (posnetek) zmaga. Klik na Preklici je blur ze sam sprozil.
    try{ (document.activeElement as HTMLElement|null)?.blur(); }catch{}
    const p=urejanjePosnetek;
    if(p){
      setStevilkaEdit(p.stevilkaEdit); setKontiranje(p.kontiranje); setSklicData(p.sklicData); setDatumi(p.datumi);
      setTrrEdit(p.trrEdit); setPartnerIbani(p.partnerIbani); setOpisVnos(p.opisVnos);
      setDevValuta(p.devValuta); setDevZnesek(p.devZnesek); setDevDatum(p.devDatum);
      setSkupajRocno(p.skupajRocno); setDdvRocno(p.ddvRocno); setRawZneski(p.rawZneski);
      setSelected((s:any)=>s?{...s,partner:p.partner,partner_najden:p.partner_najden}:s);
    }
    setUrejanjePosnetek(null); setEditMode(false);
  };
  const shraniUrejanje=async()=>{
    if(napakeGlave.length){ toast.error('Račun ima napake: '+napakeGlaveTxt,{duration:8000}); return; } // [PATCH likvidacija-fe v3]
    if(!(await shraniPopravke())) return;
    setStevilkaEdit(''); setUrejanjePosnetek(null); setEditMode(false);
  };
  useEffect(()=>{ // Esc = Preklici (ne med odprto masko partnerja)
    if(!editMode||jeRocni) return;
    const h=(e:KeyboardEvent)=>{ if(e.key==='Escape'&&!showPartnerModal){ e.preventDefault(); prekliciUrejanje(); } };
    window.addEventListener('keydown',h);
    return ()=>window.removeEventListener('keydown',h);
  });
  // gumb Likvidiraj / Preklici likvidacijo na dnu detajla (pravica, modul, prejeti, nepotrjen, ne med urejanjem)
  const likvGumbViden = !jeRocni && !editMode && !!selected && likvStanje.lahko_likvidira && likvPredmet(selected) && selected?.status!=='approved';
  // ===== konec [PATCH likvidacija-fe v2] =====
  // ===== [PATCH likvidacija-fe v3] logicne kontrole glave (zrcalo backend validacija_vnosa.py) =====
  // Racuna se iz trenutnega stanja maske (datumi, zneski glave, DDV evidenca -- te stranka ne vidi, zato se pri
  // njej ne preverja, enako backend). Uveljavi se SAMO ob Shrani / Likvidiraj / Potrdi (gumb siv + tooltip,
  // polje rdece), nikoli pri prikazu -- stari racuni z napakami se se vedno odprejo.
  // [PATCH likvidacija-fe v4] ostalo (neobdavceno): vir = kontiranje.ocr_zneski.ostalo (maska/shranjeno), sicer stolpec amount_other
  const ostaloGlave=():number=>Number(kontiranje?.ocr_zneski?.ostalo ?? selected?.amount_other ?? 0)||0;
  const [ostaloOdprto,setOstaloOdprto]=useState(false); // gumb "+ ostalo" ga odpre; vrednost != 0 ga pokaze tudi brez klika
  const ostaloVidno = ostaloOdprto || ostaloGlave()!==0;
  const _zneskiGlave=()=>({
    skupaj_brez_ddv: kontiranje?.ocr_zneski?.skupaj_brez_ddv ?? selected?.ocr?.zneski?.skupaj_brez_ddv ?? 0,
    znesek_ddv:      kontiranje?.ocr_zneski?.znesek_ddv      ?? selected?.ocr?.zneski?.znesek_ddv      ?? 0,
    skupaj_z_ddv:    kontiranje?.ocr_zneski?.skupaj_z_ddv    ?? selected?.ocr?.zneski?.skupaj_z_ddv    ?? 0,
    ostalo:          ostaloGlave(), // [PATCH likvidacija-fe v4]
  });
  const napakeGlave: NapakaGlave[] = (selected && !jeRocni) ? napakeGlaveIzracun(datumi, _zneskiGlave(), jeStranka ? null : (kontiranje?.ddv_knjiga || [])) : [];
  const napakeGlaveTxt = napakeGlave.map(n=>n.sporocilo).join('; ');
  const napakaZa = (polje:string): string|undefined => napakeGlave.find(n=>n.polje===polje)?.sporocilo;
  const glavaNapacna = napakeGlave.length > 0;
  // ===== konec [PATCH likvidacija-fe v3] =====
  /* [PATCH pregled-dela v3] merjenje aktivnega casa — EN SAM ucinek.
     Vrstni red vej je pomemben:
       1. odprta uvozna maska (showSop | showUpload) -> 'nalaganje'
          (dokument spodaj se le zaustavi in po zaprtju maske nadaljuje)
       2. odprt dokument -> 'pregled' pred prvo potrditvijo, 'popravki' po njej
       3. sicer -> 'splosno' z vrsto iz aktivnega zavihka
     showUpload/showSop sta deklarirana v v. 546/547, torej v obsegu.
     Sledilnik nikoli ne vrze izjeme. */
  useEffect(()=>{
    if(!companyId) return;
    if(showSop||showUpload){
      deloSledilec.zacni('nalaganje', {companyId, docType: aktivniTip});
    } else if(selected?.id){
      deloSledilec.zacni(potrjenDok?'popravki':'pregled',
        {companyId, docType: selected?.doc_type||aktivniTip, documentId: selected.id});
    } else {
      deloSledilec.zacni('splosno', {companyId, docType: aktivniTip});
    }
    return ()=>{ deloSledilec.koncaj('zapri'); };
  },[companyId, selected?.id, potrjenDok, aktivniTip, showSop, showUpload]);
  const zacniRocniVnos=()=>{
    if(!companyId){toast.error('Izberite podjetje');return;}
    const danes=new Date().toISOString().split('T')[0];
    const prazni={skupaj_brez_ddv:0,znesek_ddv:0,skupaj_z_ddv:0};
    setSelected({_rocni:true,id:null,doc_type:'prejeti_racun',status:'novo',ocr:{zneski:{...prazni}},partner:null,partner_najden:false});
    setKontiranje({knjizbe:[{tip:'dobro',konto:'',naziv:'',znesek:0},{tip:'breme',konto:'',naziv:'',znesek:0}],ddv_knjiga:[],ocr_zneski:{...prazni}});
    setDatumi({datum_knjizenja:danes,datum_ddv:'',datum_storitve:'',datum_racuna:'',datum_valute:'',obdobje:''});
    setSklicData({model:'SI',modelSt:'00',sklicSt:''});
    setStevilkaEdit(''); setTrrEdit(''); setPartnerIbani([]); setOpisVnos('');
    setSkupajRocno(false); setDdvRocno(false); setRocniFile(null); setEditMode(true);
    setTimeout(()=>document.getElementById('vt-stevilka')?.focus(),80);
  };
  // osnova+DDV -> skupaj (rocni popravek skupaj obvelja); pred DDV-razclenitvijo
  // dobro in strosek sledita skupnemu znesku (Janezova specifikacija)
  const nastaviZnesek=(kljuc:string,vred:number)=>{
    const oz:any={...(kontiranje?.ocr_zneski||selected?.ocr?.zneski||{skupaj_brez_ddv:0,znesek_ddv:0,skupaj_z_ddv:0})};
    if(oz.ostalo===undefined) oz.ostalo=ostaloGlave(); // [PATCH likvidacija-fe v4] ostalo vedno v payloadu (0 = brez)
    oz[kljuc]=vred;
    const _ost=Number(oz.ostalo||0); // [PATCH likvidacija-fe v4] neobdavceno v enacbi skupaj
    // [PATCH rocni-vnos-fe v7] osnova -> DDV po stopnji prve DDV vrstice (privzeto 22 %)
    // [PATCH glava-sync v2] (nadomesca glava-osnova-ddv v1) Kako OSNOVA vodi DDV v glavi, odloca knjiga:
    //  - ena vrstica domaca/uvoz ali vse vrstice domace: DDV = osnova x stopnja prve vrstice, rocni DDV se ponastavi
    //  - EU par (KIR+KPR): racun tujega dobavitelja DDV nima -> glava DDV 0, skupaj = osnova; samoobdavcitev gre
    //    v evidenco (obe vrstici) in knjizbe 26x/16x, obveznost 2200 = osnova (odlocitev Janez 04.09.)
    //  - devizni, mesane knjige: dosedanje pravilo rocni-vnos-fe v7 (!ddvRocno)
    const _dk=(kontiranje?.ddv_knjiga||[]);
    const _jeDevizni=Boolean(deviznoGet().valuta);
    const _jeIzd=jeIzdaniTip(selected?.doc_type);
    const _ena1=!_jeIzd&&_dk.length===1&&['domaca','uvoz'].includes(knjigaVrsticeDdv(_dk[0]));
    const _euPar=!_jeIzd&&!_jeDevizni&&_dk.length===2&&_dk.every((v:any)=>knjigaVrsticeDdv(v)==='eu');
    const _vseDom=_dk.every((v:any)=>knjigaVrsticeDdv(v)==='domaca');
    const _osnovaVodi=!_jeDevizni&&(_ena1||_vseDom);
    if(kljuc==='skupaj_brez_ddv'&&_euPar){ oz.znesek_ddv=0; oz.skupaj_z_ddv=Number((Number(vred||0)+_ost).toFixed(2)); setDdvRocno(true); } // [PATCH likvidacija-fe v4] + ostalo
    if(kljuc==='skupaj_brez_ddv'&&!_euPar&&(_osnovaVodi||!ddvRocno)){
      if(_osnovaVodi) setDdvRocno(false);
      const _st7=Number((kontiranje?.ddv_knjiga||[])[0]?.stopnja);
      const stopnja7=Number.isFinite(_st7)?_st7:22;
      oz.znesek_ddv=Number((Number(vred||0)*stopnja7/100).toFixed(2));
    }
    if(kljuc==='znesek_ddv') setDdvRocno(true);
    // [PATCH likvidacija-fe v5] REGRESIJA: vpis OSNOVE je preracunal DDV, skupaj pa ne, ker je skupajRocno (rocno vpisan
    // skupaj / OCR zneski ne sedejo) blokiral enacbo. Vpis osnove odslej VEDNO posodobi skupaj = osnova + DDV + ostalo in
    // ponastavi rocni skupaj (veriga se zacne znova). Popravek DDV in ostalo ohranita dosedanje pravilo (skupaj sledi, ce
    // ni rocno vpisan); EU par skupaj nastavi ze zgoraj in tu ni zajet.
    const _osnovaVnos = kljuc==='skupaj_brez_ddv' && !_euPar;
    const rocnoSkupaj = !_osnovaVnos && (skupajRocno || kljuc==='skupaj_z_ddv');
    if(!rocnoSkupaj){ oz.skupaj_z_ddv=Number((Number(oz.skupaj_brez_ddv||0)+Number(oz.znesek_ddv||0)+_ost).toFixed(2)); } // [PATCH likvidacija-fe v4] + ostalo
    if(_osnovaVnos&&skupajRocno) setSkupajRocno(false);
    if(kljuc==='skupaj_z_ddv') setSkupajRocno(true);
    const noviSkupaj=Number(oz.skupaj_z_ddv||0);
    let kn=(kontiranje?.knjizbe||[]);
    const imaDdv=kn.some((kb:any)=>kb.tip==='breme'&&String(kb.konto||'').startsWith('16'));
    if(!imaDdv&&kn.length){ kn=kn.map((kb:any)=>({...kb,znesek:noviSkupaj})); }
    // [PATCH glava-sync v1] glava -> DDV evidenca -> knjizbe. SAMO prejeti, SAMO ena vrstica,
    // SAMO domaca knjiga (odlocitev Janez 04.09.). Vrstica dobi osnovo in DDV iz glave, knjizbe
    // prezida handleDdvChange (ista pot kot rocni popravek evidence). Pozor: rocni razrez stroska
    // se ohrani le, ce vsota sede na cent (razdeli-ddv-fe v2) — po spremembi zneska torej pade.
    // Sicer (0 ali >1 vrstic, EU/uvoz/oss, izdani) ostane dosedanje obnasanje.
    if(_ena1){ /* [PATCH glava-sync v2] domaca ALI uvoz (ena vrstica); _dk/_ena1/_euPar so definirani zgoraj */
      const _v={..._dk[0],osnova:Number(oz.skupaj_brez_ddv||0),znesek_ddv:Number(oz.znesek_ddv||0)};
      handleDdvChange({...(kontiranje||{}),ocr_zneski:oz,ddv_knjiga:[_v]});
    } else if(_euPar&&kljuc==='skupaj_brez_ddv'){
      // [PATCH glava-sync v2] EU par: obe vrstici osnova iz glave, DDV = osnova x stopnja vrstice (sifrant, 22 %);
      // vrstica brez stopnje (se brez vrste) dobi samo osnovo. Knjizbe prezida handleDdvChange (KIR/KPR pot).
      const _osn=Number(oz.skupaj_brez_ddv||0);
      const _nove=_dk.map((v:any)=>{const _st=Number(v?.stopnja);return {...v,osnova:_osn,znesek_ddv:Number.isFinite(_st)?Number((_osn*_st/100).toFixed(2)):Number(v?.znesek_ddv||0)};});
      handleDdvChange({...(kontiranje||{}),ocr_zneski:oz,ddv_knjiga:_nove});
    } else {
      setKontiranje((k:any)=>({...k,ocr_zneski:oz,knjizbe:kn}));
    }
    setSelected((s:any)=>s?{...s,ocr:{...(s.ocr||{}),zneski:{...oz}}}:s);
  };
  // [PATCH rocni-vnos-fe v2] predlog kontov iz znanja (vzorci/keywords) —
  // poklice se ob izbiri partnerja in ob izhodu iz Opisa; polni SAMO prazne konte
  const zadnjiPredlogRef=useRef<string>('');
  const predlagajKonte=async(pid?:string,opisBesedilo?:string)=>{
    if(!companyId) return;
    if(jeIzdaniTip(selected?.doc_type)) return; // [PATCH izdani-partner-isci-fe v1] prejeta konto-pamet ne polni izdanih knjizb
    const _pid=String(pid||kontiranje?.partner_id||''); if(!_pid) return;
    const _op=String(opisBesedilo??opisVnos??'').trim();
    const kljuc=_pid+'|'+_op;
    if(zadnjiPredlogRef.current===kljuc) return;
    zadnjiPredlogRef.current=kljuc;
    try{
      const oz=kontiranje?.ocr_zneski||{};
      const r=await api.get(`/dokumenti/${companyId}/predlog-kontov`,{params:{partner_id:_pid,opis:_op,osnova:Number(oz.skupaj_brez_ddv||0)}});
      const d=r.data||{}; if(!d.najdeno) return;
      const kn=(kontiranje?.knjizbe||[]).map((kb:any)=>({...kb}));
      let sprem=false;
      const iD=kn.findIndex((kb:any)=>kb.tip==='dobro');
      const iS=kn.findIndex((kb:any)=>kb.tip==='breme'&&!String(kb.konto||'').startsWith('16'));
      if(iD>=0&&!String(kn[iD].konto||'').trim()&&d.konto_dobavitelja){
        kn[iD].konto=String(d.konto_dobavitelja);
        kn[iD].naziv=d.naziv_dobavitelja||kn[iD].naziv||'Obveznosti do dobaviteljev';
        sprem=true;
      }
      if(iS>=0&&!String(kn[iS].konto||'').trim()&&d.konto_stroska){
        kn[iS].konto=String(d.konto_stroska);
        kn[iS].naziv=d.naziv_stroska||kn[iS].naziv||'';
        if(d.sm_stroska&&!kn[iS].sm) kn[iS].sm=String(d.sm_stroska);
        sprem=true;
      }
      if(sprem){
        setKontiranje((k:any)=>({...k,knjizbe:kn}));
        toast(`\ud83d\udca1 Konti predlagani (${d.vir==='ucni_vzorci'?'zgodovina partnerja':'ključne besede'})`);
      }
    }catch{/* predlog je opcijski */}
  };
  // [PATCH rocni-vnos-fe v3] skupna izbira partnerja (modal + inline iskalnik)
  // [PATCH partner-uredi-z-racuna v1] urejanje partnerja v sifrantu neposredno z racuna.
  // Loceno od uporabiPartnerja(): to NI menjava partnerja, zato se partner_id
  // ne spremeni, konti se ne predlagajo znova in fokus se ne premakne.
  const [urediPartnerja,setUrediPartnerja]=useState<any>(null);
  // [PATCH rocni-razrez-fe v1a] rocna razdelitev dokumenta na N delov
  const [razrezOpen,setRazrezOpen]=useState(false);
  const [razrezInfo,setRazrezInfo]=useState<any>(null);
  const [razrezDelov,setRazrezDelov]=useState(2);
  const [razrezRezi,setRazrezRezi]=useState<number[]>([]);
  const [razrezBusy,setRazrezBusy]=useState(false);
  // [PATCH zdruzi-fe v3] zdruzitev vec dokumentov v enega novega
  const [zdruziOpen,setZdruziOpen]=useState(false);
  const [zdruziInfo,setZdruziInfo]=useState<any>(null);
  const [zdruziQ,setZdruziQ]=useState('');
  const [zdruziKand,setZdruziKand]=useState<any[]>([]);
  const [zdruziIzbrani,setZdruziIzbrani]=useState<any[]>([]);
  const [zdruziBusy,setZdruziBusy]=useState(false);
  // Normalizacija mest reza: vsak del mora dobiti vsaj eno stran.
  // Za k rezov in n strani velja za i-ti rez: min = prejsnji+1, max = n-(k-i).
  const normRezi=(arr:number[],n:number)=>{
    const k=arr.length; const out=arr.slice();
    for(let j=0;j<k;j++){
      const minV=j===0?1:out[j-1]+1;
      const maxV=n-(k-j);
      let v=Number(out[j]||minV);
      if(v<minV) v=minV;
      if(v>maxV) v=maxV;
      out[j]=v;
    }
    for(let j=k-1;j>=0;j--){
      const maxV=n-(k-j);
      if(out[j]>maxV) out[j]=maxV;
      if(j>0&&out[j-1]>=out[j]) out[j-1]=out[j]-1;
    }
    return out;
  };
  const odpriRazrez=async()=>{
    if(!selected?.id) return;
    try{
      const r=await api.get(`/dokumenti/${companyId}/dokument/${selected.id}/razrez-info`);
      if(!r.data?.dovoljeno){ toast.error(r.data?.razlog||'Razdelitev ni mogoča'); return; }
      const n=Number(r.data.st_strani||0);
      setRazrezInfo(r.data);
      setRazrezDelov(2);
      setRazrezRezi(normRezi([1],n));
      setRazrezOpen(true);
    }catch(e:any){
      const det=e?.response?.data?.detail;
      toast.error(typeof det==='string'?det:'Podatkov o dokumentu ni bilo mogoče prebrati');
    }
  };
  const nastaviRazrezDelov=(k:number)=>{
    const n=Number(razrezInfo?.st_strani||0);
    if(k<2||k>n) return;
    const novi:number[]=[];
    for(let i=1;i<k;i++) novi.push(i);
    setRazrezDelov(k);
    setRazrezRezi(normRezi(novi,n));
  };
  const nastaviRez=(i:number,v:number)=>{
    const n=Number(razrezInfo?.st_strani||0);
    setRazrezRezi(prev=>{ const kopija=prev.slice(); kopija[i]=v; return normRezi(kopija,n); });
  };
  const izvediRazrez=async()=>{
    if(!selected?.id||razrezBusy) return;
    const idIzvirnika=selected.id;
    setRazrezBusy(true);
    try{
      const r=await api.post(`/dokumenti/${companyId}/dokument/${idIzvirnika}/razdeli`,{rezi:razrezRezi});
      const stDelov=Number(r.data?.st_delov||razrezRezi.length+1);
      setRazrezOpen(false);
      setRazrezInfo(null);
      setDokumenti(prev=>prev.filter((d:any)=>d.id!==idIzvirnika));
      setSelected(null);
      toast.success(`Razdeljeno na ${stDelov} dele — obdelava teče.`);
      /* [PATCH rocni-razrez-napredek v1b] isto okno napredka kot pri uvozu sopa.
         Polling je v uploadStore (vzorec: DokumentiPage:1147/:1174), zato
         tece naprej tudi ce uporabnik okno zapre ali osvezi stran. */
      if(r.data?.batch_id){
        setShowSop(true);
        useUploadStore.getState().zacniSop(companyId, r.data.batch_id, selectedCompany?.name||'', aktivniTip);
      }
    }catch(e:any){
      const det=e?.response?.data?.detail;
      toast.error(typeof det==='string'?det:'Razdelitev ni uspela');
    }finally{
      setRazrezBusy(false);
    }
  };

  // [PATCH zdruzi-fe v3] Vsi izbrani dokumenti se izbrisejo, iz spojenega PDF nastane
  // NOV dokument, ki gre znova skozi prepoznavo in kontiranje. Dokument, na
  // katerem uporabnik stoji, je VEDNO prvi; ostali sledijo v vrstnem redu
  // klikanja. Kandidatov NE beremo iz svojega endpointa: obstojeci seznam
  // ze zna iskati po partnerju, stevilki, interni stevilki in znesku.
  const zdruziPolozaj=(id:string)=>zdruziIzbrani.findIndex((x:any)=>x.id===id);
  const zdruziZacetnaStran=(idx:number)=>{
    let s=Number(zdruziInfo?.st_strani||0)+1;
    for(let i=0;i<idx;i++) s+=Number(zdruziIzbrani[i]?.st_strani||0);
    return s;
  };
  const zdruziSkupajStrani=()=>zdruziIzbrani.reduce((v:number,x:any)=>v+Number(x.st_strani||0),Number(zdruziInfo?.st_strani||0));
  const zdruziRazpon=(od:number,koliko:number)=>koliko>1?`str. ${od}\u2013${od+koliko-1}`:`str. ${od}`;
  const sklonDok=(n:number)=>n===1?'dokument':(n===2?'dokumenta':(n<=4?'dokumente':'dokumentov'));
  const isciZdruziKand=async(q:string)=>{
    if(!companyId||!selected?.id) return;
    try{
      const tip=selected.doc_type||aktivniTip;
      const r=await api.get(`/dokumenti/${companyId}?tip=${tip}&limit=25${q&&q.trim()?`&q=${encodeURIComponent(q.trim())}`:''}`);
      setZdruziKand((r.data||[]).filter((d:any)=>d.id!==selected?.id));
    }catch{ setZdruziKand([]); }
  };
  const odpriZdruzi=async()=>{
    if(!selected?.id) return;
    try{
      const r=await api.get(`/dokumenti/${companyId}/dokument/${selected.id}/zdruzi-info`);
      if(!r.data?.dovoljeno){ toast.error(r.data?.razlog||'Združitev ni mogoča'); return; }
      setZdruziInfo(r.data);
      setZdruziQ('');
      setZdruziIzbrani([]);
      setZdruziKand([]);
      setZdruziOpen(true);
      isciZdruziKand('');
    }catch(e:any){
      const det=e?.response?.data?.detail;
      toast.error(typeof det==='string'?det:'Podatkov o dokumentu ni bilo mogoče prebrati');
    }
  };
  /* Klik na kandidata: ce je ze izbran -> odznaci; sicer preveri ograje in
     PREBERI stevilo strani (seznam ga ne nosi), sele nato dodaj na konec. */
  const preklopiZdruziKand=async(d:any)=>{
    if(zdruziBusy||!d?.id) return;
    if(zdruziPolozaj(d.id)>=0){ setZdruziIzbrani(prev=>prev.filter((x:any)=>x.id!==d.id)); return; }
    try{
      const r=await api.get(`/dokumenti/${companyId}/dokument/${d.id}/zdruzi-info`);
      if(!r.data?.dovoljeno){ toast.error(r.data?.razlog||'Tega dokumenta ni mogoče združiti'); return; }
      setZdruziIzbrani(prev=>[...prev,{
        id:d.id,
        doc_number:d.doc_number||d.ocr?.stevilka||'brez številke',
        ime:d.partner?.ime||d.ocr?.izdajatelj?.ime||d.file_name||'',
        st_strani:Number(r.data.st_strani||0),
      }]);
    }catch(e:any){
      const det=e?.response?.data?.detail;
      toast.error(typeof det==='string'?det:'Podatkov o dokumentu ni bilo mogoče prebrati');
    }
  };
  const izvediZdruzi=async()=>{
    if(!selected?.id||zdruziIzbrani.length===0||zdruziBusy) return;
    const idIzvora=selected.id, idi=zdruziIzbrani.map((x:any)=>x.id);
    setZdruziBusy(true);
    try{
      const r=await api.post(`/dokumenti/${companyId}/dokument/${idIzvora}/zdruzi`,{cilj_ids:idi});
      setZdruziOpen(false);
      setZdruziInfo(null);
      setZdruziIzbrani([]);
      /* vsi izvirniki padejo — iz seznama gredo vsi */
      setDokumenti(prev=>prev.filter((d:any)=>d.id!==idIzvora&&!idi.includes(d.id)));
      setSelected(null);
      toast.success(`Združeno (${r.data?.st_strani||'?'} strani) — obdelava teče.`);
      /* isto okno napredka kot pri uvozu sopa in rocnem razrezu; polling je
         v uploadStore, zato tece naprej tudi ce uporabnik okno zapre. */
      if(r.data?.batch_id){
        setShowSop(true);
        useUploadStore.getState().zacniSop(companyId, r.data.batch_id, selectedCompany?.name||'', aktivniTip);
      }
    }catch(e:any){
      const det=e?.response?.data?.detail;
      toast.error(typeof det==='string'?det:'Združitev ni uspela');
    }finally{
      setZdruziBusy(false);
    }
  };
  const [nalagamPartnerja,setNalagamPartnerja]=useState(false);
  const odpriUrediPartnerja=async()=>{
    const pid=selected?.partner?.id;
    if(!pid||!companyId) return;
    setNalagamPartnerja(true);
    try{
      const r=await api.get(`/sifranti/partnerji/${companyId}/${pid}/podrobno`);
      setUrediPartnerja(r.data);
    }catch{
      toast.error('Partnerja ni bilo mogoce nalozit\u0069 iz sifranta');
    }finally{
      setNalagamPartnerja(false);
    }
  };
  const partnerShranjen=(p:any)=>{
    setUrediPartnerja(null);
    const _ibs=(Array.isArray(p.ibani)?p.ibani:[]).map((x:any)=>typeof x==='string'?x:String(x?.iban||'')).filter(Boolean);
    setPartnerIbani(_ibs);
    // TRR na dokumentu se NAMENOMA ne prepise — tih prepis bi bil nepricakovan.
    setSelected((s:any)=>s?{...s,partner:{...(s.partner||{}),id:p.id,ime:p.name,name:p.name,tax_number:p.tax_number,vat_number:p.vat_number,vasco_code:p.vasco_code,iban:p.iban},partner_najden:Boolean(p.vasco_code)}:s);
    setKontiranje((k:any)=>k?{...k,partner_ime:p.name,partner_davcna:p.tax_number}:k);
    setDokumenti(prev=>prev.map(d=>d.id===selected?.id?{...d,partner:{...(d.partner||{}),ime:p.name,name:p.name,tax_number:p.tax_number,vat_number:p.vat_number,vasco_code:p.vasco_code}}:d));
  };
  const uporabiPartnerja=(p:any)=>{
    setKontiranje((k:any)=>({...k,partner_ime:p.name,partner_davcna:p.tax_number,partner_id:p.id}));
    setSelected((s:any)=>s?{...s,partner:{id:p.id,ime:p.ime||p.name,name:p.name,tax_number:p.tax_number,vat_number:p.vat_number,vasco_code:p.vasco_code,iban:p.iban},partner_najden:Boolean(p.vasco_code)}:s);
    const _ibs=(Array.isArray(p.ibani)?p.ibani:[]).map((x:any)=>typeof x==='string'?x:String(x?.iban||'')).filter(Boolean);
    setPartnerIbani(_ibs);
    const _prim=p.iban||_ibs[0]||'';
    if(_prim&&!jeIzdaniTip(selected?.doc_type)) setTrrEdit(_prim); // [PATCH izdani-partner-isci-fe v1] kupcev IBAN ni TRR izdanega racuna
    setTimeout(()=>document.getElementById('vt-sklic-model')?.focus(),60);
    predlagajKonte(String(p.id),opisVnos);
  };
  // [PATCH rocni-vnos-fe v7] sprememba stopnje v DDV evidenci (ena vrstica)
  // preracuna tudi DDV in skupaj v glavi, ce nista rocno popravljena
  const handleDdvChangeZ=(k:any)=>{
    try{
      const rows=(k?.ddv_knjiga||[]);
      const _st=Number(rows[0]?.stopnja);
      if(rows.length===1&&Number.isFinite(_st)&&!ddvRocno){
        const oz:any={...(k?.ocr_zneski||kontiranje?.ocr_zneski||{})};
        const osn=Number(oz.skupaj_brez_ddv||0);
        const nddv=Number((osn*_st/100).toFixed(2));
        if(Math.abs(nddv-Number(oz.znesek_ddv||0))>0.005){
          oz.znesek_ddv=nddv;
          if(!skupajRocno) oz.skupaj_z_ddv=Number((osn+nddv).toFixed(2));
          k={...k,ocr_zneski:oz};
          setSelected((s:any)=>s?{...s,ocr:{...(s.ocr||{}),zneski:{...oz}}}:s);
        }
      }
    }catch{/* neobvezno */}
    handleDdvChange(k);
  };
  // ===== konec [PATCH rocni-vnos-fe v1] stanje =====

  // [PATCH soimenjaki v1] Partnerji z istim nazivom (pravilo uvoza: norm + besede).
  // Rumeni pas je doslej visel na ocr.partner_kandidati, kar zapise SAMO uvoz VOD;
  // dokument iz OCR ali rocnega vnosa ga ni imel, tudi ce je imel kupec soimenjake.
  // Izmerjeno 27.08.2026: 1181 od 33.378 partnerjev FIZIANA ima soimenjaka (3,5 %),
  // dokumentov s takim kupcem je 6 -- pas zato ne postane hrup.
  const [soimenjaki,setSoimenjaki]=useState<any[]>([]);
  const [soimenjakiNaslovi,setSoimenjakiNaslovi]=useState(false);
  useEffect(()=>{
    const _pid=kontiranje?.partner_id||selected?.partner?.id||null;
    if(!companyId||!_pid){ setSoimenjaki([]); setSoimenjakiNaslovi(false); return; }
    let veljaven=true;
    api.get(`/sifranti/partnerji/${companyId}/soimenjaki`,{params:{partner_id:_pid}})
      .then((r:any)=>{ if(!veljaven) return;
        setSoimenjaki(r.data?.soimenjaki||[]);
        setSoimenjakiNaslovi(Boolean(r.data?.naslovi_razlicni)); })
      .catch(()=>{ if(veljaven){ setSoimenjaki([]); setSoimenjakiNaslovi(false); } });
    return ()=>{ veljaven=false; };
    // eslint-disable-next-line
  },[companyId,selected?.id,kontiranje?.partner_id,selected?.partner?.id]);
  // Zlitje: kandidati iz uvoza (dvoumno ujemanje) + soimenjaki iz sifranta.
  // Dedup po id; vrstni red: uvozni kandidati najprej (ti nosijo kontekst uvoza).
  const pasKandidati=useMemo(()=>{
    const iz=Array.isArray(selected?.ocr?.partner_kandidati)?selected.ocr.partner_kandidati:[];
    const vsi=[...iz];
    const videni=new Set(iz.map((x:any)=>String(x?.id||'')));
    (soimenjaki||[]).forEach((s:any)=>{ const k=String(s?.id||''); if(k&&!videni.has(k)){ videni.add(k); vsi.push(s); } });
    // pas ima smisel samo ob izbiri: en sam soimenjak brez uvoznega konteksta ni izbira
    return (iz.length>0||vsi.length>=2)?vsi:[];
  },[selected?.ocr?.partner_kandidati,soimenjaki]);
  const [showPartnerModal,setShowPartnerModal]=useState(false);
  // ===== Povezave dobropis/avans (Faza 1) =====
  const [odprtiDobropisi, setOdprtiDobropisi] = useState<any[]>([]);
  const [vezave, setVezave] = useState<any[]>([]);
  const [veziModal, setVeziModal] = useState(false);
  const [veziIzbrani, setVeziIzbrani] = useState<string[]>([]);
  const toggleVezi = (id: string) => setVeziIzbrani(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  const [zmanjsajNalog, setZmanjsajNalog] = useState(true);
  const [odprtiRacuni, setOdprtiRacuni] = useState<any[]>([]);
  const [vezanNa, setVezanNa] = useState<any>(null);
  const [racunModal, setRacunModal] = useState(false);
  const [racunIzbrani, setRacunIzbrani] = useState<string[]>([]);
  const toggleRacun = (id: string) => setRacunIzbrani(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  const [veziZnesek, setVeziZnesek] = useState('');
  const [racunZnesek, setRacunZnesek] = useState('');
  const [brisanjeModal, setBrisanjeModal] = useState(false);
  // [PATCH preklic-maska v1] maska za preklic potrditve (namesto window.confirm)
  const [preklicModal, setPreklicModal] = useState(false);
  const [preklicPrenos, setPreklicPrenos] = useState<any>(null);  // {exported_at, export_format} | null
  const [preklicBusy, setPreklicBusy] = useState(false);
  const [brisanjeDoc, setBrisanjeDoc] = useState<any>(null);
  const [brisanjeOdv, setBrisanjeOdv] = useState<any>({povezave:[], placila:[], lahko_brisati:true});
  const _pidPov = () => kontiranje?.partner_id || selected?.partner?.id || selected?.partner_id || null;
  const osveziPovezave = () => {
    if (!companyId || !selected?.id) return;
    api.get(`/stranka/${companyId}/racuni/${selected.id}/povezave`)
      .then((r:any) => setVezave(r.data.povezave || [])).catch(() => setVezave([]));
    const pid = _pidPov();
    if (pid) api.get(`/stranka/${companyId}/dobavitelj-odprti?partner_id=${pid}`)
      .then((r:any) => setOdprtiDobropisi(r.data.odprti || [])).catch(() => setOdprtiDobropisi([]));
    else setOdprtiDobropisi([]);
  };
  const osveziDobropis = () => {
    if (!companyId || !selected?.id) return;
    api.get(`/stranka/${companyId}/dokument/${selected.id}/povezava`)
      .then((r:any) => setVezanNa(r.data)).catch(() => setVezanNa(null));
    const pid = _pidPov();
    if (pid) api.get(`/stranka/${companyId}/odprti-racuni?partner_id=${pid}`)
      .then((r:any) => setOdprtiRacuni(r.data.racuni || [])).catch(() => setOdprtiRacuni([]));
    else setOdprtiRacuni([]);
  };
  useEffect(() => {
    if (!selected?.id) { setOdprtiDobropisi([]); setVezave([]); setOdprtiRacuni([]); setVezanNa(null); return; }
    const tip = selected.doc_type || 'prejeti_racun';
    if (tip === 'prejeti_racun') { osveziPovezave(); setOdprtiRacuni([]); setVezanNa(null); }
    else if (tip === 'credit_note' || tip === 'avans') { osveziDobropis(); setVezave([]); setOdprtiDobropisi([]); }
    // eslint-disable-next-line
  }, [companyId, selected?.id, kontiranje?.partner_id]);
  const osveziKontiranje = async () => {
    if (!selected?.id) return;
    try {
      const r = await api.get(`/dokumenti/${companyId}?tip=${selected.doc_type||aktivniTip}&limit=${limitSezRef.current}${stanjeQS()}`);  // [PATCH seznam-limit-fe v1]
      setDokumenti(r.data.map(obogatiIzdani)); // [PATCH ir3a-fix2 v1]
      naloziUvozZap(companyId); /* [PATCH uvoz-zaporedje v1] */
      const svez = r.data.find((d:any) => d.id === selected.id);
      if (svez) { setSelected(svez); setKontiranje(_uredKnjizbeIzdani(JSON.parse(JSON.stringify(svez.kontiranje||{})), svez.doc_type)); }
    } catch {}
  };
  const potrdiVezavo = async () => {
    if (veziIzbrani.length === 0) return;
    try {
      for (const id of veziIzbrani) {
        const o:any = odprtiDobropisi.find((x:any) => x.id === id);
        await api.post(`/stranka/${companyId}/racuni/${selected.id}/povezi`, {
          linked_document_id: id,
          kind: o?.doc_type || 'credit_note',
          znesek: (veziIzbrani.length === 1 ? Number(String(veziZnesek).replace(',', '.')) : Number(o?.znesek)) || null,
          zmanjsaj_nalog: zmanjsajNalog,
        });
      }
      toast.success(veziIzbrani.length > 1 ? `Povezano (${veziIzbrani.length})` : 'Povezano');
      setVeziModal(false); setVeziIzbrani([]); setZmanjsajNalog(true);
      osveziPovezave(); osveziKontiranje();
    } catch (e:any) { toast.error(e?.response?.data?.detail || 'Napaka pri povezovanju'); }
  };
  const odpniVezavo = async (linkId: string) => {
    try {
      await api.delete(`/stranka/${companyId}/povezave/${linkId}`);
      toast.success('Odpeto');
      const tip = selected?.doc_type || 'prejeti_racun';
      if (tip === 'prejeti_racun') { osveziPovezave(); osveziKontiranje(); } else osveziDobropis();
    } catch (e:any) { toast.error('Napaka'); }
  };
  const potrdiVezavoNaRacun = async () => {
    if (racunIzbrani.length === 0) return;
    try {
      for (const id of racunIzbrani) {
        const o:any = odprtiRacuni.find((x:any) => x.id === id);
        await api.post(`/stranka/${companyId}/racuni/${id}/povezi`, {
          linked_document_id: selected.id,
          kind: selected.doc_type || 'credit_note',
          znesek: (racunIzbrani.length === 1 ? Number(String(racunZnesek).replace(',', '.')) : Number(o?.odprto)) || null,
          zmanjsaj_nalog: zmanjsajNalog,
        });
      }
      toast.success(racunIzbrani.length > 1 ? `Povezano (${racunIzbrani.length})` : 'Povezano');
      setRacunModal(false); setRacunIzbrani([]); setZmanjsajNalog(true);
      osveziDobropis();
    } catch (e:any) { toast.error(e?.response?.data?.detail || 'Napaka pri povezovanju'); }
  };
  const [pdfOdprto,setPdfOdprto]=useState(()=>localStorage.getItem('aicount_pdf_odprto')==='true');
  const [panelWidths, setPanelWidths] = useState(() => {
    try { return JSON.parse(localStorage.getItem('aicount_panel_widths') || 'null') || {list: 280, detail: 500}; }
    catch { return {list: 280, detail: 500}; }
  });
  const panelWidthsRef = useRef(panelWidths);
  const listPanelRef = useRef<HTMLDivElement>(null);
  const detailPanelRef = useRef<HTMLDivElement>(null);
  const dragRef = useRef<{active: string|null, startX: number, startW: number}>({active: null, startX: 0, startW: 0});
  const containerRef = useRef<HTMLDivElement>(null);

  const onMouseDown = (panel: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    const startW = panelWidthsRef.current[panel as keyof typeof panelWidths];
    const startX = e.clientX;
    // Onemogoči pointer events na iframeih med dragom
    document.querySelectorAll('iframe').forEach((f: any) => f.style.pointerEvents = 'none');
    document.body.style.cursor = 'col-resize';
    const onMove = (ev: MouseEvent) => {
      const dx = ev.clientX - startX;
      const newW = Math.max(180, Math.min(800, startW + (panel === 'detail' ? -dx : dx)));
      if (panel === 'list' && listPanelRef.current) {
        listPanelRef.current.style.width = newW + 'px';
      } else if (panel === 'detail' && detailPanelRef.current) {
        detailPanelRef.current.style.width = newW + 'px';
      }
      panelWidthsRef.current = {...panelWidthsRef.current, [panel]: newW};
    };
    const onUp = () => {
      // Vrni pointer events in cursor
      document.querySelectorAll('iframe').forEach((f: any) => f.style.pointerEvents = '');
      document.body.style.cursor = '';
      setPanelWidths({...panelWidthsRef.current});
      localStorage.setItem('aicount_panel_widths', JSON.stringify(panelWidthsRef.current));
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  };

  const setPdfOdprtoShranjeno = (v: boolean) => {
    setPdfOdprto(v);
    localStorage.setItem('aicount_pdf_odprto', v ? 'true' : 'false');
  };

  useEffect(()=>{
    return () => { localStorage.removeItem('aicount_pdf_doc'); };
  }, []);

  useEffect(()=>{
    if(selectedCompany){
      setCompanyId(selectedCompany.id);
      api.get(`/profil/${selectedCompany.id}`).then(r=>{setDdvKonti(r.data?.ddv_konti||{});setIzvozProgram(r.data?.izvoz_program||'vasco');setPlacnikProfil(r.data?.placnik_delavec||{});setPlacnikProfilIzd(r.data?.placnik_delavec_izdani||{});}).catch(()=>setDdvKonti({}));  // [PATCH placnik-saldakonto-pogoj v1] isti klic, brez novega prometa
    } else {
      setCompanyId('');
    }
  },[selectedCompany]);

  useEffect(()=>{
    if(companyId){
      setSelected(null);
      setKontiranje(null);
      localStorage.removeItem('aicount_pdf_doc');
      api.get(`/dokumenti/${companyId}/sekvenca/${aktivniTip}`).then(r=>setSekvenca(r.data)).catch(()=>{});
    }
  },[aktivniTip, companyId]);

  const naloziUvozZap=async(cid:string)=>{ /* [PATCH uvoz-zaporedje v1] */ try{const r=await api.get(`/dokumenti/${cid}/batch-zaporedje`);if(useAuthStore.getState().selectedCompany?.id!==cid){return;}setUvozZap(r.data||{});}catch{setUvozZap({});} };
  const naloziDokumente=async(cid:string, tip?:string, q?:string)=>{
    const t=tip||aktivniTip;
    try{const r=await api.get(`/dokumenti/${cid}?tip=${t}&limit=${limitSezRef.current}${stanjeQS()}${q&&q.trim()?`&q=${encodeURIComponent(q.trim())}`:''}`);if(useAuthStore.getState().selectedCompany?.id!==cid){return;}setDokumenti(r.data.map(obogatiIzdani));naloziUvozZap(cid); /* [PATCH uvoz-zaporedje v1] */}catch{} // [PATCH ir3a-fix2 v1]
  };

  useEffect(()=>{
    if(companyId) api.get(`/sifranti/kontni-plan/${companyId}`).then(r=>setKontiPlan(r.data)).catch(()=>{});
  },[companyId]);
  // debounce iskanje
  useEffect(()=>{
    if(!companyId)return;
    const t=setTimeout(()=>{naloziDokumente(companyId, aktivniTip, iskanje);},300);
    return ()=>clearTimeout(t);
  },[iskanje]);
  // [PATCH zivo-osvezevanje v1] seznam se osvezi ob vrnitvi fokusa in periodicno.
  // Osvezi se SAMO seznam (naloziDokumente); `selected` in `kontiranje`
  // ostaneta nedotaknjena, zato osvezitev ne povozi dela v maski.
  // Preskoci se, kadar okno ni vidno ali kadar je odprta uvozna maska.
  // [PATCH opombe-stranka-fe v1] oznake opomb v seznamu (racunovodja: odprta/odgovorjena, stranka: odprta) + odpiranje ?opomba_doc=
  const [opombeStatus,setOpombeStatus]=useState<Record<string,string>>({});
  const [opombeNaVoljo,setOpombeNaVoljo]=useState<boolean>(false); /* [PATCH opombe-pogoj v1] prejeti samo ob stranki z Nabavo */

  /* [PATCH ai-preverbe-fe v1] Python preverbe prejetih (samo branje): racunovodja, samo podjetja v ai.vklop */
  const [aiVklop,setAiVklop]=useState<boolean>(false);
  const [aiZnacke,setAiZnacke]=useState<Record<string,string>>({});
  const [aiPrev,setAiPrev]=useState<any>(null);
  const [aiPrevNal,setAiPrevNal]=useState<boolean>(false);
  const aiJePrejeti=(d:any)=>d?.doc_type==='prejeti_racun'||d?.doc_type==='credit_note';
  useEffect(()=>{ let ziv=true; setAiVklop(false); if(!companyId||jeStranka) return; api.get(`/ai-preverbe/${companyId}/vklop`).then((r:any)=>{ if(ziv) setAiVklop(!!r.data?.aktiven); }).catch(()=>{}); return ()=>{ ziv=false; }; },[companyId,jeStranka]);
  useEffect(()=>{ if(!aiVklop||!companyId){ setAiZnacke({}); return; } const ids=(dokumenti||[]).filter(aiJePrejeti).map((d:any)=>String(d.id)).slice(0,500); if(!ids.length) return; let ziv=true; api.post(`/ai-preverbe/${companyId}/znacke`,{ids}).then((r:any)=>{ if(ziv) setAiZnacke(r.data?.znacke||{}); }).catch(()=>{}); return ()=>{ ziv=false; }; },[aiVklop,companyId,dokumenti]);
  useEffect(()=>{ setAiPrev(null); if(!aiVklop||!companyId||!selected?.id||selected?._rocni||!aiJePrejeti(selected)) return; let ziv=true; setAiPrevNal(true); api.get(`/ai-preverbe/${companyId}/${selected.id}`).then((r:any)=>{ if(ziv) setAiPrev(r.data); }).catch(()=>{}).finally(()=>{ if(ziv) setAiPrevNal(false); }); return ()=>{ ziv=false; }; },[aiVklop,companyId,selected]);
  useEffect(()=>{
    if(!companyId||jeStranka){setOpombeNaVoljo(false);return;}
    let ziv=true;
    api.get(`/opombe/${companyId}/na-voljo`).then((r:any)=>{ if(ziv) setOpombeNaVoljo(!!r.data?.prejeti); }).catch(()=>{ if(ziv) setOpombeNaVoljo(false); });
    return ()=>{ ziv=false; };
  },[companyId, jeStranka]);
  useEffect(()=>{
    if(!companyId){setOpombeStatus({});return;}
    let ziv=true;
    const nalozi=async()=>{
      try{
        const m:Record<string,string>={};
        if(jeStranka){
          const r=await api.get(`/stranka/${companyId}/opombe/stevec`);
          (r.data?.doc_ids||[]).forEach((id:string)=>{m[id]='odprta';});
        }else{
          const r=await api.get(`/opombe/${companyId}/odprte`);
          (r.data||[]).forEach((x:any)=>{ if(!m[x.document_id]||x.status==='odgovorjena') m[x.document_id]=x.status; });
        }
        if(ziv) setOpombeStatus(m);
      }catch{ if(ziv) setOpombeStatus({}); }
    };
    nalozi();
    const ob=()=>nalozi();
    window.addEventListener(OPOMBE_DOGODEK, ob);
    const iv=setInterval(()=>{ if(document.visibilityState==='visible') nalozi(); },10000); /* [PATCH opombe-osvezevanje v1] */
    return ()=>{ ziv=false; window.removeEventListener(OPOMBE_DOGODEK, ob); clearInterval(iv); };
  },[companyId, jeStranka]);
  useEffect(()=>{
    const id=searchParams.get('opomba_doc'); if(!id||!dokumenti.length) return;
    const d=dokumenti.find((x:any)=>x.id===id);
    const sp=new URLSearchParams(searchParams); sp.delete('opomba_doc'); setSearchParams(sp,{replace:true});
    if(d) izberiDokument(d); else toast('Račun ni na trenutnem seznamu — poiščite ga v seznamu.');
    // eslint-disable-next-line
  },[searchParams, dokumenti]);
  const OSVEZI_MS = 30000;
  useEffect(()=>{
    if(!companyId) return;
    const osvezi=()=>{
      if(document.visibilityState!=='visible') return;
      if(showSop||showUpload) return;
      naloziDokumente(companyId, aktivniTip, iskanje);
    };
    window.addEventListener('focus', osvezi);
    document.addEventListener('visibilitychange', osvezi);
    const iv=setInterval(osvezi, OSVEZI_MS);
    return ()=>{
      window.removeEventListener('focus', osvezi);
      document.removeEventListener('visibilitychange', osvezi);
      clearInterval(iv);
    };
    // eslint-disable-next-line
  },[companyId, aktivniTip, iskanje, showSop, showUpload]);
  const izvoziVasco=async()=>{
    if(!companyId){toast.error('Izberite podjetje');return;}
    try{
      const r=await api.get(`/izvoz/vasco/${companyId}?leto=${izvozLeto}&mesec=${izvozMesec}`,{responseType:'blob'});
      const url=window.URL.createObjectURL(new Blob([r.data]));
      // [PATCH kn21-ui-ime v1] ime iz Content-Disposition (backend prefiks PREJETI_/IZDANI_)
      const _cd=String(r.headers?.['content-disposition']||'');
      const _m=_cd.match(/filename="?([^";]+)"?/i);
      const a=document.createElement('a');
      a.href=url; a.download=_m?_m[1]:`KN21_${izvozLeto}_${String(izvozMesec).padStart(2,'0')}.xml`; // [PATCH kn21-ui-ime v1]
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Izvoz pripravljen');
    }catch(e:any){
      if(e.response?.status===404) toast.error('Ni potrjenih dokumentov za to obdobje');
      else toast.error('Izvoz ni uspel');
    }
  };

  // [PATCH bizbox-prevzem v1] + [PATCH bizbox-prevzem v2] — prejem iz bizBox ePredala
  const epPrevzem=async()=>{
    if(epBusy)return;
    setEpBusy(true);
    const t=toast.loading('Prevzemam iz ePredala...');
    try{
      const r=await api.post(`/bizbox/${companyId}/prevzem`);
      const d=r.data||{};
      toast.dismiss(t);
      if((d.prevzeto||0)===0&&(d.napak||0)===0&&(d.preskoceno||0)===0){
        if((d.starejsi_od_datuma||0)>0)toast(`Ni novih dokumentov; starejših od nastavljenega datuma: ${d.starejsi_od_datuma}.`,{icon:'\ud83d\udced'}); // [PATCH bizbox-prevzem v7]
        else if((d.ze_obdelano||0)>0)toast(`Ni novih dokumentov (že obdelani: ${d.ze_obdelano}).`,{icon:'\ud83d\udced'});
        else toast('ePredal je prazen.',{icon:'\ud83d\udced'});
      }else{
        if((d.starejsi_od_datuma||0)>0)toast(`Starejši od datuma (ostanejo v ePredalu): ${d.starejsi_od_datuma}`,{icon:'\u23f3'});
        if(d.prevzeto>0)toast.success(`Prevzeto iz ePredala: ${d.prevzeto}`);
        if(d.preskoceno>0)toast(`Preskočeno (paket brez računa): ${d.preskoceno}`,{icon:'\u26a0\ufe0f'});
        if(d.napak>0)toast.error(`Napaka: ${(d.napake&&d.napake[0]&&d.napake[0].napaka)||d.napak}`);
      }
      naloziDokumente(companyId, aktivniTip);
    }catch(e:any){
      toast.dismiss(t);
      if(e.response?.status===409){ setEpModal(true); }
      else if(e.response?.status===401){ setEpModal(true); toast.error(e.response?.data?.detail||'Prijava ni uspela'); }
      else toast.error(e.response?.data?.detail||'Prevzem iz ePredala ni uspel');
    }finally{setEpBusy(false);}
  };
  const uvozIzEPredala=async()=>{
    if(!companyId){toast.error('Izberite podjetje');return;}
    if(epBusy)return;
    try{
      const s=await api.get(`/bizbox/${companyId}/status`);
      if(!s.data?.nastavljeno){
        setEpUser(s.data?.uporabnik||'');
        setEpOkolje(s.data?.okolje==='prod'?'prod':'demo');
        setEpNastavljeno(false);
        setEpPass('');
        setEpModal(true);
        return;
      }
    }catch{ setEpModal(true); return; }
    await epPrevzem();
  };
  const epShraniInPrevzemi=async()=>{
    if(!epUser.trim()){toast.error('Vnesite uporabniško ime');return;}
    if(!epPass&&!epNastavljeno){toast.error('Vnesite geslo');return;}
    try{
      await api.post(`/bizbox/${companyId}/poverilnice`,
        {uporabnik:epUser.trim(),geslo:epPass,okolje:epOkolje});
      setEpModal(false);setEpPass('');
      toast.success('Poverilnice shranjene');
      await epPrevzem();
    }catch(e:any){
      toast.error(e.response?.data?.detail||'Shranjevanje ni uspelo');
    }
  };
  /* [PATCH vod-uvoz-fe v1] predogled NICESAR ne zapise; izvedba pise.
     vodZnesek je lasten, da patch ni odvisen od obstoja pomozne fmt(). */
  const vodZnesek=(x:any)=>Number(x||0).toLocaleString('sl-SI',{minimumFractionDigits:2,maximumFractionDigits:2});
  const [vkrMaska,setVkrMaska]=useState<File|null>(null); // [PATCH miniblagajna-fe v1] datoteka, ki caka na Nastavitve za VKR (409)
  const vodOdpri=()=>{
    setVodOpen(true); setVodPredogled(null); setVodPorocilo(null);
    setVodFile(null); setVodVse(false);
  };
  const vodPreberi=async(f:File)=>{
    if(!companyId){toast.error('Izberite podjetje');return;}
    setVodBusy(true); setVodPredogled(null); setVodPorocilo(null);
    try{
      const fd=new FormData(); fd.append('file',f);
      const r=await api.post(`/uvoz-vod/${companyId}/predogled`,fd,{headers:{'Content-Type':'multipart/form-data'}});
      setVodPredogled(r.data); setVodFile(f);
    }catch(e:any){
      if(e.response?.status===409&&e.response?.data?.detail?.koda==='vkr_nastavitve'){ /* [PATCH miniblagajna-fe v1] prvi uvoz Mini blagajne -> maska */
        toast.error(e.response.data.detail.sporocilo||'Izpolni Nastavitve za VKR'); setVkrMaska(f); setVodFile(null); return;
      }
      toast.error(e.response?.data?.detail||'Datoteke ni bilo mogoče prebrati');
      setVodFile(null);
    }finally{ setVodBusy(false); }
  };
  const vodUvozi=async()=>{
    if(!companyId||!vodFile) return;
    setVodBusy(true);
    try{
      const fd=new FormData();
      fd.append('file',vodFile);
      fd.append('ustvari_partnerje',vodUstvari?'true':'false');
      const r=await api.post(`/uvoz-vod/${companyId}/izvedi`,fd,{headers:{'Content-Type':'multipart/form-data'}});
      setVodPorocilo(r.data); setVodPredogled(null);
      toast.success(`Uvoženih ${r.data.uvozenih} računov`);
      naloziDokumente(companyId, aktivniTip);
    }catch(e:any){
      toast.error(e.response?.data?.detail?.sporocilo||e.response?.data?.detail||'Napaka pri uvozu'); /* [PATCH miniblagajna-fe v1] */
    }finally{ setVodBusy(false); }
  };

  /* [PATCH izdani-eslog-uvoz-fe v1] uvoz izdanih e-racunov (e-SLOG 2.0/1.6, XML+PDF, posamezno ali ZIP).
     Predogled NICESAR ne zapise; izvedba pise (isti tok kot sop izdanih -> Za prenos). */
  const [eslOpen,setEslOpen]=useState(false);
  const [eslBusy,setEslBusy]=useState(false);
  const [eslFiles,setEslFiles]=useState<File[]>([]);
  const [eslPredogled,setEslPredogled]=useState<any>(null);
  const [eslPorocilo,setEslPorocilo]=useState<any>(null);
  const eslOdpri=()=>{ setEslOpen(true); setEslFiles([]); setEslPredogled(null); setEslPorocilo(null); };
  const eslFd=(fs:File[])=>{ const fd=new FormData(); fs.forEach(f=>fd.append('files',f)); return fd; };
  const eslNapaka=(e:any,privzeto:string)=>{ const d=e?.response?.data?.detail; return typeof d==='string'?d:(d?.sporocilo||privzeto); };
  const eslPreberi=async(fs:File[])=>{
    if(!companyId){toast.error('Izberite podjetje');return;}
    if(!fs.length) return;
    setEslBusy(true); setEslPredogled(null); setEslPorocilo(null);
    try{
      const r=await api.post(`/uvoz-eslog/${companyId}/predogled`,eslFd(fs),{headers:{'Content-Type':'multipart/form-data'},timeout:600000});
      setEslPredogled(r.data); setEslFiles(fs);
    }catch(e:any){ toast.error(eslNapaka(e,'Datotek ni bilo mogoče prebrati')); setEslFiles([]); }
    finally{ setEslBusy(false); }
  };
  const eslUvozi=async()=>{
    if(!companyId||!eslFiles.length) return;
    setEslBusy(true);
    try{
      const r=await api.post(`/uvoz-eslog/${companyId}/izvedi`,eslFd(eslFiles),{headers:{'Content-Type':'multipart/form-data'},timeout:600000});
      setEslPorocilo(r.data); setEslPredogled(null);
      toast.success(`Uvoženih ${r.data.uvozenih} računov`);
      naloziDokumente(companyId, aktivniTip);
    }catch(e:any){ toast.error(eslNapaka(e,'Napaka pri uvozu')); }
    finally{ setEslBusy(false); }
  };
  const ESL_STATUS:any={validated:'potrjen',review_needed:'v pregled',preskocen:'preskočen',dvojnik:'že obstaja'};

  const uploadSop=async(file:File)=>{
    if(!companyId){toast.error('Izberite podjetje');return;}
    setSopBusy(true);setSopBatch(null);
    try{
      const fd=new FormData();fd.append('file',file);
      // premor=2 zaradi Azure F0; po prehodu na S0 nastavi na 0
      const r=await api.post(`/dokumenti/${companyId}/batch?premor=0&doc_type=${aktivniTip}`,fd,{headers:{'Content-Type':'multipart/form-data'}});
      const batchId=r.data.batch_id;
      toast.success('Šop sprejet, obdelava poteka v ozadju...');
      /* [PATCH sop-napredek-fe v1] polling se je preselil v uploadStore:
         tece tudi ob zaprtem oknu in prezivi osvezitev strani. Zakljucek
         (osvezitev seznama + toast) obravnava ucinek nad zakljucenOb. */
      useUploadStore.getState().zacniSop(companyId, batchId, selectedCompany?.name||'', aktivniTip);
      setSopBusy(false);
      return batchId;   /* [PATCH uvoz-iz-mape v3] klicalci lahko ignorirajo */
    }catch(e:any){
      toast.error(e.response?.data?.detail||'Napaka pri uvozu šopa');
      setSopBusy(false);
      return null;   /* [PATCH uvoz-iz-mape v3] */
    }
  };

  // ===== [PATCH sop-multi-fe v1] uvoz VEC datotek naenkrat =====
  // Stara pot uploadSop (en PDF -> /batch) je NEDOTAKNJENA in se se vedno
  // uporabi, kadar je izbrana natanko ena PDF datoteka. Vse ostalo gre na
  // /batch-multi: .doc/.docx se pretvorijo prek gotenberga, izdani se spojijo
  // v en sop (razrez po stevilkah), prejeti dobijo en dokument na datoteko.
  /* [PATCH sop-napredek-fe v1] sopPoll odstranjen — polling je v
     uploadStore.zacniSop (en sam vir resnice za obe uvozni poti). */
  const uploadSopMulti=async(files:File[])=>{
    if(!companyId){toast.error('Izberite podjetje');return;}
    if(!files||!files.length) return;
    setSopBusy(true);setSopBatch(null);
    try{
      const fd=new FormData();
      files.forEach(f=>fd.append('files',f));
      const r=await api.post(`/dokumenti/${companyId}/batch-multi?premor=0&doc_type=${aktivniTip}`,fd,{headers:{'Content-Type':'multipart/form-data'}});
      toast.success(`Sprejetih ${r.data.st_datotek||files.length} datotek — priprava poteka v ozadju...`);
      /* [PATCH sop-napredek-fe v1] */
      useUploadStore.getState().zacniSop(companyId, r.data.batch_id, selectedCompany?.name||'', aktivniTip);
      setSopBusy(false);
      return r.data.batch_id;   /* [PATCH uvoz-iz-mape v3] */
    }catch(e:any){
      toast.error(e.response?.data?.detail||'Napaka pri uvozu datotek');
      setSopBusy(false);
      return null;   /* [PATCH uvoz-iz-mape v3] */
    }
  };
  // ===== [PATCH uvoz-iz-mape v3] nastavitev mape + premik NALOZENIH datotek =====
  // Zasnova (odlocitev Janez, 30.07.2026):
  //   - mapa se nastavi V OKNU 'Uvoz racunov', loceno za prejete in izdane
  //   - rocica mape zivi v IndexedDB pod kljucem companyId|aktivniTip
  //   - datoteke izbere uporabnik sam (kot doslej); po uspesnem sprejemu se
  //     premaknejo SAMO tiste, ki jih je poslal — ujemanje ime + velikost
  //   - mapa ni nastavljena => uvoz tece tocno kot prej, nic se ne premika
  // File System Access API je samo v Chromiumu; drugod se vrstica ne izrise.
  const fsaNaVoljo = typeof window!=='undefined' && 'showDirectoryPicker' in window;
  const [mapaRocica,setMapaRocica]=useState<any>(null);
  const [mapaIme,setMapaIme]=useState<string>('');

  const mapaKljuc=()=>String(companyId||'')+'|'+String(aktivniTip||'');
  const mapaDbOdpri=():Promise<any>=>new Promise((res,rej)=>{
    const q=indexedDB.open('aicount-mape',1);
    q.onupgradeneeded=()=>{const db=q.result; if(!db.objectStoreNames.contains('rocice')) db.createObjectStore('rocice');};
    q.onsuccess=()=>res(q.result);
    q.onerror=()=>rej(q.error);
  });
  const mapaShrani=async(h:any)=>{
    const db=await mapaDbOdpri();
    await new Promise((res,rej)=>{const t=db.transaction('rocice','readwrite');
      t.objectStore('rocice').put(h,mapaKljuc()); t.oncomplete=()=>res(null); t.onerror=()=>rej(t.error);});
    db.close();
  };
  const mapaBeri=async():Promise<any>=>{
    const db=await mapaDbOdpri();
    const v=await new Promise<any>((res,rej)=>{const t=db.transaction('rocice','readonly');
      const r=t.objectStore('rocice').get(mapaKljuc()); r.onsuccess=()=>res(r.result||null); r.onerror=()=>rej(r.error);});
    db.close(); return v;
  };
  /* [PATCH uvoz-iz-mape v4] odstranitev nastavitve: brez rocice program mape
     ne more odpreti, zato se datoteke ne premikajo vec in uvoz tece kot pred
     nastavitvijo. Dovoljenja Chromu ni mogoce preklicati (API za to ne
     obstaja) — brez rocice je brez ucinka. */
  const mapaBrisi=async()=>{
    const db=await mapaDbOdpri();
    await new Promise((res,rej)=>{const t=db.transaction('rocice','readwrite');
      t.objectStore('rocice').delete(mapaKljuc()); t.oncomplete=()=>res(null); t.onerror=()=>rej(t.error);});
    db.close();
  };
  const odstraniMapo=async()=>{
    try{
      await mapaBrisi();
      setMapaRocica(null); setMapaIme('');
      toast.success('Mapa odstranjena — datoteke se ne bodo vec premikale');
    }catch(e:any){
      toast.error('Mape ni bilo mogoce odstraniti: '+String(e?.message||e));
    }
  };

  // ob menjavi podjetja/zavihka in ob odprtju okna preberi shranjeno rocico
  useEffect(()=>{
    let ziv=true;
    (async()=>{
      if(!fsaNaVoljo||!companyId){ if(ziv){setMapaRocica(null);setMapaIme('');} return; }
      try{
        const h=await mapaBeri();
        if(!ziv) return;
        setMapaRocica(h||null); setMapaIme(h?String(h.name||''):'');
      }catch(e:any){ if(ziv){setMapaRocica(null);setMapaIme('');} }
    })();
    return ()=>{ziv=false;};
  },[companyId,aktivniTip,showSop]);

  const nastaviMapo=async()=>{
    if(!companyId){toast.error('Izberite podjetje');return;}
    if(!fsaNaVoljo){toast.error('Ta brskalnik ne podpira izbire mape — uporabite Chrome ali Edge');return;}
    // Chrome zavrne id, daljsi od 32 znakov (dokazano 30.07.2026, TypeError).
    // Predpona 'sp'/'si' loci prejete od izdanih => brskalnik si zapomni obe mapi.
    const mapaId=('s'+(String(aktivniTip||'').startsWith('izdani')?'i':'p')
      +String(companyId).replace(/[^a-zA-Z0-9]/g,'')).slice(0,32);
    let h:any=null;
    try{
      h=await (window as any).showDirectoryPicker({id:mapaId, mode:'readwrite'});
    }catch(e:any){
      // tiho SAMO ob preklicu; vsaka druga napaka mora biti vidna
      if(!e||e.name!=='AbortError') toast.error('Mape ni bilo mogoce odpreti: '+(e?.name||'napaka')+' — '+String(e?.message||e));
      return;
    }
    try{
      await mapaShrani(h); setMapaRocica(h); setMapaIme(String(h.name||''));
      toast.success('Mapa nastavljena: '+String(h.name||''));
    }catch(e:any){
      toast.error('Mape ni bilo mogoce shraniti: '+String(e?.message||e));
    }
  };

  // Dovoljenje se zahteva TAKOJ ob izbiri datotek, dokler velja uporabnikova
  // poteza — po cakanju na upload bi requestPermission lahko odpovedal.
  const mapaPripravi=async():Promise<boolean>=>{
    if(!fsaNaVoljo||!mapaRocica) return false;
    try{
      let st:any = mapaRocica.queryPermission ? await mapaRocica.queryPermission({mode:'readwrite'}) : 'granted';
      if(st!=='granted'&&mapaRocica.requestPermission) st=await mapaRocica.requestPermission({mode:'readwrite'});
      if(st!=='granted'){
        toast.error('Dostop do mape ni dovoljen — datoteke ostanejo v mapi. Po potrebi mapo nastavi znova.');
        return false;
      }
      return true;
    }catch(e:any){
      toast.error('Mape ni bilo mogoce preveriti: '+String(e?.message||e));
      return false;
    }
  };

  const mapaProstoIme=async(ciljDir:any, ime:string):Promise<string>=>{
    const pika=ime.lastIndexOf('.');
    const baza=pika>0?ime.slice(0,pika):ime;
    const kon=pika>0?ime.slice(pika):'';
    let kandidat=ime;
    for(let i=2;i<50;i++){
      try{ await ciljDir.getFileHandle(kandidat); }catch(e:any){ return kandidat; }
      kandidat=baza+' ('+i+')'+kon;
    }
    return baza+' ('+Date.now()+')'+kon;
  };

  // premik ene datoteke; brisanje SELE po zapisani in zaprti kopiji
  const mapaPremakni=async(izvorDir:any, ciljDir:any, h:any)=>{
    const ime=String(h.name);
    const prosto=await mapaProstoIme(ciljDir, ime);
    if(typeof h.move==='function'){ await h.move(ciljDir, prosto); return; }
    const f=await h.getFile();
    const nov=await ciljDir.getFileHandle(prosto,{create:true});
    const w=await nov.createWritable();
    await w.write(f); await w.close();
    await izvorDir.removeEntry(ime);
  };

  // Premakne SAMO poslane datoteke. Ujemanje ime + velikost: brskalnik pri
  // navadni izbiri datotek poti ne izda, zato je to edini razpolozljivi kljuc.
  const premakniPoslane=async(poslane:File[])=>{
    if(!mapaRocica||!poslane||!poslane.length) return;
    try{
      const d=new Date();
      const mesec=d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0');
      const koren=await mapaRocica.getDirectoryHandle('_UVOZENO',{create:true});
      const cilj=await koren.getDirectoryHandle(mesec,{create:true});
      let premaknjenih=0;
      const nenajdene:string[]=[]; const drugacne:string[]=[]; const spodletele:string[]=[];
      for(const f of poslane){
        let h:any=null;
        try{ h=await mapaRocica.getFileHandle(f.name); }
        catch(e:any){ nenajdene.push(f.name); continue; }
        try{
          const vMapi=await h.getFile();
          if(Number(vMapi.size)!==Number(f.size)){ drugacne.push(f.name); continue; }
        }catch(e:any){ nenajdene.push(f.name); continue; }
        try{ await mapaPremakni(mapaRocica, cilj, h); premaknjenih++; }
        catch(e:any){ spodletele.push(f.name); }
      }
      const deli:string[]=[];
      if(premaknjenih) deli.push('premaknjenih '+premaknjenih);
      if(nenajdene.length) deli.push('ni v mapi: '+nenajdene.length);
      if(drugacne.length) deli.push('drugacna velikost: '+drugacne.length);
      if(spodletele.length) deli.push('premik ni uspel: '+spodletele.length);
      const sporocilo='_UVOZENO / '+mesec+' — '+(deli.length?deli.join(', '):'nic za premik');
      if(nenajdene.length||drugacne.length||spodletele.length) toast.error(sporocilo);
      else toast.success(sporocilo);
    }catch(e:any){
      toast.error('Premik v _UVOZENO ni uspel: '+String(e?.message||e));
    }
  };
  // ===== [PATCH uvoz-iz-mape v3] konec =====

  // ===== [PATCH razveljavi-uvoz-fe v1] razveljavitev uvoza sopa =====
  // ===== [PATCH razveljavi-uvoz-fe v1] razveljavitev (parametricno: [PATCH nedavni-uvozi-fe v1]) =====
  const odpriRazveljavitev=async(batchId:string)=>{
    if(!batchId||!companyId) return;
    setRazvBatchId(batchId);
    setRazvBusy(true);
    try{
      const r=await api.get(`/dokumenti/${companyId}/batch/${batchId}/razveljavitev-info`);
      setRazvInfo(r.data);
      setRazvOpen(true);
    }catch(e:any){
      toast.error(e.response?.data?.detail||'Napaka pri pripravi razveljavitve');
    }finally{ setRazvBusy(false); }
  };
  const izvediRazveljavitev=async(obseg:string)=>{
    if(!razvBatchId||!companyId) return;
    setRazvBusy(true);
    try{
      const r=await api.post(`/dokumenti/${companyId}/batch/${razvBatchId}/razveljavi?obseg=${obseg}`);
      toast.success(`Razveljavljeno: ${r.data.st_izbrisanih} dokumentov`);
      setRazvOpen(false); setBlokData(null);
      setNedavni((cur:any[])=>cur.map(b=>b.batch_id===razvBatchId?{...b,status:'razveljavljen'}:b));
      if(sopBatch?.batch_id===razvBatchId){ setShowSop(false); setSopBatch(null); }
      naloziDokumente(companyId, aktivniTip);
    }catch(e:any){
      const det=e.response?.data?.detail;
      if(e.response?.status===409 && det && det.koda==='blokade'){
        setBlokObseg(obseg); setBlokData(det); setRazvOpen(false);
      }else{
        toast.error(typeof det==='string'?det:'Razveljavitev ni uspela');
      }
    }finally{ setRazvBusy(false); }
  };
  const oznaciNeprenoseno=async(docId:string)=>{
    if(!companyId) return;
    try{
      await api.put(`/dokumenti/${companyId}/razveljavitev/neprenoseno/${docId}`);
      setBlokData((cur:any)=> cur? {...cur, preneseni:(cur.preneseni||[]).filter((d:any)=>d.doc_id!==docId)} : cur);
      toast.success('Označeno kot neprenešeno');
    }catch(e:any){
      toast.error(e.response?.data?.detail||'Napaka');
    }
  };
  const odpriNedavne=async()=>{
    if(!companyId) return;
    setNedavniBusy(true); setNedavniOpen(true);
    try{
      const r=await api.get(`/dokumenti/${companyId}/batch`);
      setNedavni(Array.isArray(r.data)?r.data.filter((b:any)=>b.doc_type===aktivniTip):[]);
    }catch(e:any){
      toast.error(e.response?.data?.detail||'Napaka pri branju uvozov');
      setNedavni([]);
    }finally{ setNedavniBusy(false); }
  };
  // ===== [PATCH prestevilci-sop-fe v1] interno preštevilčenje šopa =====
  const odpriPrestevilcenje=async(batchId:string)=>{
    if(!batchId||!companyId) return;
    setPrestBusy(true);
    try{
      const r=await api.get(`/dokumenti/${companyId}/batch/${batchId}/prestevilcenje-info`);
      setPrestBatchId(batchId); setPrestInfo(r.data); setPrestVnos({}); setPrestNapake(null); setPrestOpen(true);
    }catch(e:any){
      const det=e.response?.data?.detail;
      toast.error(typeof det==='string'?det:'Napaka pri pripravi preštevilčenja');
    }finally{ setPrestBusy(false); }
  };
  const izvediPrestevilcenje=async()=>{
    if(!prestBatchId||!companyId||!prestInfo) return;
    const serije=(prestInfo.serije||[])
      .filter((s:any)=>String(prestVnos[s.serija]??'').trim()!=='')
      .map((s:any)=>({serija:s.serija, zacetna_st:parseInt(String(prestVnos[s.serija]).trim(),10)}));
    if(serije.length===0){ toast.error('Vpišite začetno številko vsaj za eno serijo'); return; }
    if(serije.some((s:any)=>!Number.isInteger(s.zacetna_st)||s.zacetna_st<1)){ toast.error('Začetna številka mora biti celo število ≥ 1'); return; }
    setPrestBusy(true); setPrestNapake(null);
    try{
      const r=await api.post(`/dokumenti/${companyId}/batch/${prestBatchId}/prestevilci`,{serije});
      const opis=(r.data.serije||[]).map((x:any)=>`${x.serija||'brez serije'}: ${x.od}–${x.do}`).join(', ');
      toast.success(`Preštevilčeno (${opis})`);
      setPrestOpen(false); setPrestInfo(null);
      naloziDokumente(companyId, aktivniTip);
    }catch(e:any){
      const det=e.response?.data?.detail;
      if(e.response?.status===409 && det && det.koda==='prestevilcenje_blokade'){ setPrestNapake(det); }
      else{ toast.error(typeof det==='string'?det:'Preštevilčenje ni uspelo'); }
    }finally{ setPrestBusy(false); }
  };
  const prestOznaciNeprenoseno=async(docId:string)=>{
    if(!companyId) return;
    try{
      await api.put(`/dokumenti/${companyId}/razveljavitev/neprenoseno/${docId}`);
      setPrestNapake((cur:any)=> cur? {...cur, izvozeni:(cur.izvozeni||[]).filter((d:any)=>d.doc_id!==docId)} : cur);
      setPrestInfo((cur:any)=> cur? {...cur, serije:(cur.serije||[]).map((s:any)=>({...s, izvozeni:(s.izvozeni||[]).filter((d:any)=>d.doc_id!==docId)}))} : cur);
      toast.success('Označeno kot neprenešeno');
    }catch(e:any){
      toast.error(e.response?.data?.detail||'Napaka');
    }
  };
  // ===== konec [PATCH prestevilci-sop-fe v1] funkcije =====
  // ===== konec [PATCH razveljavi-uvoz-fe v1] =====
  const onDrop=useCallback((files:File[])=>{
    if(!companyId){toast.error('Izberite podjetje');return;}
    /* [PATCH sop-napredek-fe v1] hkrati je dovoljen SAMO EN uvoz na podjetje.
       Beremo prek getState(), da varovalka ni odvisna od zastarelega closura. */
    {
      const _us:any=useUploadStore.getState();
      if(_us.sopPoPodjetju[companyId]&&_us.sopPoPodjetju[companyId].aktiven){toast.error('Uvoz že poteka — počakajte, da se konča.');return;}
      if(_us.poPodjetju[companyId]&&_us.poPodjetju[companyId].aktiven){toast.error('Uvoz že poteka — počakajte, da se konča.');return;}
    }
    // [PATCH ir3a-odklep v1] izdani gredo IZKLJUCNO prek sopa (razrez po stevilkah)
    if(aktivniTip==='izdani_racun'){
      // [PATCH sop-multi-fe v1] izdani: vec datotek + Word (prej samo EN PDF)
      const _ok=files.filter(f=>/\.(pdf|docx?)$/i.test(f.name));
      if(!_ok.length){toast.error('Podprti so PDF, .doc in .docx.');return;}
      setShowUpload(false); setShowSop(true); setSopBatch(null);
      if(_ok.length===1&&/\.pdf$/i.test(_ok[0].name)) uploadSop(_ok[0]); else uploadSopMulti(_ok);
      return;
    }
    // [PATCH sop-multi-fe v1] prejeti: Word gre na /batch-multi — ozadnji uploader
    // pozna samo PDF/slike/XML. Cist PDF/slikovni nabor ostane na stari poti.
    if(files.some(f=>/\.docx?$/i.test(f.name))){
      setShowUpload(false); setShowSop(true); setSopBatch(null); uploadSopMulti(files); return;
    }
    useUploadStore.getState().zazeniUvoz(companyId, files, aktivniTip, selectedCompany?.name||'');
    setShowUpload(false);
  },[companyId, aktivniTip, selectedCompany]);

  const {getRootProps,getInputProps,isDragActive}=useDropzone({
    onDrop,accept:{'application/pdf':['.pdf'],'image/*':['.jpg','.jpeg','.png'],'text/xml':['.xml'],'application/msword':['.doc'],'application/vnd.openxmlformats-officedocument.wordprocessingml.document':['.docx']}, // [PATCH sop-multi-fe v1]
  });
  // osvezitev: vezana na izbrano podjetje (takoj ob preklopu) + sprotno med uvozom (koncano)
  const selUvozId=useAuthStore(s=>s.selectedCompany?.id||'');
  const uploadKoncano=useUploadStore(s=>selUvozId?(s.poPodjetju[selUvozId]?.koncano??0):0);
  useEffect(()=>{
    if(!selUvozId) return;
    setDokumenti([]);
    setNalagam(true);
    naloziDokumente(selUvozId, aktivniTip).finally(()=>setNalagam(false));
  },[selUvozId, aktivniTip]);
  const zadnjiNalozen=useUploadStore(s=>s.zadnjiNalozen);
  useEffect(()=>{
    if(!zadnjiNalozen || zadnjiNalozen.companyId!==selUvozId) return;
    const _d=zadnjiNalozen.doc;
    if(!_d||!_d.id) return;
    setDokumenti((prev:any)=> prev.some((x:any)=>x.id===_d.id) ? prev : [_d, ...prev]);
  },[zadnjiNalozen]);
  // [PATCH ir3a-fix2 v1] izdani: parser kljuci (znesek_z_ddv, datum_izdaje...) ->
  // PR oblika (ocr.zneski/ocr.datumi), ki jo bereta kartica in detail
  const obogatiIzdani=(d:any)=>{
    if(!jeIzdaniTip(d?.doc_type)||!d?.ocr) return d;
    const o=d.ocr;
    // [PATCH ir4a-ui-zneski v1] parser vcasih ne prebere povzetkov (00401/00406)
    // -> prikaz jih obnovi iz ddv_spec (ista logika kot backend ir4a-zneski v2/v3);
    // zacasna ublazitev do parser fixa; na konsistentnih dokumentih no-op.
    const _spB=(Array.isArray(o.ddv_spec)?o.ddv_spec:[]);
    const _sumB=(k:string)=>Number(_spB.reduce((s:number,x:any)=>s+Number(x?.[k]||0),0).toFixed(2));
    let _brezB=Number(o.znesek_brez_ddv||0); if(!_brezB&&_spB.length) _brezB=_sumB('osnova');
    let _ddvB=Number(o.ddv_skupaj||0); if(!_ddvB&&_spB.length) _ddvB=_sumB('znesek');
    let _zddvB=Number(o.znesek_z_ddv||d.amount_total||0);
    if(!_zddvB&&(_brezB||_ddvB)) _zddvB=Number((_brezB+_ddvB).toFixed(2));
    if(!_brezB&&_zddvB&&_ddvB) _brezB=Number((_zddvB-_ddvB).toFixed(2));
    const zneski=o.zneski||{skupaj_brez_ddv:_brezB,znesek_ddv:_ddvB,skupaj_z_ddv:_zddvB};
    const _dd=o.datum_dobave||o.datum_izdaje||'';
    const datumi=o.datumi||{datum_racuna:o.datum_izdaje||'',datum_valute:o.datum_valute||'',datum_storitve:o.datum_dobave||'',datum_ddv:_dd,obdobje:_dd?`${_dd.slice(5,7)}.${_dd.slice(0,4)}`:''};
    // [PATCH ir3a-fix3 v1] detail bere top-level ocr.datum/datum_dospelosti/datum_storitve (ISO)
    // [PATCH ir3a-fix4 v1] postavke: parser kljuci (opis, cena_brez_ddv, znesek_brez_ddv)
    // -> oblika, ki jo bere tabela postavk (naziv, kolicina, cena, znesek)
    const postavke=(o.postavke||[]).map((ps:any)=> ps?.naziv!==undefined ? ps : ({
      ...ps,
      naziv:`${ps.zap!=null?ps.zap+'. ':''}${ps.opis||''}${ps.opis2?'\n'+ps.opis2:''}`.trim()||'\u2014',
      kolicina:ps.kolicina!=null?`${ps.kolicina}${ps.enota?' '+ps.enota:''}`:'',
      cena:ps.cena_brez_ddv??null,
      znesek:ps.znesek_brez_ddv??0,
    }));
    return {...d,ocr:{...o,
      datum:o.datum||o.datum_izdaje||'',
      datum_dospelosti:o.datum_dospelosti||o.datum_valute||'',
      datum_storitve:o.datum_storitve||o.datum_dobave||'',
      postavke,zneski,datumi}};
  };
  // [PATCH ir3a-fix v1] izdani nimajo interne serije -> leto iz doc_number ('00361-2026')
  // [PATCH izdani-serija-leto v1] leto dokumenta: serija -> leto v st. racuna (izdani)
  // -> leto iz DATUMA dokumenta (leto knjizenja) -> created_at (zadnja
  // resitev: dokument ne sme biti nikoli neviden, sicer ga ni mogoce urediti).
  const _letoIz=(s:any)=>String(s||'').match(/(20\d{2})/)?.[1];
  /* [PATCH izdani-sort-fe v1] Nepotrjeni IZDANI racuni se razvrstijo po
     NATISNJENI stevilki racuna, ne po created_at: interno_st dobijo sele
     ob potrditvi, worker pa kose obdeluje vzporedno, zato je created_at
     glede na vrstni red v PDF-u nakljucen.
     Numericni del pred locilom ('251/2026' -> 251) resi tudi leksikalno
     past: doc_number je varchar, zato bi '100/2027' pristal pred '98/2027'.
     Prejeti se NE dotaknejo -- njihov doc_number je stevilka dobavitelja. */
  const _stIzdanega=(d:any)=>{
    if(!jeIzdaniTip(d?.doc_type)) return null;
    /* [PATCH izdani-sort-rn v1] MLAKAR tiska 'RN-38-26' - crkovna
       predpona stoji PRED stevilko, zato prejsnji vzorec ni prijel in je
       razvrscanje padlo nazaj na created_at (vzporedni workerji ->
       nakljucen vrstni red; izmerjeno 41,39,42,38,40).
       Predpona je omejena na 4 crke, da se nabor ne razsiri po tihem.
       '251/2026', '060/2026' in '00361-2026' se obnasajo nespremenjeno. */
    /* [PATCH izdani-sort-martincic v1] MARTINCIC tiska '26-0210': prvi del
       je LETO (26), ne zaporedna. Spodnji vzorec je pri vseh 35 racunih
       vrnil 26, zato 'an!==bn' nikoli ni veljalo in razvrscanje je padlo
       na created_at (vzporedni workerji -> nakljucen vrstni red).
       Zaprto na DVE stevki + vezaj + STIRI stevke, brez crk:
         'RN-38-26' (crke), '00361-2026' (5 stevk), '251/2026' (posevnica)
       ne ustrezajo, zato se obnasajo nespremenjeno. */
    const mm=String(d?.doc_number||'').match(/^\s*(\d{2})-(\d{4})\s*$/);
    if(mm) return Number(mm[2]);
    const m=String(d?.doc_number||'').match(/^\s*[A-Za-z]{0,4}[\s\-_.]*0*(\d{1,7})/);
    return m?Number(m[1]):null;
  };
  const serijaDok=(d:any)=>String(
    letoIzSerije(d.interno_st_serija)  /* [PATCH interne-predpone v1] 'A2026' -> '2026': predpona ne sme razbiti letnih zavihkov */
    ||((jeIzdaniTip(d.doc_type))&&_letoIz(d.doc_number))
    ||_letoIz(d.kontiranje?.datumi?.datum_racuna)
    ||_letoIz(d.kontiranje?.datumi?.datum_ddv)
    ||_letoIz(d.ocr?.datum_izdaje)
    ||_letoIz(d.kontiranje?.datumi?.datum_storitve)
    ||_letoIz(d.ocr?.datum_dobave)
    ||_letoIz(d.kontiranje?.datumi?.obdobje)
    ||_letoIz(d.created_at)
    ||'').replace(/^\D+/,'');  /* [PATCH interna-ob-potrditvi v1] 'IR2026' -> '2026' */
  // [PATCH opal-st-fe v1] Opalova številka izdanega: YY(leto) + zaporedna (4-mestno).
  // Leto: sufiks v številki ('00361-2026') → datum računa → DDV → storitev.
  // BREZ created_at: brez pravega datuma prikaz pade na izvirno obliko (nič ugibanja).
  const opalSt=(d:any)=>{
    if(!jeIzdaniTip(d?.doc_type)) return '';
    const m=String(d.doc_number||d.ocr?.stevilka||'').trim().match(/^0*(\d{1,6})(?:\s*[-–—]\s*(20\d{2}))?$/);
    if(!m) return '';
    const num=parseInt(m[1],10);
    if(num>9999) return '';
    const leto=m[2]||_letoIz(d.kontiranje?.datumi?.datum_racuna)||_letoIz(d.ocr?.datum_izdaje)||_letoIz(d.kontiranje?.datumi?.datum_ddv)||_letoIz(d.kontiranje?.datumi?.datum_storitve)||'';
    if(!/^20\d{2}$/.test(leto)) return '';
    return leto.slice(2)+String(num).padStart(4,'0');
  };
  const letaNaVoljoTop=dokumenti.map((d:any)=>serijaDok(d)||null).filter(Boolean).filter((v:any,i:number,a:any[])=>a.indexOf(v)===i).sort().reverse();
  useEffect(()=>{
    if(letaNaVoljoTop.length>0 && !letaNaVoljoTop.includes(izbranoLeto)) setIzbranoLeto(letaNaVoljoTop[0]);
  },[dokumenti]);

  // [PATCH ir4a-ui-postavke v1] izdani: konto per postavka + pregrupiranje dobro 7xx
  const ir4aKat=(p:any)=> selected?.ocr?.tip==='eu46' ? 'eu_oproscen' : (Number(p?.ddv_stopnja||0)>0?'dom_obdavcen':'oproscen');
  const ir4aPk=():any[]=> Array.isArray(kontiranje?.postavke_konti)?kontiranje.postavke_konti:[];
  const ir4aPkZa=(pst:any,idx:number)=>{const a=ir4aPk();return a.find((x:any)=>x&&pst&&x.zap!=null&&x.zap===pst.zap)??a[idx];};
  const ir4aSpremeniKonto=(idx:number,pst:any,vred:string)=>{
    const konto=String(vred||'').replace(/[^0-9]/g,'');
    const a=ir4aPk().map((x:any)=>({...x}));
    const cilj=a.findIndex((x:any)=>x&&pst&&x.zap!=null&&x.zap===pst.zap);
    const i=cilj>=0?cilj:idx;
    if(!a[i]||!konto||String(a[i].konto||'')===konto) return;
    a[i]={...a[i],konto,vir:'rocno'};
    const posts=selected?.ocr?.postavke||[];
    const sk:Record<string,number>={};
    posts.forEach((p:any,j:number)=>{const el=a.find((x:any)=>x&&p&&x.zap!=null&&x.zap===p.zap)??a[j];const k=String(el?.konto||'');if(!k)return;sk[k]=Number(((sk[k]||0)+Number(p?.znesek||0)).toFixed(2));});
    const stare=(kontiranje?.knjizbe||[]);
    const je7=(kb:any)=>kb?.tip==='dobro'&&String(kb?.konto||'').startsWith('7');
    const dobro7=stare.filter(je7);
    const cilVsota=Number(dobro7.reduce((s:number,kb:any)=>s+Number(kb?.znesek||0),0).toFixed(2));
    const smDok=dobro7.find((kb:any)=>kb?.sm)?.sm;
    const nazivP='Prihodki od prodaje'+(selected?.ocr?.tip==='eu46'?' \u2014 EU':'');
    let pari:any[]=Object.entries(sk).sort((x:any,y:any)=>Number(y[1])-Number(x[1]));
    const vsota=Number(pari.reduce((s:number,par:any)=>s+Number(par[1]),0).toFixed(2));
    const d=Number((cilVsota-vsota).toFixed(2));
    if(Math.abs(d)>0.05){toast.error('Vsota postavk se ne ujema s prihodki \u2014 konto ni spremenjen');return;}
    if(pari.length&&Math.abs(d)>0){pari=pari.map((par:any,ii:number)=>ii===0?[par[0],Number((Number(par[1])+d).toFixed(2))]:par);}
    const brez7=stare.filter((kb:any)=>!je7(kb));
    let poz=stare.findIndex(je7);
    if(poz<0){poz=brez7.length;}else{let pred=0;for(let j=0;j<poz;j++){if(!je7(stare[j]))pred++;}poz=pred;}
    const skupine=pari.map((par:any)=>({tip:'dobro',konto:String(par[0]),naziv:nazivP,znesek:Number(par[1]),...(smDok?{sm:smDok}:{})}));
    const nove=[...brez7.slice(0,poz),...skupine,...brez7.slice(poz)];
    setKontiranje({...(kontiranje||{}),knjizbe:nove,postavke_konti:a});
  };
  const izberiDokument=async(doc:any)=>{
    setSelected(doc);
    /* [PATCH prodajni-tok v3] ali je dokument iz izdaje (Prodaja) -> pasica + zaklep glave v UI (backend zaklepa neodvisno) */
    setIzIzdaje(null);
    if(doc?.id&&companyId&&jeIzdaniTip(doc?.doc_type)){ api.get(`/izdaja/${companyId}/po-dokumentu/${doc.id}`).then((r:any)=>{ const z=r?.data?.iz_izdaje||null; setIzIzdaje(z); }).catch(()=>setIzIzdaje(null)); }
    setKontiranje(_uredKnjizbeIzdani(JSON.parse(JSON.stringify(doc.kontiranje||{})), doc.doc_type));
    // Nastavi sklic state
    const rawSklic = doc.ocr?.sklic||doc.kontiranje?.sklic||'';
    let model='SI', modelSt='00', sklicSt=rawSklic;
    const m = rawSklic.match(/^(SI|RF|NRC)\s*(\d{2})\s*(.*)$/i);
    if(m){
      model=m[1].toUpperCase(); modelSt=m[2]; sklicSt=m[3].trim();
    } else {
      // Brez predpone, vodilni 2-mestni model + presledek: "00 269-2613" -> model=00, sklic=269-2613
      const m2 = rawSklic.match(/^(\d{2})\s+(.+)$/);
      if(m2){ modelSt=m2[1]; sklicSt=m2[2].trim(); }
    }
    // [PATCH sklic-model-fe v1] backend loci model sklica v ocr.sklic_model — maska ga bere
    const _mOcrFe = String(doc.ocr?.sklic_model||'').trim();
    if(/^\d{2}$/.test(_mOcrFe)) { modelSt = _mOcrFe; }
    // Fallback: če ni sklica, uporabi številko računa (/ → -)
    if(!sklicSt && (doc.doc_number||doc.ocr?.stevilka)) { sklicSt = (doc.doc_number||doc.ocr?.stevilka||'').replace(/\//g, '-'); }
    setSklicData({model, modelSt, sklicSt});
    setOpombaText(doc.opomba || '');
    // [PATCH rocni-vnos-fe v1] init za tab-vnos
    setTrrEdit(doc.ocr?.trr||doc.partner?.iban||'');
    setPartnerIbani([]);
    setOpisVnos(String(doc.opis??doc.kontiranje?.opis??doc.ocr?.opis??'')); /* [PATCH opis-dokumenta v1] stolpec documents.opis je vir resnice; JSON poti ostaneta kot fallback za stare zapise */
    {const _z=doc.kontiranje?.ocr_zneski||doc.ocr?.zneski||{};const _o=Number(_z.ostalo??doc.amount_other??0);setSkupajRocno(Math.abs(Number(_z.skupaj_z_ddv||0)-(Number(_z.skupaj_brez_ddv||0)+Number(_z.znesek_ddv||0)+_o))>0.011);} // [PATCH likvidacija-fe v4] + ostalo; [PATCH likvidacija-fe v5] isti vir kot maska (shranjeno kontiranje pred OCR), sicer ostalo iz kontiranja proti OCR zneskom lazno sprozi rocni skupaj
    setOstaloOdprto(false); // [PATCH likvidacija-fe v4] polje ostalo privzeto skrito (vidno, ce vrednost != 0)
    {const _z7=doc.ocr?.zneski||{};const _r7=(doc.kontiranje?.ddv_knjiga||[]);const _s7=Number(_r7[0]?.stopnja);
     setDdvRocno(!(_r7.length===1&&Number.isFinite(_s7)&&Math.abs(Number(_z7.znesek_ddv||0)-Number(_z7.skupaj_brez_ddv||0)*_s7/100)<=0.011));} // [PATCH rocni-vnos-fe v7]
    setRocniFile(null);
    const danes=new Date().toISOString().split('T')[0];
    const datumRacuna = doc.ocr?.datum || '';
    if(!datumRacuna) toast.error('⚠️ Datum računa ni bil prepoznan - preverite ročno!');
    // Datum valute: kartica/gotovina = placano takoj -> valuta = datum racuna; sicer datum dospelosti iz OCR
    const _nacin = doc.ocr?.nacin_placila;
    const _valutaTakoj = (_nacin === 'kartica' || _nacin === 'gotovina');
    const datumValute = doc.ocr?.datum_dospelosti || datumRacuna; /* [PATCH fe-datum-valute v1] */  // valuta = datum dospelosti, sicer datum racuna
    /* [PATCH datumi-roundtrip v1] shranjeni datumi (Shrani [prej Koncaj]/potrdi -> kontiranje.datumi) imajo prednost pred OCR izpeljavo */
    const _kd=(doc.kontiranje?.datumi)||{};
    const _ds=_kd.datum_storitve||doc.ocr?.datum_storitve||datumRacuna;
    {const _zl=(doc as any)?.ocr?.zaklep_leta; if(/* [PATCH zaklep-leta-izdani v1] obe smeri */ _zl?.premaknjeno_na && _ds===_zl.premaknjeno_na) toast(String(_zl.opozorilo||'Datum storitve premaknjen v odprto leto'),{icon:'\ud83d\udd12',duration:6000,id:'zaklep-leta'});} /* [PATCH zaklep-leta-fe v1] opozorilo ob odprtju premaknjenega dokumenta */
    const _dvnos=(doc.created_at||'').slice(0,10); /* [PATCH knjizenje-default v1] privzeto knjizenje = datum vnosa, ne danes */
    let _dd0=_kd.datum_ddv||_ds, _ob0=_kd.obdobje||obdobjeIzDatuma(_ds); /* [PATCH ddv-blokada v1] */
    if(!jeIzdaniTip(doc?.doc_type) && jeZaklenjeno(_dd0,ddvBlokada)){/* [PATCH izdani-blokada-dialog-fe v2] izdani: brez tihega premika, vprasa se ob Potrdi */ _dd0=prviOdprtiDan(ddvBlokada); /* [PATCH prejeti-obdobje-storitev v1] obdobje NE sledi datumu za DDV — ostane pri mesecu storitve */ toast(`Datum za DDV prestavljen na ${_dd0.split('-').reverse().join('.')} — obdobje ostane ${_ob0}`,{icon:'\ud83d\udd12'}); }
    setDatumi({datum_knjizenja:_kd.datum_knjizenja||_dvnos||danes,datum_ddv:_dd0,datum_storitve:_ds,datum_racuna:_kd.datum_racuna||datumRacuna,datum_valute:_kd.datum_valute||datumValute,obdobje:_ob0});
    // Če partner ni najden v šifrantu, obvezno prikaži izbiro
    // (onemogočeno - modal se ne odpre avtomatsko)
    if(false && !doc.partner_najden && !doc.kontiranje?.partner_id) {
      setTimeout(() => setShowPartnerModal(true), 300);
    }
    if(pdfOdprto && doc.file_path && companyId) {
      try {
        const r = await api.get(`/dokumenti/${companyId}/${doc.id}/pdf-token`);
        localStorage.setItem('aicount_pdf_doc', JSON.stringify({companyId, docId: doc.id, token: r.data.token}));
      } catch(e) { console.error(e); }
    } else if(pdfOdprto && !doc.file_path) {
      localStorage.removeItem('aicount_pdf_doc');
    }
  };

  const dejanskoIzbrisi=async(doc:any)=>{
    try{
      await api.delete(`/dokumenti/${companyId}/${doc.id}`);
      toast.success('Dokument izbrisan');
      setDokumenti(prev=>prev.filter(d=>d.id!==doc.id));
      if(selected?.id===doc.id){setSelected(null);setKontiranje(null);}
      setBrisanjeModal(false); setBrisanjeDoc(null);
    }catch(err:any){
      /* [PATCH brisanje-sporocila v1] pred tem je bil obravnavan samo status 409;
         403 (tuj dokument) in 404 (dokumenta ni vec) sta padla v skupno
         splosno sporocilo, zato razlog nikoli ni prisel na zaslon. */
      const _st = err?.response?.status;
      const _det = err?.response?.data?.detail;
      const _sporocilo = (typeof _det === 'string' && _det) ? _det : null;
      if(_st===404){
        toast.error(_sporocilo || 'Tega dokumenta ni več — seznam je osvežen.');
        setDokumenti(prev=>prev.filter(d=>d.id!==doc.id));
        if(selected?.id===doc.id){setSelected(null);setKontiranje(null);}
        setBrisanjeModal(false); setBrisanjeDoc(null);
      } else if(_st===409 && brisanjeDoc){
        if(_sporocilo) toast.error(_sporocilo);
        await osveziOdvisnosti(brisanjeDoc);
      } else {
        toast.error(_sporocilo || 'Napaka pri brisanju');
      }
    }
  };
  const osveziOdvisnosti=async(doc:any)=>{
    try{ const r=await api.get(`/dokumenti/${companyId}/${doc.id}/odvisnosti`); setBrisanjeOdv(r.data); return r.data; }
    catch(e:any){ /* [PATCH brisanje-sporocila v1] napaka klica NI dokaz o povezavah */
      const f:any={povezave:[],placila:[],lahko_brisati:false,
        napaka:(e?.response?.status===404 ? 'ni_dokumenta' : 'napaka')};
      setBrisanjeOdv(f as any); return f; }
  };
  const odstraniPovezavoBris=async(linkId:string)=>{
    try{ await api.delete(`/stranka/${companyId}/povezave/${linkId}`); toast.success('Povezava odstranjena'); if(brisanjeDoc) await osveziOdvisnosti(brisanjeDoc); }
    catch{ toast.error('Napaka'); }
  };
  const odstraniPlaciloBris=async(placiloId:string)=>{
    try{ await api.delete(`/stranka/${companyId}/placila/${placiloId}`); toast.success('Plačilo izbrisano'); if(brisanjeDoc) await osveziOdvisnosti(brisanjeDoc); }
    catch{ toast.error('Napaka'); }
  };
  const izbrisiDokument=async(e:React.MouseEvent,doc:any)=>{
    e.stopPropagation();
    // [PATCH zaklep-potrjenega-fe v1] potrjenega ni mogoce izbrisati; povej TAKOJ, brez klica streznika
    if(String(doc?.status||'')==='approved'){
      toast.error(jeStranka
        ? 'Račun je že potrjen, zato ga ni več mogoče izbrisati. Obrnite se na svoje računovodstvo.'
        : "Dokument je potrjen. Najprej uporabi 'Prekliči potrditev'.");  /* [PATCH stranka-potrjen-fe v1] */
      return;
    }
    if(jeStranka&&likvPredmet(doc)&&likvidiranDok(doc)){  /* [PATCH likvidacija-fe v1] */
      toast.error('Račun je likvidiran. Za brisanje najprej prekličite likvidacijo.'); return;
    }
    setBrisanjeDoc(doc);
    await osveziOdvisnosti(doc);
    setBrisanjeModal(true);
  };

  const handleDdvChange=(k:any)=>{
    const ddvVrstice=k.ddv_knjiga||[];
    // [PATCH ddvknjiga-smer v1] IZDANI racuni: D terjatev (bruto) / K prihodek (osnova)
    // / K izstopni DDV PO STOPNJI (konto iz profila konto_ddv_dom_obracunani_*).
    // Prej je tudi izdane gradila prejeta logika spodaj (K obveznost / D vstopni DDV
    // / D strosek) -> obrnjeni tipi + vstopni konto 16xxx. Prejeta pot je nespremenjena.
    const jeIzdaniDok=(k?.smer==='izdani')||(jeIzdaniTip(selected?.doc_type));
    if(jeIzdaniDok){
      const kontoObrStopnje=(stopnja:number):string=>{
        const sk=stopnja===9.5?'95':stopnja===5?'5':'22';
        return ddvKonti?.['konto_ddv_dom_obracunani_'+sk]||ddvKonti?.konto_ddv_genericni_obracunani||'260000';
      };
      const obst=k.knjizbe||[];
      const izdOsnova=Number(ddvVrstice.reduce((s:number,v:any)=>s+Number(v.osnova||0),0).toFixed(2));
      const izdDdv=Number(ddvVrstice.reduce((s:number,v:any)=>s+Number(v.znesek_ddv||0),0).toFixed(2));
      // Konte iscemo PO KONTU (ne po tipu) - robustno tudi ce je dokument ze pokvarjen.
      const kontoTerjatve=k.konto_dobavitelja||obst.find((kb:any)=>kb.konto?.startsWith('12'))?.konto||'1200';
      const nazivTerjatve=obst.find((kb:any)=>kb.konto?.startsWith('12'))?.naziv||'Terjatve do kupcev';
      // [PATCH oss-temelji v1] 2e: pri OSS je knjizba prihodkov vir resnice.
      // Prej je imel konto_stroska prednost, zato bi vsaka naslednja sprememba
      // v DDV knjigi povozila konto iz OSS nastavitev IN rocni popravek
      // uporabnika. Konto iz nastavitev pride v knjizbo v DdvKnjiga.tsx
      // (updateVrstica ob spremembi drzave/dobave), konto_stroska ostane samo
      // rezerva, kadar knjizbe se ni. Iskanje po nazivu, ker konto iz
      // nastavitev ni nujno 76xxx. Ne-OSS dokumenti so nespremenjeni.
      const jeOssDok=ddvVrstice.some((v:any)=>v.vrsta==='IZD_OSS_BLAGO'||v.vrsta==='IZD_OSS_STORITEV');
      const najdiPrihodke=(kb:any)=>kb.konto?.startsWith('76')||String(kb.naziv||'').startsWith('Prihodki');
      const kontoPrihodka=jeOssDok
        ?(obst.find(najdiPrihodke)?.konto||k.konto_stroska||'7600')
        :(k.konto_stroska||obst.find((kb:any)=>kb.konto?.startsWith('76'))?.konto||'7600');
      const nazivPrihodka=k.naziv_konta||obst.find(jeOssDok?najdiPrihodke:(kb:any)=>kb.konto?.startsWith('76'))?.naziv||'Prihodki od prodaje';
      const smPrihodka=obst.find((kb:any)=>(jeOssDok?najdiPrihodke(kb):kb.konto?.startsWith('76'))&&kb.sm)?.sm;
      const knjizbeIzd:any[]=[
        {tip:'breme',konto:kontoTerjatve,naziv:nazivTerjatve,znesek:Number((izdOsnova+izdDdv).toFixed(2))},
        {tip:'dobro',konto:kontoPrihodka,naziv:nazivPrihodka,znesek:izdOsnova,...(smPrihodka?{sm:smPrihodka}:{})},
      ];
      // ENA DDV knjizba NA STOPNJO; naziv znakovno enak backendu (izdani_kontiranje.py)
      ddvVrstice.forEach((v:any)=>{
        const zn=Number(v.znesek_ddv||0);
        if(zn>0){
          const st=Number(v.stopnja||0);
          // [PATCH oss-temelji v1] OSS: konto DDV pride IZ VRSTICE (nastavitve
          // po drzavi potrosnje), nikoli iz profila podjetja. Prej je tudi OSS
          // vrstica dobila kontoObrStopnje(), ki bere samo matriko
          // konto_ddv_dom_obracunani_* -> vrstica je nosila DOMACI konto in se
          // ob menjavi drzave ni spremenila (napaka B1/B2 rocnega testa).
          // Prazen konto = "za to drzavo/stopnjo ni nastavljen" -> backend
          // _preveri_oss_vrstice() potrditev blokira. Ostale vrste nespremenjene.
          const jeOss = v.vrsta==='IZD_OSS_BLAGO'||v.vrsta==='IZD_OSS_STORITEV';
          const kontoDdv = jeOss ? String(v.konto_ddv||'') : kontoObrStopnje(st);
          knjizbeIzd.push({tip:'dobro',konto:kontoDdv,
            naziv:`Obračunani (izstopni) DDV ${String(st).replace('.',',')}%`,
            znesek:Number(zn.toFixed(2)),
            stopnja:st});// [PATCH vod-izdani-stopnja v1] VOD pari po stopnji
        }
      });
      setKontiranje({...k,knjizbe:knjizbeIzd});
      return;
    }
    // Konto vstopnega DDV po stopnji iz profila (ddvKonti) - vedno izracunaj, ne zanasaj se na shranjeno vrstico
    // [PATCH ddv-konto-lib v1] Prej SAMO stari ploski kljuci (konto_ddv_22/95/5).
    // Profil, ki ima matriko konto_ddv_dom_vstopni_* ali samo genericni konto,
    // je bil prezrt; stopnja 5 % brez kljuca konto_ddv_5 je padla na trdi 160000.
    // Zdaj ista veriga kot backend: matrika -> star -> genericni -> fallback.
    const kontoStopnje=(stopnja:number):string=>ddvKonto(ddvKonti,'dom',stopnja,'vstopni');
    const skupajOsnova=ddvVrstice.reduce((s:number,v:any)=>s+Number(v.osnova),0);
    const skupajDdvOdbitni=ddvVrstice.filter((v:any)=>v.odbitno).reduce((s:number,v:any)=>s+Number(v.znesek_ddv),0);
    const skupajDdvObracunani=ddvVrstice.reduce((s:number,v:any)=>s+Number(v.znesek_ddv),0);
    const vsaOdbitna=ddvVrstice.length>0&&ddvVrstice.every((v:any)=>v.odbitno);
    // [PATCH ddv-mesane-knjige v1] EU_VRSTE / jeSamoobdavcitev odstranjena:
    // vejanje po CELEM dokumentu je bilo vzrok, da je mesan racun izgubil
    // ne-EU vrstice. Nova gradnja vejni po VSAKI VRSTICI posebej.

    // Konte vzamemo iz obstoječih knjižb (backend jih je nastavil iz profila podjetja)
    const obstojeceKnjizbe=k.knjizbe||[];
    const konto_dobavitelja=k.konto_dobavitelja||obstojeceKnjizbe.find((kb:any)=>kb.tip==='dobro'&&(kb.konto?.startsWith('22')||kb.konto?.startsWith('12')))?.konto||'220000';
    const konto_obracunani=obstojeceKnjizbe.find((kb:any)=>kb.tip==='dobro'&&kb.konto?.startsWith('26'))?.konto||'260000';
    // Vstopni DDV konto: PRIMARNO iz ddv_knjiga (konto_ddv iz profila podjetja), nato obstojece knjizbe, nato fallback
    const konto_vstopni=ddvVrstice.find((v:any)=>v.konto_ddv)?.konto_ddv||obstojeceKnjizbe.find((kb:any)=>kb.tip==='breme'&&kb.konto?.startsWith('16'))?.konto||'160000';
    const naziv_obracunani=obstojeceKnjizbe.find((kb:any)=>kb.tip==='dobro'&&kb.konto?.startsWith('26'))?.naziv||'Obračunani DDV';
    const naziv_vstopni=obstojeceKnjizbe.find((kb:any)=>kb.tip==='breme'&&kb.konto?.startsWith('16'))?.naziv||'DDV odbiten vstopni';
    const konto_stroska=k.konto_stroska||obstojeceKnjizbe.find((kb:any)=>kb.tip==='breme'&&!kb.konto?.startsWith('16'))?.konto||'402000';
    const naziv_stroska=k.naziv_konta||obstojeceKnjizbe.find((kb:any)=>kb.tip==='breme'&&!kb.konto?.startsWith('16'))?.naziv||'Strošek';
    // Ohrani SM iz obstojece stroskovne knjizbe (preklop odbitno ne sme zbrisati SM)
    const sm_stroska=obstojeceKnjizbe.find((kb:any)=>kb.tip==='breme'&&!kb.konto?.startsWith('16')&&kb.sm)?.sm;

    let knjizbe:any[];
    {
      // [PATCH ddv-mesane-knjige v1] ENOTNA gradnja knjizb, VRSTICO PO VRSTICI.
      // Prej sta bili DVE loceni veji (domaca "else" + EU "if jeSamoobdavcitev"),
      // pogoj pa je uporabljal .some() -> ENA EU vrstica je potegnila CEL dokument
      // v EU vejo. Mesan racun (domaci + EU + uvoz na isti listini) je zato izgubil
      // vse ne-EU vrstice; obveznost do dobavitelja je bila samo EU del.
      //
      // Pravila (za CISTE dokumente je izid IDENTICEN dosedanjemu):
      //   bruto     = SUM prispevkov: KPR 0, KIR osnova, ostalo osnova+DDV
      //   26xxx K   = po ENA knjizba na KIR vrstico (obracunani DDV samoobdavcitve)
      //   16xxx D   = po ENA knjizba na odbitno vrstico z DDV > 0
      //   neodbitni = DDV ne-KIR vrstic brez kljukice Odb. -> pristeje se strosku
      //   strosek   = SUM osnov (KPR se NE steje) + neodbitni DDV
      //
      // Seznami vrst so zrcalo KIR_AVTO / KPR_AVTO / SOLO_SAMOOBD v DdvKnjiga.tsx
      // in _KIR_VRSTE v opal.py — ob spremembi popravi VSE tri.
      const _KIR=['76A_KIR','EU_STOR_KIR','EU_BLAGO_KIR'];
      const _KPR=['76A_KPR','EU_STOR_KPR','EU_BLAGO_KPR'];
      const _SOLO=['76A','EU_BLAGO','EU_STOR'];
      const jeKir=(v:any)=>_KIR.includes(String(v?.vrsta||''));
      const jeKpr=(v:any)=>_KPR.includes(String(v?.vrsta||''));
      const jeSolo=(v:any)=>_SOLO.includes(String(v?.vrsta||''));
      const c2=(n:any)=>Number(Number(n||0).toFixed(2));
      // prispevek vrstice k znesku racuna — zrcalo prispevekDoBruta() v DdvKnjiga.tsx:
      // DDV samoobdavcitve NI del zneska racuna, zato KPR prispeva 0, KIR le osnovo.
      const prispevek=(v:any)=>jeKpr(v)?0
        :((jeKir(v)||jeSolo(v))?Number(v.osnova||0)
          :Number(v.osnova||0)+Number(v.znesek_ddv||0));
      const bruto=c2(ddvVrstice.reduce((s:number,v:any)=>s+prispevek(v),0));
      const osnoveZaStrosek=c2(ddvVrstice.reduce((s:number,v:any)=>s+(jeKpr(v)?0:Number(v.osnova||0)),0));
      // neodbitni steje SAMO ne-KIR vrstice: KIR je obveznost (26xxx), ne strosek
      const neodbitni=c2(ddvVrstice.reduce((s:number,v:any)=>s+((!jeKir(v)&&!v.odbitno)?Number(v.znesek_ddv||0):0),0));
      const jeTuj=ddvVrstice.some((v:any)=>jeKir(v)||jeKpr(v)||jeSolo(v));
      knjizbe=[{tip:'dobro',konto:konto_dobavitelja,
                naziv:jeTuj?'Obveznosti do tujih dobaviteljev':'Obveznosti do dobaviteljev',
                znesek:bruto}];
      // obracunani DDV samoobdavcitve -> 26xxx K. Prej ENA zdruzena knjizba;
      // locene so pravilnejse, ker VOD (opal.py) pari grupe PO ZNESKU.
      ddvVrstice.forEach((v:any)=>{
        if(jeKir(v)&&Math.abs(Number(v.znesek_ddv||0))>0.004){ /* [PATCH fe-ddv-negativni v1] tudi dobropis (DDV < 0) */
          knjizbe.push({tip:'dobro',
            konto:ddvKonto(ddvKonti,kategorijaIzVrste(String(v.vrsta||'')),Number(v.stopnja||0),'obracunani'),
            naziv:naziv_obracunani,znesek:c2(v.znesek_ddv)});
        }
      });
      // vstopni odbitni DDV -> 16xxx D, po ena knjizba na vrstico (svoj konto).
      ddvVrstice.forEach((v:any)=>{
        if(!jeKir(v)&&v.odbitno&&Math.abs(Number(v.znesek_ddv||0))>0.004){ /* [PATCH fe-ddv-negativni v1] tudi dobropis (DDV < 0) */
          knjizbe.push({tip:'breme',
            konto:ddvKonto(ddvKonti,kategorijaIzVrste(String(v.vrsta||'')),Number(v.stopnja||0),'vstopni'),
            naziv:jeKpr(v)?naziv_vstopni:`DDV odbiten vstopni ${v.stopnja}%`,
            znesek:c2(v.znesek_ddv)});
        }
      });
      const strosekZnesek=c2(osnoveZaStrosek+neodbitni);
      const strosekNaziv=neodbitni>0?`${naziv_stroska} (z neodbitnim DDV)`:naziv_stroska;
      // [PATCH razdeli-ddv-fe v2] Ohrani ROCNI RAZREZ stroska — NESPREMENJENO.
      // [PATCH vod-saldakonto-280 v1] seznam MORA biti enak kot opal.py::_je_saldakonto
      const _razStroski=obstojeceKnjizbe.filter((kb:any)=>kb.tip==='breme'&&!kb.placano
        &&!/^(220|221|280|285|919)/.test(String(kb.konto||''))&&!/^(16|26)/.test(String(kb.konto||'')));
      const _razVsota=c2(_razStroski.reduce((s:number,kb:any)=>s+Number(kb.znesek||0),0));
      if(_razStroski.length>1&&Math.abs(_razVsota-strosekZnesek)<0.005){
        _razStroski.forEach((kb:any)=>knjizbe.push({...kb}));
      } else {
        knjizbe.push({tip:'breme',konto:konto_stroska,naziv:strosekNaziv,znesek:strosekZnesek,sm:sm_stroska});
      }
    }
    setKontiranje({...k,knjizbe});
  };

  // [PATCH fe-bsi-valuta v2] devizni blok (nadgradnja [PATCH fe-bsi-valuta v1]):
  // 3-smerna sinhronizacija: tecaj <-> EUR <-> datum <-> znesek v valuti.
  // deviznoApply skalira ocr_zneski + ddv_knjiga + kontirne vrstice s faktorjem novi/stari skupaj.
  const deviznoGet=()=>((kontiranje?.devizno)||(selected?.ocr?.devizno)||{});
  const deviznoApply=(noviEur:number,dvNovo:any)=>{
    // [PATCH rocni-vnos-fe v4] nadgradnja [PATCH fe-bsi-valuta v2]:
    // + setev praznega (rocnega) racuna iz preracuna + zrcalo v selected.ocr
    const oz:any={...(kontiranje?.ocr_zneski||selected?.ocr?.zneski||{})};
    const stariEur=Number(oz.skupaj_z_ddv||0);
    const fak=(stariEur>0&&noviEur>0)?noviEur/stariEur:0;
    const seme=(fak===0&&noviEur>0&&stariEur===0);
    let knj=(kontiranje?.knjizbe||[]);
    let dknj=(kontiranje?.ddv_knjiga||[]);
    if(fak>0){
      const ddv=Number((Number(oz.znesek_ddv||0)*fak).toFixed(2));
      oz.skupaj_z_ddv=Number(noviEur.toFixed(2));
      oz.znesek_ddv=ddv;
      oz.skupaj_brez_ddv=Number((noviEur-ddv).toFixed(2));
      knj=knj.map((kb:any)=>({...kb,znesek:Number((Number(kb.znesek||0)*fak).toFixed(2))}));
      dknj=dknj.map((v:any)=>({...v,osnova:Number((Number(v.osnova||0)*fak).toFixed(2)),znesek_ddv:Number((Number(v.znesek_ddv||0)*fak).toFixed(2))}));
    } else if(seme){
      oz.skupaj_z_ddv=Number(noviEur.toFixed(2));
      if(Number(oz.znesek_ddv||0)===0) oz.skupaj_brez_ddv=oz.skupaj_z_ddv;
      const ima16=knj.some((kb:any)=>kb.tip==='breme'&&String(kb.konto||'').startsWith('16'));
      if(!ima16&&knj.length) knj=knj.map((kb:any)=>({...kb,znesek:Number(noviEur.toFixed(2))}));
    }
    setKontiranje((k:any)=>({...k,ocr_zneski:oz,knjizbe:knj,ddv_knjiga:dknj,devizno:{...deviznoGet(),...dvNovo}}));
    if(fak>0||seme){
      setSelected((s:any)=>s?{...s,ocr:{...(s.ocr||{}),zneski:{...oz}}}:s);
      if(seme) setSkupajRocno(true);
    }
  };
  const deviznoTecajChange=(t:number)=>{
    const zv=Number(deviznoGet().znesek_valuta||0);
    if(!(t>0)||!(zv>0)){ setKontiranje((k:any)=>({...k,devizno:{...deviznoGet(),tecaj:(t>0?t:null),tecaj_vir:'rocno'}})); return; }
    deviznoApply(Number((zv/t).toFixed(2)),{tecaj:t,tecaj_vir:'rocno'});
  };
  const deviznoEurChange=(eur:number)=>{
    const zv=Number(deviznoGet().znesek_valuta||0);
    const t=(eur>0&&zv>0)?Number((zv/eur).toFixed(6)):null;
    deviznoApply(eur,{tecaj:t,tecaj_vir:'rocno'});
  };
  const deviznoZvChange=(zv:number)=>{
    const dv=deviznoGet(); const t=Number(dv.tecaj||0); const z=Number(zv.toFixed(2));
    if(t>0&&z>0){ deviznoApply(Number((z/t).toFixed(2)),{znesek_valuta:z}); }
    else { setKontiranje((k:any)=>({...k,devizno:{...deviznoGet(),znesek_valuta:z}})); }
  };
  const deviznoDatumChange=async(d:string)=>{
    const dv=deviznoGet();
    if(!d||!dv.valuta){ setKontiranje((k:any)=>({...k,devizno:{...dv,tecaj_datum:d||null}})); return; }
    try{
      const r=await api.get(`/dokumenti/${companyId}/tecaj-bsi`,{params:{datum:d,valuta:dv.valuta}});
      if(r.data?.tecaj){
        const zv=Number(dv.znesek_valuta||0);
        deviznoApply(zv>0?Number((zv/r.data.tecaj).toFixed(2)):0,
          {tecaj:r.data.tecaj,tecaj_datum:r.data.tecaj_datum,tecaj_vir:(r.data.vir||'BSI')}); /* [PATCH bsi-tecaji v1] */
        toast.success(`BSI tečaj ${dv.valuta} (${fmtDatum(r.data.tecaj_datum)}): ${String(r.data.tecaj).replace('.',',')}`);
      } else {
        setKontiranje((k:any)=>({...k,devizno:{...dv,tecaj_datum:d}}));
        toast.error(`BSI tečaja za ${dv.valuta} na ${fmtDatum(d)} ni — vnesi ročno`);
      }
    }catch{ toast.error('Napaka pri poizvedbi BSI tečaja'); }
  };

  // [PATCH rocni-vnos-fe v4] vklop devizne kljukice: potrdi valuto in povleci
  // BSI tecaj na datum racuna (vikend/praznik resi tecajnica s preskokom nazaj)
  const deviznoVklopi=async(koda:string)=>{
    const val=(koda||'').trim().toUpperCase();
    if(!/^[A-Z]{3}$/.test(val)||val==='EUR'){ toast.error('Vnesi 3-črkovno kodo valute (npr. USD, CHF) — EUR ni devizni'); return; }
    const d=(datumi.datum_racuna||new Date().toISOString().split('T')[0]);
    let dvNovo:any={valuta:val,_vklop:undefined,tecaj_vir:'BSI'};
    try{
      const r=await api.get(`/dokumenti/${companyId}/tecaj-bsi`,{params:{datum:d,valuta:val}});
      if(r.data?.tecaj){
        dvNovo.tecaj=r.data.tecaj; dvNovo.tecaj_datum=r.data.tecaj_datum; dvNovo.tecaj_vir=(r.data.vir||'BSI'); /* [PATCH bsi-tecaji v1] */
        toast.success(`BSI tečaj ${val} (${fmtDatum(r.data.tecaj_datum)}): ${String(r.data.tecaj).replace('.',',')}`);
      } else toast.error(`BSI tečaja za ${val} na ${fmtDatum(d)} ni — klikni tečaj v bloku in ga vnesi ročno`);
    }catch{ toast.error('Napaka pri poizvedbi BSI tečaja'); }
    setKontiranje((k:any)=>({...k,devizno:{...((k&&k.devizno)||{}),...dvNovo}}));
  };

  // [PATCH rocni-vnos-fe v5] potrditev deviznega mini-vnosa:
  // valuta + znesek + datum -> BSI tecaj na datum -> osnova(EUR) = preracun,
  // DDV = 0, skupaj = osnova; datum racuna se prepise iz datuma za tecaj.
  const deviznoPotrdiVnos=async()=>{
    const _fok=(id:string)=>setTimeout(()=>document.getElementById(id)?.focus(),40);
    const val=(devValuta||'').trim().toUpperCase();
    if(!/^[A-Z]{3}$/.test(val)||val==='EUR'){ toast.error('Vnesi 3-črkovno kodo valute (npr. USD) — EUR ni devizni'); _fok('vt-dev-valuta'); return; }
    const _zs=String(devZnesek||'').trim();
    const zv=Number(_zs.includes(',')?_zs.replace(/\./g,'').replace(',','.'):_zs);
    if(!(zv>0)){ toast.error('Vnesi znesek v valuti'); _fok('vt-dev-znesek'); return; }
    const _ds=String(devDatum||'').trim();
    const dIso=parseDatumVnos(_ds)||''; // [PATCH rocni-vnos-fe v6] pametni datum (3006 -> 30.06.2026)
    if(!dIso){ toast.error('Neveljaven datum — npr. 3006 ali 30.06.2026'); _fok('vt-dev-datum'); return; }
    // datum racuna iz datuma za tecaj (kaskada kot pri vnosu datuma racuna)
    { let _dd=dIso,_ob=obdobjeIzDatuma(dIso); if(jeZaklenjeno(dIso,ddvBlokada)){ _dd=prviOdprtiDan(ddvBlokada); /* [PATCH prejeti-obdobje-storitev v1] obdobje ostane pri vnesenem datumu */ } setDatumi(d=>({...d,datum_racuna:dIso,datum_ddv:_dd,datum_storitve:dIso,obdobje:_ob})); } /* [PATCH ddv-blokada v1] */
    let tecaj:any=null, tecajDatum:any=dIso, vir='rocno';
    try{
      const r=await api.get(`/dokumenti/${companyId}/tecaj-bsi`,{params:{datum:dIso,valuta:val}});
      if(r.data?.tecaj){
        tecaj=r.data.tecaj; tecajDatum=r.data.tecaj_datum||dIso; vir=(r.data.vir||'BSI'); /* [PATCH bsi-tecaji v1] */
        toast.success(`BSI tečaj ${val} (${fmtDatum(tecajDatum)}): ${String(tecaj).replace('.',',')}`);
      } else toast.error(`BSI tečaja za ${val} na ${fmtDatum(dIso)} ni — klikni tečaj v bloku in ga vnesi ročno`);
    }catch{ toast.error('Napaka pri poizvedbi BSI tečaja'); }
    const eur=(tecaj&&Number(tecaj)>0)?Number((zv/Number(tecaj)).toFixed(2)):0;
    setKontiranje((k:any)=>{
      let kn=(k?.knjizbe||[]);
      if(eur>0){
        const ima16=kn.some((kb:any)=>kb.tip==='breme'&&String(kb.konto||'').startsWith('16'));
        if(!ima16&&kn.length) kn=kn.map((kb:any)=>({...kb,znesek:eur}));
      }
      const oz=(eur>0)?{...(k?.ocr_zneski||{}),skupaj_brez_ddv:eur,znesek_ddv:0,skupaj_z_ddv:eur}:(k?.ocr_zneski||{});
      return {...k,ocr_zneski:oz,knjizbe:kn,
        devizno:{valuta:val,znesek_valuta:Number(zv.toFixed(2)),tecaj:(tecaj?Number(tecaj):null),tecaj_datum:tecajDatum,tecaj_vir:vir}};
    });
    if(eur>0){
      setSelected((s:any)=>s?{...s,ocr:{...(s.ocr||{}),zneski:{...(s.ocr?.zneski||{}),skupaj_brez_ddv:eur,znesek_ddv:0,skupaj_z_ddv:eur}}}:s);
      setSkupajRocno(false); setDdvRocno(true); // [PATCH rocni-vnos-fe v7] devizni: DDV ostane 0
    }
    _fok('vt-datum-racuna'); // [PATCH rocni-vnos-fe v6] tab-tok naprej na datum racuna
  };

  // SEJA E: varnostni dialog stevilke — shrani/zavrzi/ostani ob menjavi dokumenta
  const shraniPopravekStevilke=async():Promise<boolean>=>{
    const nova=(stevilkaEdit||'').trim();
    if(!selected?.id||!nova) return true;
    try{
      await api.put(`/dokumenti/${companyId}/${selected.id}/stevilka`,{popravljena_stevilka:nova});
      setDokumenti(prev=>prev.map(d=>d.id===selected.id?{...d,doc_number:nova,ocr:{...(d.ocr||{}),stevilka:nova}}:d));
      setSelected((s:any)=>s&&s.id===selected.id?{...s,doc_number:nova,ocr:{...(s.ocr||{}),stevilka:nova}}:s); // SEJA E: koncaj razresi popravek
      setStevilkaEdit('');
      toast.success(`Številka shranjena: ${nova}`);
      return true;
    }catch(e:any){toast.error(e?.response?.data?.detail||'Napaka pri shranjevanju številke');return false;}
  };
  const varnoZapustiDokument=async():Promise<boolean>=>{
    if(selected?._rocni){ return window.confirm('Ročni vnos še ni shranjen. Zavržem osnutek?'); } // [PATCH rocni-vnos-fe v1]
    if(!selected?.id) return true;
    const stara=stDok(selected);
    const nova=(stevilkaEdit||'').trim();
    if(!editMode||!nova||nova===stara) return true; // dialog samo med aktivnim urejanjem
    if(window.confirm(`Popravljena številka '${nova}' še NI shranjena.\n\nOK = shrani popravek in pojdi naprej\nPrekliči = naslednje vprašanje (zavrzi ali ostani)`)){
      return await shraniPopravekStevilke();
    }
    if(window.confirm('Zavržem popravek številke?\n\nOK = zavrzi in pojdi naprej\nPrekliči = ostani na tem računu')){
      return true; // reset ob menjavi naredi useEffect
    }
    return false;
  };
  const shraniPopravke=async():Promise<boolean>=>{
    if(!selected?.id)return true;
    try{
      const _staraSt=stDok(selected);
      const _novaSt=(stevilkaEdit||'').trim();
      const _sPopravkom=Boolean(_novaSt&&_novaSt!==_staraSt);
      await api.post(`/dokumenti/${companyId}/${selected.id}/shrani`,{...kontiranje,datumi,sklic:sestaviSklic(),trr:(trrEdit||'').trim(),opis:(opisVnos||'').trim(),...(_sPopravkom?{popravljena_stevilka:_novaSt}:{})}); // [PATCH rocni-vnos-fe v1]
      toast.success('Popravki shranjeni');
      naloziDokumente(companyId, aktivniTip, iskanje);
      if(_sPopravkom) setSelected((s:any)=>s&&s.id===selected.id?{...s,doc_number:_novaSt,ocr:{...(s.ocr||{}),stevilka:_novaSt}}:s);
      return true;
    }catch(e:any){toast.error(e?.response?.data?.detail||'Napaka pri shranjevanju');return false;}
  };
  // ===== [PATCH ddv-kontrola-stopnja v1] kontrola DDV evidence (KPR/KIR) =====
  // znesek_ddv se mora ujemati z osnova x stopnja; stopnja se bere iz sifranta
  // VRSTE_DDV (vir resnice), ne iz polja vrstice. Velja za obe smeri in ne
  // glede na kljukici Odb./Pop. TRDA BLOKADA - ob krsitvi se potrditev ustavi.
  // Neznana vrsta -> preskok. (Odlocitve Janez 28.07.2026.)
  const DDV_KONTROLA_TOL = 0.05; // EUR - zaokrozevanje po postavkah dobavitelja
  const preveriDdvKnjigo = (ddvKnjiga: any[]): boolean => { // [PATCH ddv-kontrola-stopnja v2] trda blokada
    // [PATCH ddv-stopnja-vrata v1] TRDA BLOKADA: stopnja, ki je OCR ni prebral.
    // Tece PRED kontrolo osnova x stopnja, ker je brez stopnje ta brezpredmetna.
    // Izbirnik Vrsta je v tem primeru PRAZEN (DdvKnjiga.tsx), zato je sporocilo
    // usklajeno s tem, kar uporabnik dejansko vidi na zaslonu.
    // Legitimna stopnja 0 (OPROSCEN / NI_PREDMET / 76.a) NI zajeta -- glej
    // stopnjaNedolocena() v DdvKnjiga.tsx.
    const brezVrste: number[] = [];
    (ddvKnjiga || []).forEach((v: any, i: number) => {
      if (stopnjaNedolocena(v)) brezVrste.push(i + 1);
    });
    if (brezVrste.length) {
      toast.error(
        'Potrditev ni mogo\u010da \u2014 v zavihku DDV ni izbrane vrste (vrstica '
        + brezVrste.join(', ') + '). OCR stopnje ni prepoznal, ker se osnova in '
        + 'DDV ne izideta v nobeno veljavno stopnjo. Preveri zneske na ra\u010dunu, '
        + 'nato izberi vrsto.',
        { duration: 10000 }
      );
      return false;
    }
    const krsitve: string[] = [];
    (ddvKnjiga || []).forEach((v: any, i: number) => {
      const def = VRSTE_DDV.find((x) => x.value === v?.vrsta);
      if (!def) return;
      // [PATCH oss-uvoz v1] D1: pri OSS stopnja NI lastnost vrste --
      // VRSTE_DDV ima za IZD_OSS_* stopnjo 0 kot zacetno vrednost,
      // prava stopnja je stopnja DRZAVE POTROSNJE in zivi na vrstici.
      // Brez tega je kontrola primerjala 590,00 x 0 % = 0,00 proti
      // vpisanim 147,50 in blokirala potrditev pravilnega racuna.
      const st = jeOssVrsta(v?.vrsta) ? Number(v?.stopnja || 0)
                                     : Number(def.stopnja || 0);
      const osnova = Number(v?.osnova || 0);
      const ddv = Number(v?.znesek_ddv || 0);
      if (Math.abs(ddv - (osnova * st) / 100) > DDV_KONTROLA_TOL) {
        krsitve.push(`vrstica ${i + 1} (${def.label}): ${fmt(osnova)} \u00d7 ${String(st).replace('.', ',')}% = ${fmt((osnova * st) / 100)}, vpisano ${fmt(ddv)}`);
      }
    });
    if (krsitve.length) {
      toast.error(`Preveri DDV zavihek \u2014 osnova in DDV se ne ujemata: ${krsitve[0]}${krsitve.length > 1 ? ` (+ \u0161e ${krsitve.length - 1})` : ''}`, { duration: 8000 });
    }
    return krsitve.length === 0;
  };
  // ===== [PATCH ddv-kontrola-stopnja v2] obvezni datumi + obdobje pred potrditvijo =====
  // Vseh 6 polj sekcije Datumi mora biti izpolnjenih (Janez 28.07.:
  // "ne sme potrditi, ce katerikoli od datumov ali obdobje manjka").
  const preveriDatume = (d: any): boolean => {
    const obvezni: Array<[string, string]> = [
      ['datum_racuna', 'Datum ra\u010duna'],
      ['datum_storitve', 'Datum storitve'],
      ['datum_valute', 'Datum valute'],
      ['datum_knjizenja', 'Datum knji\u017eenja'],
      ['datum_ddv', 'Datum za DDV'],
      ['obdobje', 'Obdobje (MM.YYYY)'],
    ];
    const manjka = obvezni.filter(([k]) => !String((d || {})[k] || '').trim()).map(([, naziv]) => naziv);
    if (manjka.length) {
      toast.error(`Potrditev ni mogo\u010da \u2014 manjka: ${manjka.join(', ')}`, { duration: 8000 });
      return false;
    }
    return true;
  };
  const potrdiKontiranje=async()=>{
    if(/DVOJNIK/.test(stDok(selected))&&!window.confirm('Ta račun je označen kot DVOJNIK — račun s to številko je za tega dobavitelja že v bazi. Vseeno potrdim?'))return; /* [PATCH vseeno-dvojnik v1] */
    if(!selected?.id)return;
    if(napakeGlave.length){ toast.error('Potrditev ni mogoča, račun ima napake: '+napakeGlaveTxt,{duration:8000}); return; } // [PATCH likvidacija-fe v3] (backend enako, 400)
    // [PATCH ir3b-potrdi v1] izdani: kupec je vezan ze na dokumentu -> fallback
    const _partnerId = kontiranje?.partner_id || selected?.partner_id || selected?.partner?.id; // [PATCH ir3b-potrdi-fix2 v1] listing vraca partner objekt
    if(!_partnerId) {
      toast.error('Najprej izberite partnerja iz šifranta!');
      setShowPartnerModal(true);
      return;
    }
    // SM preverjanje: stroskovnomestni konti morajo imeti SM (predlog se shrani, prazni blokirajo)
    const smZahteva = new Set(kontiPlan.filter((k:any)=>k.requires_cost_center).map((k:any)=>String(k.code)));
    const smPredlogi: Record<string,string> = {};
    kontiPlan.forEach((k:any)=>{ if(k.suggested_cost_center) smPredlogi[String(k.code)]=String(k.suggested_cost_center); });
    const knjizbeSSm = (kontiranje.knjizbe||[]).map((kn:any)=>{
      if(smZahteva.has(String(kn.konto)) && !kn.sm){
        const predlog = smPredlogi[String(kn.konto)];
        if(predlog) return {...kn, sm: predlog};
      }
      return kn;
    });
    const manjkaSm = knjizbeSSm.find((kn:any)=>smZahteva.has(String(kn.konto)) && !kn.sm);
    if(manjkaSm){
      toast.error(`Konto ${manjkaSm.konto} zahteva stroškovno mesto (SM)!`);
      return;
    }
    // [PATCH placano-fe v1] "+ Placano" vrstice: brez konta ali placnika ni potrditve
    // [PATCH placano-izdani-fe v1] izdani: partner (prejemnik) je na BREME vrstici
    const _izdPl=jeIzdaniTip(selected?.doc_type);
    // [PATCH placnik-saldakonto-pogoj v1] o partnerju odloca profil, nato sifrant.
    // Gola zastavica placano ne pomeni vec, da vrstica potrebuje placnika: 165002
    // (kartica) in 109000 (denar na poti) v sifrantu nista saldakonta.
    const _pkKonto=String(((_izdPl?placnikProfilIzd:placnikProfil)||{})?.konto||'').trim();
    const _jePlacnikProfil=(kn:any)=>!!kn.placano&&!!_pkKonto&&String(kn.konto||'').trim()===_pkKonto;
    // 1a) placano vrstica brez konta je vedno napaka (dodajPlacano na izdanih ustvari
    //     prazen konto, ker je placnik_delavec_izdani v profilu prazen)
    const brezKonta=(knjizbeSSm||[]).find((kn:any)=>kn.placano&&!String(kn.konto||'').trim());
    if(brezKonta){
      toast.error('Vrstica "+ Plačano": izberite konto, ali obe vrstici izbrišite.');
      return;
    }
    // 1b) placilna vrstica NA PROFILNEM KONTU zahteva placnika/prejemnika
    const manjkaPlacano=(knjizbeSSm||[]).find((kn:any)=>_jePlacnikProfil(kn)&&!kn.partner_id);
    if(manjkaPlacano){
      toast.error(_izdPl?'Vrstica "+ Plačano": izberite prejemnika (delavca), ali obe vrstici izbrišite.':'Vrstica "+ Plačano": izberite plačnika (delavca), ali obe vrstici izbrišite.');
      return;
    }
    // [PATCH saldakonto-partner v1] saldakontni konto zahteva partnerja (trda blokada, kot SM)
    const saldaZahteva=new Set(kontiPlan.filter((k:any)=>k.je_saldakonto).map((k:any)=>String(k.code)));
    const manjkaPartner=(knjizbeSSm||[]).find((kn:any)=>!_jePlacnikProfil(kn)&&saldaZahteva.has(String(kn.konto))&&!kn.partner_id);
    if(manjkaPartner){
      toast.error(`Konto ${manjkaPartner.konto} je saldakonten — izberite partnerja na tej knjižbi!`);
      return;
    }
    const _akt = knjizbeSSm.filter((kb:any)=>kb.tip==='breme').reduce((s:number,kb:any)=>s+Number(kb.znesek||0),0);
    const _pas = knjizbeSSm.filter((kb:any)=>kb.tip==='dobro').reduce((s:number,kb:any)=>s+Number(kb.znesek||0),0);
    if(Math.abs(_akt-_pas)>0.01){
      toast.error(`Aktiva \u2260 Pasiva (${_akt.toFixed(2)} vs ${_pas.toFixed(2)}). Popravite knjizbe pred potrditvijo.`);
      return;
    }
    // [PATCH ddv-kontrola-stopnja v2] TRDI BLOKADI: manjkajoci datumi/obdobje + neskladje DDV evidence
    if (!preveriDatume(datumi)) return;
    if (!preveriDdvKnjigo(kontiranje?.ddv_knjiga || [])) return;
        /* [PATCH izdani-blokada-dialog-fe v2] IZDANI racun, ki ima datum za DDV v
       zaklenjenem obdobju: vprasaj, prestavi SAMO datum za DDV v prvo odprto
       obdobje in oznaci popravek DDV za obdobje IZVIRNEGA datuma za DDV.
       OBDOBJE (datumi.obdobje) SE NE SPREMENI - izrecna zahteva Janez 29.07.2026.
       Prejeta smer je nedotaknjena. setDatumi je asinhron, zato gre v POST
       lokalna kopija, ne state `datumi`. Parni backend patch:
       [PATCH izdani-popravek-obdobje v1] v api/dokumenti.py. */
    let _dtFin: any = datumi;
    let _dkFin: any[] = (kontiranje?.ddv_knjiga || []);
    if (jeIzdaniTip(selected?.doc_type) && ddvBlokada && jeZaklenjeno(datumi.datum_ddv, ddvBlokada)) {
      const _pObd = obdobjeIzDatuma(datumi.datum_ddv) || String(datumi.obdobje || '');
      const _nDan = prviOdprtiDan(ddvBlokada);
      const _nSlo = _nDan.split('-').reverse().join('.');
      if (!window.confirm(
        `Obdobje ${_pObd} je davčno zaklenjeno (blokada do vključno ${mmyyyy(ddvBlokada)}).\n\n` +
        `OK = datum za DDV prestavim na ${_nSlo} in v DDV evidenci označim popravek za ${_pObd}.\n` +
        `Obdobje (${String(datumi.obdobje || '')}) ostane nespremenjeno.\n\n` +
        `Prekliči = računa ne potrdim`)) return;
      _dtFin = { ...datumi, datum_ddv: _nDan };
      _dkFin = _dkFin.map((_v: any) => ({ ..._v, popravek: true, popravek_obdobje: _pObd }));
      setDatumi(_dtFin);
    }
    const kontiranjeFinal = {...kontiranje, partner_id: _partnerId, knjizbe: knjizbeSSm, ddv_knjiga: _dkFin}; /* [PATCH izdani-blokada-dialog-fe v2] */ // [PATCH ir3b-potrdi v1]
    setKontiranje(kontiranjeFinal);
    // PATCH_POTRDI_INSOLV_VAROVALKA_V1: aktivna varovalka pred knjizbo insolventnega partnerja
    try{
      const _ins = await api.get('/insolventnost/preveri', { params: { partner_id: _partnerId } }); // [PATCH ir3b-potrdi v1]
      if(_ins?.data?.insolventen){
        const _po = _ins.data.postopek || {};
        const _odKdaj = _po.od_kdaj || _po.datum_zacetka || _po.datum_objave;
        const _datum = _odKdaj ? fmtDatum(_odKdaj) : '';
        const _naziv = _po.naziv || kontiranje?.partner_ime || 'Partner';
        const _jePP = _po.status === 'potrjena_pp';
        const _msg = _jePP
          ? `\u26a0 OPOMBA: Partner "${_naziv}" je bil v postopku prisilne poravnave (potrjena${_datum ? ', od ' + _datum : ''}).\n\nVseeno potrdim knjižbo?`
          : `\u26a0 POZOR: Partner "${_naziv}" je v postopku: ${_po.vrsta_postopka || 'insolvenčni postopek'}${_datum ? ' (od ' + _datum + ')' : ''}.\n\nVseeno potrdim knjižbo?`;
        if(!window.confirm(_msg)) return;
      }
    }catch(_e){/* preveritev ni uspela - potrjevanja ne blokiramo, pasivni trak ostaja */}
    try{
      const _staraSt=stDok(selected);
      const _novaSt=(stevilkaEdit||'').trim();
      const _sPopravkom=Boolean(_novaSt&&_novaSt!==_staraSt); // SEJA E
      const _rPot=await api.post(`/dokumenti/${companyId}/${selected.id}/potrdi`,{...kontiranjeFinal,datumi:_dtFin,sklic:sestaviSklic(),trr:(trrEdit||'').trim(),opis:(opisVnos||'').trim(),...(_sPopravkom?{popravljena_stevilka:_novaSt}:{})}); // [PATCH rocni-vnos-fe v1]
      toast.success(_sPopravkom?`Potrjeno! Številka popravljena: ${_novaSt}`:'Potrjeno!');
      /* [PATCH tuja-firma-znacka-takoj v1] backend je ob potrditvi ze ugasnil
         tuja_firma.aktivno v bazi; lokalno stanje mora slediti, sicer oranzni
         trak ostane viden do rocne osvezitve. Brez opozorila = no-op. */
      const _kontPotrjeno = kontiranje?.tuja_firma
        ? {...kontiranje, tuja_firma:{...kontiranje.tuja_firma, aktivno:false}}
        : kontiranje;
      if(kontiranje?.tuja_firma) setKontiranje(_kontPotrjeno);
      /* [PATCH badge-po-potrditvi v1] interna st. iz odgovora -> glava + seznam takoj */
      const posodobljen={...selected,status:'approved',kontiranje:_kontPotrjeno,...((_rPot as any)?.data?.interno_st?{interno_st:(_rPot as any).data.interno_st,interno_st_serija:(_rPot as any).data.interno_st_serija}:{}),...(_sPopravkom?{doc_number:_novaSt,ocr:{...(selected.ocr||{}),stevilka:_novaSt}}:{})};
      setSelected(posodobljen);
      setDokumenti(prev=>prev.map(d=>d.id===selected.id?{...d,...posodobljen}:d));
      naloziDokumente(companyId, aktivniTip, iskanje); // [PATCH placano-znacka-fe v1] znacka Placano/status takoj, brez rocne osvezitve
    }catch(e:any){toast.error(e?.response?.data?.detail || 'Napaka pri potrjevanju');}
  };


  // ===== [PATCH u7b-preklic-fe v1] preklic potrditve =====
  // [PATCH preklic-maska v1] gumb samo odpre masko; oznako prenosa preberemo iz
  // `selected` ali iz vrstice v seznamu, da maska ze ob odprtju ve, ali je
  // racun prenesen. Ce tega ne ve, backend vrne 409 {prenesen:true} in maska
  // ostane odprta z opozorilom (glej izvediPreklic).
  const prekliciPotrditev=()=>{
    if(!selected) return;
    const _vrsta:any=dokumenti.find((d:any)=>d.id===selected.id)||{};
    const _exp=selected?.exported_at||_vrsta.exported_at||null;
    const _fmt=selected?.export_format||_vrsta.export_format||null;
    setPreklicPrenos(_exp?{exported_at:_exp,export_format:_fmt}:null);
    setPreklicModal(true);
  };
  // [PATCH preklic-prenesen v1] ce je racun ze prenesen, ga najprej odznacimo
  // prek ISTEGA endpointa kot gumb 'Odznaci izbrane' v Prenosih
  // (PrenosiPage.tsx:99), nato preklicemo potrditev.
  const izvediPreklic=async()=>{
    if(!selected) return;
    const _napakaText=(d:any)=>(typeof d==='string'?d:(d&&d.sporocilo)||'');
    setPreklicBusy(true);
    try{
      const _odznacen=Boolean(preklicPrenos);
      if(_odznacen) await api.post(`/izvoz/${companyId}/odznaci`,{doc_ids:[selected.id]});
      const r=await api.post(`/dokumenti/${companyId}/${selected.id}/preklici-potrditev`,{});
      const op=r?.data?.opozorilo;
      if(op){toast(op);}else{toast.success(r?.data?.ucenje_povrnjeno?'Potrditev preklicana, učenje razveljavljeno.':'Potrditev preklicana.');}
      if(_odznacen) toast.success('Označen za ponovni prenos.');
      const posodobljen={...selected,status:'review_needed',...(_odznacen?{exported_at:null,export_format:null}:{})};
      setSelected(posodobljen);
      setDokumenti(prev=>prev.map(d=>d.id===selected.id?{...d,...posodobljen}:d));
      naloziDokumente(companyId, aktivniTip, iskanje); // [PATCH placano-znacka-fe v1] znacka Placano/status takoj, brez rocne osvezitve
      setPreklicModal(false); setPreklicPrenos(null);
    }catch(e:any){
      const d=e?.response?.data?.detail;
      if(e?.response?.status===409&&d&&typeof d==='object'&&d.prenesen){
        // FE ni vedel, da je racun prenesen — maska ostane odprta z opozorilom
        setPreklicPrenos({exported_at:d.exported_at||null,export_format:d.export_format||null});
      }else{
        toast.error(_napakaText(d)||'Napaka pri preklicu potrditve');
      }
    }finally{ setPreklicBusy(false); }
  };
  // ===== [PATCH rocni-vnos-fe v1] potrditev rocnega vnosa =====
  const sestaviSklic=()=>{
    const st=(sklicData.sklicSt||'').trim()||String(stevilkaEdit||'').replace(/\//g,'-');
    return (sklicData.model+(sklicData.modelSt||'00')+' '+st).trim();
  };
  const potrdiRocni=async()=>{
    const fokus=(id:string,msg:string)=>{toast.error(msg);setTimeout(()=>document.getElementById(id)?.focus(),50);};
    const st=(stevilkaEdit||'').trim();
    if(!st) return fokus('vt-stevilka','Vnesite številko računa');
    if(!kontiranje?.partner_id) return fokus('vt-partner','Izberite partnerja iz šifranta');
    const oz=kontiranje?.ocr_zneski||{};
    if(!(Number(oz.skupaj_z_ddv||0)>0)) return fokus('vt-osnova','Vnesite zneske računa');
    if(!datumi.datum_racuna) return fokus('vt-datum-racuna','Vnesite datum računa');
    const kn=(kontiranje?.knjizbe||[]);
    if(!kn.length||kn.some((k:any)=>!String(k.konto||'').trim())) return fokus('kv-breme-konto','Vpišite konte v vse knjižbe');
    // [PATCH rocni-vnos-fe v2] SM: predlog samodejno, manjkajoci blokira (fokus)
    const smZahtevaR=new Set(kontiPlan.filter((k:any)=>k.requires_cost_center).map((k:any)=>String(k.code)));
    const smPredlogiR:Record<string,string>={};
    kontiPlan.forEach((k:any)=>{ if(k.suggested_cost_center) smPredlogiR[String(k.code)]=String(k.suggested_cost_center); });
    const knjSm=kn.map((k:any)=>{
      if(smZahtevaR.has(String(k.konto))&&!k.sm){
        const p=smPredlogiR[String(k.konto)];
        if(p) return {...k,sm:p};
      }
      return k;
    });
    const manjkaSmR=knjSm.find((k:any)=>smZahtevaR.has(String(k.konto))&&!k.sm);
    if(manjkaSmR) return fokus('kv-breme-sm',`Konto ${manjkaSmR.konto} zahteva stroškovno mesto (SM)`);
    // [PATCH saldakonto-partner v1] saldakontni konto zahteva partnerja
    const saldaZahtevaR=new Set(kontiPlan.filter((k:any)=>k.je_saldakonto).map((k:any)=>String(k.code)));
    // [PATCH placnik-saldakonto-pogoj v1] rocni vnos je vedno prejeti -> profil prejetih
    const _pkR=String((placnikProfil||{})?.konto||'').trim();
    const manjkaPartnerR=knjSm.find((k:any)=>!(!!k.placano&&!!_pkR&&String(k.konto||'').trim()===_pkR)&&saldaZahtevaR.has(String(k.konto))&&!k.partner_id);
    if(manjkaPartnerR) return fokus('kv-breme-konto',`Konto ${manjkaPartnerR.konto} je saldakonten — izberite partnerja`);
    const akt=knjSm.filter((k:any)=>k.tip==='breme').reduce((s:number,k:any)=>s+Number(k.znesek||0),0);
    const pas=knjSm.filter((k:any)=>k.tip==='dobro').reduce((s:number,k:any)=>s+Number(k.znesek||0),0);
    if(Math.abs(akt-pas)>0.01) return fokus('kv-breme-znesek',`Aktiva \u2260 Pasiva (${akt.toFixed(2)} vs ${pas.toFixed(2)})`);
    // [PATCH ddv-kontrola-stopnja v2] TRDI BLOKADI: manjkajoci datumi/obdobje + neskladje DDV evidence
    if (!preveriDatume(datumi)) return;
    if (!preveriDdvKnjigo(kontiranje?.ddv_knjiga || [])) return;
    try{
      const payload={stevilka:st,partner_id:kontiranje.partner_id,sklic:sestaviSklic(),
        trr:(trrEdit||'').trim(),opis:(opisVnos||'').trim(),datumi,zneski:oz,
        ddv_knjiga:kontiranje.ddv_knjiga||[],knjizbe:knjSm,
        devizno:(kontiranje?.devizno?.valuta?{valuta:kontiranje.devizno.valuta,znesek_valuta:kontiranje.devizno.znesek_valuta,tecaj:kontiranje.devizno.tecaj,tecaj_datum:kontiranje.devizno.tecaj_datum,tecaj_vir:kontiranje.devizno.tecaj_vir}:undefined), // [PATCH rocni-vnos-fe v4]
        doc_type:'prejeti_racun'}; // [PATCH rocni-vnos-fe v2]
      const fd=new FormData(); fd.append('payload',JSON.stringify(payload));
      if(rocniFile) fd.append('file',rocniFile);
      const r=await api.post(`/dokumenti/${companyId}/rocni`,fd,{headers:{'Content-Type':'multipart/form-data'}});
      /* [PATCH interne-predpone v1] rocni vnos je vedno prejeti_racun (payload zgoraj) */
      toast.success(`Račun shranjen (interna št. ${internaPrikaz({interno_st:r.data?.interno_st, interno_st_serija:r.data?.interno_st_serija, doc_type:'prejeti_racun'})})`);
      const novId=r.data?.id;
      setEditMode(false); setStevilkaEdit(''); setRocniFile(null);
      const rr=await api.get(`/dokumenti/${companyId}?tip=${aktivniTip}&limit=${limitSezRef.current}${stanjeQS()}`);  // [PATCH seznam-limit-fe v1]
      setDokumenti(rr.data);
      naloziUvozZap(companyId); /* [PATCH uvoz-zaporedje v1] */
      const svez=(rr.data||[]).find((d:any)=>d.id===novId);
      if(svez) izberiDokument(svez); else {setSelected(null);setKontiranje(null);}
    }catch(e:any){
      const d=e?.response?.data?.detail;
      toast.error(typeof d==='string'?d:(d?.sporocilo||'Napaka pri shranjevanju računa'));
    }
  };
  // ===== konec [PATCH rocni-vnos-fe v1] potrditev =====

  return (
    <div className="space-y-0 vt-fokus">{/* [PATCH rocni-vnos-fe v5] fokus obroba */}{/* [PATCH glava-kompakt v1] space-y-4 -> 0: zavihki so v portalu, 16 px praznine pod glavo ni vec potrebnih */}
      <style>{`
        /* [PATCH rocni-vnos-fe v6] jantarni fokus — viden na temni in svetli podlagi */
        .vt-fokus input:focus, .vt-fokus select:focus, .vt-fokus textarea:focus{
          outline:2px solid #f59e0b !important; outline-offset:1px;
          border-color:#f59e0b !important;
          box-shadow:0 0 0 3px rgba(245,158,11,.55), 0 0 12px 2px rgba(245,158,11,.45) !important;
        }
        .vt-fokus button:focus-visible{
          outline:2px solid #f59e0b !important; outline-offset:2px;
          box-shadow:0 0 10px rgba(245,158,11,.5) !important;
        }
        .vt-fokus input[type=checkbox]:focus{
          box-shadow:0 0 0 3px rgba(245,158,11,.6) !important;
        }
        /* [PATCH glava-kompakt v1] gumbi v zgornji rezi manjsi (id premaga Tailwind razrede) */
        #zgornja-reza button{padding:4px 10px;font-size:12px;line-height:1.25;border-radius:8px;gap:6px}
        #zgornja-reza button svg{width:14px;height:14px}
        #zgornja-reza button .rounded-full{font-size:10px;padding:0 5px}
      `}</style>

      {/* [PATCH zgornja-reza v1] zavihki + gumbi uvoza gredo v zgornjo vrstico okvirja (portal);
          ob manjkajoci rezi ostanejo tu. Vsebina bloka nespremenjena. */}
      {((vsebina) => { const reza = document.getElementById('zgornja-reza'); return reza ? createPortal(vsebina, reza) : vsebina; })(
      <div className="w-full flex items-center justify-between gap-2 whitespace-nowrap">{/* [PATCH naziv-prikaz v3] napisi gumbov se ne lomijo */}{/* [PATCH glava-kompakt v1] gap-3 -> gap-2 */}
        <div className="flex gap-2">{/* [PATCH izdaja-dokumenti v1] izbira Prejeti/Izdani je v levem meniju; tu podzavihka Izdanih (samo pri vklopljenem rocnem vnosu) */}
          {aktivniTip==='izdani_racun'&&izdajaModul===true&&!smerAplikacije(preberiAplikacijo())/* [PATCH prodajni-tok v1] v aplikaciji ju nadomesti levi meni */&&([['prenos','Za prenos'],['rocni','Izdani računi']] as const).map(([id,label])=>(
            <button key={id} onClick={()=>{ const sp=new URLSearchParams(searchParams); sp.set('tip','izdani_racun'); if(id==='rocni') sp.set('pogled','rocni'); else sp.delete('pogled'); setSearchParams(sp); }}
              className={clsx('flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium transition border',
                pogledIzdani===id?'bg-blue-600 text-white border-blue-600':'bg-white dark:bg-gray-900 text-gray-600 dark:text-gray-400 border-gray-200 dark:border-gray-700 hover:border-blue-400')}>
              {label}
            </button>
          ))}
        </div>
        {pogledIzdani==='prenos'&&(/* [PATCH prodajni-tok v1b] gumbi uvoza samo v racunovodski obdelavi (pogled prenos) */
        <div className="flex items-center gap-3">
          {/* izvoz prestavljen na stran Prenosi */}

          {aktivniTip==='prejeti_racun'&&(<>{/* [PATCH ir3a-odklep v1] rocni+ePredal samo za prejete */}
          <button onClick={zacniRocniVnos} title="Ročni vnos računa"
            className="flex items-center gap-1 px-3 py-2.5 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl text-sm font-medium hover:border-blue-400 transition">
            <Plus className="w-4 h-4 text-blue-500"/>
          </button>
          <button onClick={uvozIzEPredala} disabled={epBusy}
            className="flex items-center gap-2 px-4 py-2.5 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl text-sm font-medium hover:border-blue-400 transition disabled:opacity-50">
            <Inbox className="w-4 h-4 text-blue-500"/>
            <span>{epBusy?'Prevzemam...':'Uvoz iz ePredala'}</span>
          </button>
          </>)}{/* [PATCH ir3a-odklep v1] */}
          <button onClick={odpriNedavne}
            className="flex items-center gap-2 px-4 py-2.5 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl text-sm font-medium hover:border-red-400 transition">
            <Trash2 className="w-4 h-4 text-red-500"/>
            <span>Nedavni uvozi</span>
          </button>
          {/* [PATCH gumbi-uvoz v1] vrstni red in barve: glavni uvoz (sop) je
              MODER in skrajno desno, posamicni uvoz je bel in levo od njega.
              Logika obeh gumbov je nespremenjena. */}
          {!String(aktivniTip||'').startsWith('izdani')&&(/* [PATCH skrij-dodaj-izdani v1] izdani: /uvozi vrne HTTP 400 -> gumb nefunkcionalen */
          <button onClick={()=>setShowUpload(true)}
            className="flex items-center gap-2 px-4 py-2.5 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl text-sm font-medium hover:border-blue-400 transition">
            <Plus className="w-4 h-4 text-blue-500"/>
            <span>Posamični uvoz</span>
          </button>)}
          {/* [PATCH vod-uvoz-fe v1] gumb samo na zavihku Izdani */}
          {String(aktivniTip||'').startsWith('izdani')&&(
          <button onClick={vodOdpri} title="Uvoz izdanih računov iz XML"
            className="flex items-center gap-2 px-4 py-2.5 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl text-sm font-medium hover:border-blue-400 transition">
            <FileText className="w-4 h-4 text-blue-500"/>
            <span>Uvoz XML</span>
          </button>)}
          {/* [PATCH izdani-eslog-uvoz-fe v1] uvoz e-racunov samo na zavihku Izdani */}
          {String(aktivniTip||'').startsWith('izdani')&&(
          <button onClick={eslOdpri} title="Uvoz izdanih e-računov: e-SLOG XML + PDF (posamezno ali ZIP)"
            className="flex items-center gap-2 px-4 py-2.5 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl text-sm font-medium hover:border-blue-400 transition">
            <FileText className="w-4 h-4 text-emerald-500"/>
            <span>Uvoz e-računov (eSLOG)</span>
          </button>)}
          <button onClick={()=>{ /* [PATCH sop-napredek-fe v1] ob aktivnem sopu okno samo odpremo, stanja ne brisemo */ if(sopStanje&&sopStanje.aktiven){setShowSop(true);return;} setShowSop(true); setSopBatch(null); }}
            className="flex items-center gap-2 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl text-sm font-medium transition">
            <Upload className="w-4 h-4"/>
            <span>Uvoz</span>
          </button>
        </div>
        )}{/* [PATCH prodajni-tok v1b] konec */}
      </div>
      )}{/* [PATCH zgornja-reza v1] konec portala */}



      {/* [PATCH bizbox-prevzem v2] — bizBox prijava */}
      {epModal&&(
        <div className="fixed inset-0 bg-black/60 z-[9998] flex items-center justify-center p-4">
          <div className="bg-white dark:bg-gray-900 rounded-2xl w-full max-w-sm border border-gray-200 dark:border-gray-700 shadow-2xl">
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-700">
              <h3 className="font-bold text-gray-900 dark:text-white">bizBox ePredal — prijava</h3>
              <button onClick={()=>setEpModal(false)} className="text-gray-400 hover:text-white">✕</button>
            </div>
            <div className="p-5 space-y-4">
              <div>
                <label className="text-xs text-gray-400 block mb-1">Uporabniško ime</label>
                <input value={epUser} onChange={e=>setEpUser(e.target.value)} autoFocus
                  className="w-full px-3 py-2 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white outline-none focus:border-blue-500"/>
              </div>
              <div>
                <label className="text-xs text-gray-400 block mb-1">Geslo</label>
                <input type="password" value={epPass} onChange={e=>setEpPass(e.target.value)}
                  onKeyDown={e=>{if(e.key==='Enter')epShraniInPrevzemi();}}
                  placeholder={epNastavljeno?'(nespremenjeno)':''}
                  className="w-full px-3 py-2 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white outline-none focus:border-blue-500"/>
                {epNastavljeno&&<p className="text-[11px] text-gray-500 mt-1">Pusti prazno, da obstoječe geslo ostane.</p>}
              </div>
              <div>
                <label className="text-xs text-gray-400 block mb-1">Strežnik</label>
                <select value={epOkolje} onChange={e=>setEpOkolje(e.target.value)}
                  className="w-full px-3 py-2 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white outline-none focus:border-blue-500 text-sm">
                  <option value="demo">bizBox Demo</option>
                  <option value="prod">bizBox</option>
                </select>
              </div>
              <p className="text-xs text-gray-400">Poverilnice se shranijo pri tem podjetju in se uporabijo za prevzem iz ePredala.</p>
              <button onClick={epShraniInPrevzemi}
                className="w-full py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl text-sm">Shrani in prevzemi</button>
            </div>
          </div>
        </div>
      )}
      {showSekvenca&&(
        <div className="fixed inset-0 bg-black/60 z-[9998] flex items-center justify-center p-4">
          <div className="bg-white dark:bg-gray-900 rounded-2xl w-full max-w-sm border border-gray-200 dark:border-gray-700 shadow-2xl">
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-700">
              <h3 className="font-bold text-gray-900 dark:text-white">Nastavitev številčenja</h3>
              <button onClick={()=>setShowSekvenca(false)} className="text-gray-400 hover:text-white">✕</button>
            </div>
            <div className="p-5 space-y-4">
              <div>
                <label className="text-xs text-gray-400 block mb-1">Naslednja interna številka</label>
                <input type="number" value={sekvenca.next_number}
                  onChange={e=>setSekvenca(s=>({...s,next_number:Number(e.target.value)}))}
                  className="w-full px-3 py-2 bg-gray-800 border border-gray-600 rounded-lg text-white outline-none"/>
              </div>
              <button onClick={async()=>{
                await api.post(`/dokumenti/${companyId}/sekvenca/${aktivniTip}`, sekvenca);
                toast.success('Shranjeno!');setShowSekvenca(false);
              }} className="w-full py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl text-sm">Shrani</button>
            </div>
          </div>
        </div>
      )}

      {showUpload&&(
        <div className="fixed inset-0 bg-black/60 z-[9998] flex items-center justify-center p-4">
          <div className="bg-white dark:bg-gray-900 rounded-2xl w-full max-w-lg border border-gray-200 dark:border-gray-700 shadow-2xl">
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-700">
              <h3 className="font-bold text-gray-900 dark:text-white">Naloži dokument</h3>
              <button onClick={()=>setShowUpload(false)} className="text-gray-400 hover:text-white">✕</button>
            </div>
            <div className="p-5">
              {/* [PATCH posamicni-opomba v1] razmejitev obeh poti uvoza:
                  posamicni = ena datoteka je en dokument (brez razreza),
                  gumb 'Uvoz' = nabor datotek se razreze na racune. */}
              <p className="text-sm text-blue-600 dark:text-blue-400 mb-4">
                Vsak PDF je svoj račun. Če je v enem PDF več računov, uporabi gumb <span className="font-semibold">Uvoz</span>.
              </p>
              <div {...getRootProps()} className={clsx('border-2 border-dashed rounded-2xl p-10 text-center cursor-pointer transition-all',isDragActive?'border-blue-500 bg-blue-50 dark:bg-blue-950':'border-gray-300 dark:border-gray-700 hover:border-blue-400')}>
                <input {...getInputProps()}/>
                <Upload className={clsx('w-10 h-10 mx-auto mb-3',isDragActive?'text-blue-500':'text-gray-400')}/>
                <p className="font-medium text-gray-700 dark:text-gray-300">{uploading?'OCR obdelava...':'Povlecite ali kliknite za nalaganje'}</p>
                <p className="text-sm text-gray-400 mt-1">PDF, JPG, PNG, eSlog XML</p>
                {uploading&&(
                  <div className="mt-4">
                    <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                      <div className="bg-blue-600 h-2 rounded-full transition-all" style={{width:`${uploadProgress}%`}}></div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* [PATCH miniblagajna-fe v1] maska Nastavitve za VKR ob prvem uvozu iz Mini blagajne (409) */}
      {vkrMaska&&(
        <div className="fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center p-4">
          <div className="w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <VkrNastavitveKartica companyId={String(companyId||'')} maska
              onShranjeno={async()=>{const f=vkrMaska; setVkrMaska(null); if(f) await vodPreberi(f);}}
              onPreklici={()=>setVkrMaska(null)}/>
          </div>
        </div>
      )}
      {/* [PATCH izdani-eslog-uvoz-fe v1] maska uvoza e-racunov */}
      {eslOpen&&(
        <div className="fixed inset-0 bg-black/60 z-[9998] flex items-center justify-center p-4">
          <div className="bg-white dark:bg-gray-900 rounded-2xl w-full max-w-4xl border border-gray-200 dark:border-gray-700 shadow-2xl max-h-[90vh] flex flex-col">
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
              <h3 className="font-bold text-gray-900 dark:text-white">Uvoz e-računov (e-SLOG XML + PDF)</h3>
              <button onClick={()=>setEslOpen(false)} disabled={eslBusy} className="text-gray-400 hover:text-white disabled:opacity-40">&#10005;</button>
            </div>
            <div className="p-5 space-y-4 overflow-y-auto">
              {!eslPredogled&&!eslPorocilo&&!eslBusy&&(
                <label className="block border-2 border-dashed rounded-2xl p-10 text-center cursor-pointer border-gray-300 dark:border-gray-700 hover:border-blue-400 transition-all">
                  <input type="file" multiple accept=".zip,.xml,.pdf" className="hidden"
                    onChange={async e=>{const fs=Array.from(e.target.files||[]); e.target.value=''; if(fs.length) await eslPreberi(fs);}}/>
                  <Upload className="w-10 h-10 mx-auto mb-3 text-gray-400"/>
                  <p className="font-medium text-gray-700 dark:text-gray-300">Izberite ZIP ali pare XML + PDF (lahko več naenkrat)</p>
                  <p className="text-sm text-gray-400 mt-1">Datoteke se najprej samo preberejo &mdash; nič se ne zapiše, dokler ne potrdite.</p>
                  <p className="text-[11px] text-gray-400 mt-2">e-SLOG 2.0 in 1.6 · XML in PDF morata imeti enako ime (npr. eSlog_380_123.xml + eSlog_380_123.pdf).</p>
                </label>
              )}
              {eslBusy&&(
                <div className="text-center py-10 text-gray-500 text-sm">{eslPredogled?'Uvažam račune — to lahko traja minuto ali dve…':'Berem datoteke…'}</div>
              )}
              {eslPredogled&&!eslBusy&&(
                <div className="space-y-4">
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                    <div className="px-3 py-2 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-200 dark:border-gray-700">
                      <div className="text-[11px] text-gray-400">Računov</div>
                      <div className="text-lg font-semibold text-gray-800 dark:text-gray-100">{eslPredogled.skupaj.dokumentov}</div>
                    </div>
                    <div className="px-3 py-2 rounded-xl bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800">
                      <div className="text-[11px] text-green-700 dark:text-green-400">Potrjenih</div>
                      <div className="text-lg font-semibold text-green-700 dark:text-green-400">{eslPredogled.skupaj.approved}</div>
                    </div>
                    <div className="px-3 py-2 rounded-xl bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800">
                      <div className="text-[11px] text-amber-700 dark:text-amber-400">V pregled</div>
                      <div className="text-lg font-semibold text-amber-700 dark:text-amber-400">{eslPredogled.skupaj.v_pregled}</div>
                    </div>
                    <div className="px-3 py-2 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-200 dark:border-gray-700">
                      <div className="text-[11px] text-gray-400">Preskočenih</div>
                      <div className="text-lg font-semibold text-gray-800 dark:text-gray-100">{eslPredogled.skupaj.preskocenih}</div>
                    </div>
                  </div>
                  <div className="text-sm text-gray-600 dark:text-gray-300">
                    Skupaj z DDV: <b>{vodZnesek(eslPredogled.skupaj.znesek_skupaj)}</b> &euro;
                    <span className="text-gray-400"> (osnova {vodZnesek(eslPredogled.skupaj.znesek_brez)} + DDV {vodZnesek(eslPredogled.skupaj.znesek_ddv)}) · e-SLOG 2.0: {eslPredogled.skupaj.eslog_20} · 1.6: {eslPredogled.skupaj.eslog_16}</span>
                  </div>
                  <div className="rounded-xl border border-gray-200 dark:border-gray-700 text-xs">
                    <div className="px-3 py-2 border-b border-gray-200 dark:border-gray-700 font-medium text-gray-700 dark:text-gray-300">DDV po vrstah</div>
                    {Object.entries(eslPredogled.po_vrstah||{}).map(([v,x]:any)=>(
                      <div key={v} className="px-3 py-1 flex justify-between gap-2 text-gray-600 dark:text-gray-300">
                        <span>{v} · {x.dokumentov}x</span>
                        <span>osnova {vodZnesek(x.osnova)} &euro; · DDV {vodZnesek(x.ddv)} &euro;</span>
                      </div>
                    ))}
                  </div>
                  {(eslPredogled.dokumenti||[]).filter((d:any)=>d.status!=='validated').length>0&&(
                    <div className="rounded-xl border border-gray-200 dark:border-gray-700">
                      <div className="px-3 py-2 border-b border-gray-200 dark:border-gray-700 text-sm font-medium text-gray-700 dark:text-gray-300">Računi, ki zahtevajo pozornost</div>
                      <div className="max-h-56 overflow-y-auto divide-y divide-gray-100 dark:divide-gray-800">
                        {(eslPredogled.dokumenti||[]).filter((d:any)=>d.status!=='validated').slice(0,200).map((d:any)=>(
                          <div key={d.zap} className="px-3 py-1.5 text-xs">
                            <div className="flex justify-between gap-2">
                              <span className="text-gray-700 dark:text-gray-300 truncate">{d.stevilka||d.xml} · {d.kupec||'—'}</span>
                              <span className="text-amber-600 flex-shrink-0">{ESL_STATUS[d.status]||d.status}{d.znesek!=null?` · ${vodZnesek(d.znesek)} €`:''}</span>
                            </div>
                            {(d.razlog||(d.opozorila||[]).length>0)&&(
                              <div className="text-gray-400">{[d.razlog,...(d.opozorila||[])].filter(Boolean).join(' · ')}</div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  {(eslPredogled.zavrnjene||[]).length>0&&(
                    <div className="px-3 py-2 rounded-xl bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-xs text-red-700 dark:text-red-400">
                      {(eslPredogled.zavrnjene||[]).slice(0,30).map((z:any,i:number)=>(<div key={i}>{z.ime}: {z.razlog}</div>))}
                    </div>
                  )}
                  <div className="flex justify-end gap-2 pt-2">
                    <button onClick={()=>{setEslPredogled(null);setEslFiles([]);}} className="px-4 py-2 rounded-xl text-sm border border-gray-200 dark:border-gray-700">Nazaj</button>
                    <button onClick={eslUvozi} disabled={!eslPredogled.skupaj.uvozljivih}
                      className="px-4 py-2 rounded-xl text-sm font-medium bg-blue-600 hover:bg-blue-700 text-white disabled:opacity-40">
                      Uvozi {eslPredogled.skupaj.uvozljivih} računov
                    </button>
                  </div>
                </div>
              )}
              {eslPorocilo&&!eslBusy&&(
                <div className="space-y-3 text-sm text-gray-700 dark:text-gray-300">
                  <div>Uvoženih <b>{eslPorocilo.uvozenih}</b> (potrjenih {eslPorocilo.approved}, v pregled {eslPorocilo.v_pregled}) · preskočenih {eslPorocilo.preskocenih} · napak {eslPorocilo.napak}</div>
                  {[...(eslPorocilo.napake||[]),...(eslPorocilo.preskoceni||[])].length>0&&(
                    <div className="max-h-56 overflow-y-auto text-xs rounded-xl border border-gray-200 dark:border-gray-700 divide-y divide-gray-100 dark:divide-gray-800">
                      {[...(eslPorocilo.napake||[]),...(eslPorocilo.preskoceni||[])].map((x:any,i:number)=>(
                        <div key={i} className="px-3 py-1.5">{x.stevilka||'—'}: {x.napaka||x.razlog}</div>
                      ))}
                    </div>
                  )}
                  <div className="text-xs text-gray-400">Računi so v »Za prenos«. Uvoz je mogoče razveljaviti v Nedavnih uvozih.</div>
                  <div className="flex justify-end"><button onClick={()=>setEslOpen(false)} className="px-4 py-2 rounded-xl text-sm bg-blue-600 text-white">Zapri</button></div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {/* [PATCH vod-uvoz-fe v1] predogled in izvedba uvoza iz XML */}
      {vodOpen&&(
        <div className="fixed inset-0 bg-black/60 z-[9998] flex items-center justify-center p-4">
          <div className="bg-white dark:bg-gray-900 rounded-2xl w-full max-w-4xl border border-gray-200 dark:border-gray-700 shadow-2xl max-h-[90vh] flex flex-col">
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
              <h3 className="font-bold text-gray-900 dark:text-white">Uvoz XML (VOD, KN-21) / Excel (Mini blagajna) / DBF ali ZIP (Posli){/* [PATCH dbf-racn-fe v1] */}</h3>
              <button onClick={()=>setVodOpen(false)} disabled={vodBusy} className="text-gray-400 hover:text-white disabled:opacity-40">&#10005;</button>
            </div>
            <div className="p-5 space-y-4 overflow-y-auto">

              {!vodPredogled&&!vodPorocilo&&!vodBusy&&(
                <label className="block border-2 border-dashed rounded-2xl p-10 text-center cursor-pointer border-gray-300 dark:border-gray-700 hover:border-blue-400 transition-all">
                  <input type="file" accept=".xml,.html,.txt,.xlsx,.dbf,.DBF,.zip" /* [PATCH dbf-racn-fe v1] */ className="hidden"
                    onChange={async e=>{const fs=Array.from(e.target.files||[]); if(fs.length) await vodPreberi(fs[0]);}}/>
                  <Upload className="w-10 h-10 mx-auto mb-3 text-gray-400"/>
                  <p className="font-medium text-gray-700 dark:text-gray-300">Kliknite za izbiro XML ali Excel (Mini blagajna) datoteke</p>
                  <p className="text-sm text-gray-400 mt-1">Datoteka se najprej samo prebere &mdash; nič se ne zapiše, dokler ne potrdite.</p>
                  <p className="text-[11px] text-gray-400 mt-2">VOD (Vasco FAW, Opal), KN-21 · Mini blagajna: Excel izvoz, ime datoteke se začne z davčno številko podjetja.</p>
                </label>
              )}

              {vodBusy&&!vodPredogled&&!vodPorocilo&&(
                <div className="text-center py-10 text-gray-500 text-sm">Berem datoteko&hellip;</div>
              )}

              {vodPredogled&&(
                <div className="space-y-4">
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                    <div className="px-3 py-2 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-200 dark:border-gray-700">
                      <div className="text-[11px] text-gray-400">Dokumentov</div>
                      <div className="text-lg font-semibold text-gray-800 dark:text-gray-100">{vodPredogled.skupaj.dokumentov}</div>
                    </div>
                    <div className="px-3 py-2 rounded-xl bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800">
                      <div className="text-[11px] text-green-700 dark:text-green-400">Potrjenih</div>
                      <div className="text-lg font-semibold text-green-700 dark:text-green-400">{vodPredogled.skupaj.approved}</div>
                    </div>
                    <div className="px-3 py-2 rounded-xl bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800">
                      <div className="text-[11px] text-amber-700 dark:text-amber-400">V pregled</div>
                      <div className="text-lg font-semibold text-amber-700 dark:text-amber-400">{vodPredogled.skupaj.v_pregled}</div>
                    </div>
                    <div className="px-3 py-2 rounded-xl bg-gray-50 dark:bg-gray-800/50 border border-gray-200 dark:border-gray-700">
                      <div className="text-[11px] text-gray-400">Preskočenih</div>
                      <div className="text-lg font-semibold text-gray-800 dark:text-gray-100">{vodPredogled.skupaj.preskocenih}</div>
                    </div>
                  </div>

                  <div className="text-sm text-gray-600 dark:text-gray-300">
                    Skupaj z DDV: <b>{vodZnesek(vodPredogled.skupaj.znesek_skupaj)}</b> &euro;
                    <span className="text-gray-400"> (osnova {vodZnesek(vodPredogled.skupaj.znesek_brez)} + DDV {vodZnesek(vodPredogled.skupaj.znesek_ddv)})</span>
                    {/* [PATCH oss-uvoz v1] D2: skupna vsota je NETO in je
                        lahko negativna, kadar dobropisi presezejo racune.
                        To ni napaka sestevanja -- zato razclenitev, da je
                        gola negativna stevilka razumljiva. */}
                    {(vodPredogled.skupaj.dobropisov ?? 0) > 0 && (
                      <div className="text-xs text-gray-500 mt-0.5">
                        od tega {vodPredogled.skupaj.racunov} računov{' '}
                        <b>{vodZnesek(vodPredogled.skupaj.znesek_racunov_skupaj)}</b> &euro;
                        {' '}in {vodPredogled.skupaj.dobropisov} dobropisov{' '}
                        <b>{vodZnesek(vodPredogled.skupaj.znesek_dobropisov_skupaj)}</b> &euro;
                      </div>
                    )}
                  </div>

                  {Array.isArray(vodPredogled.manjkajoci_konti)&&vodPredogled.manjkajoci_konti.length>0&&(
                    <div className="px-3 py-2 rounded-xl bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-xs text-red-700 dark:text-red-400">
                      Konti, ki jih ni v kontnem planu: <b>{vodPredogled.manjkajoci_konti.join(', ')}</b>
                      <div className="mt-0.5">Dokumenti s temi konti se ne bodo uvozili.</div>
                    </div>
                  )}

                  {/* [PATCH vod-uvoz-davcna-krizno v1] O4: ta odsek se polni IZKLJUCNO iz novi_partnerji
                      (partner=None in brez kandidatov); kupci, ujeti po jedru davcne, so vezani na obstojecega */}
                  {(vodPredogled.skupaj?.povezanih_po_davcni||0)>0&&(
                    <div className="px-3 py-2 rounded-xl bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 text-xs text-green-700 dark:text-green-400">
                      {vodPredogled.skupaj.povezanih_po_davcni} dokumentov povezanih z obstoječimi partnerji po davčni številki (novi partnerji se zanje ne ustvarijo).
                    </div>
                  )}
                  {Array.isArray(vodPredogled.novi_partnerji)&&vodPredogled.novi_partnerji.length>0&&(
                    <div className="rounded-xl border border-gray-200 dark:border-gray-700">
                      <label className="flex items-center gap-2 px-3 py-2.5 border-b border-gray-200 dark:border-gray-700 cursor-pointer">
                        <input type="checkbox" checked={vodUstvari} onChange={e=>setVodUstvari(e.target.checked)} className="w-4 h-4"/>
                        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                          Dodaj {vodPredogled.novi_partnerji.length} novih partnerjev v šifrant
                        </span>
                      </label>
                      <div className="max-h-40 overflow-y-auto divide-y divide-gray-100 dark:divide-gray-800">
                        {vodPredogled.novi_partnerji.slice(0,50).map((p:any,i:number)=>(
                          <div key={i} className="px-3 py-1.5 text-xs flex items-center justify-between gap-2">
                            <span className="text-gray-700 dark:text-gray-300 truncate">{p.naziv}</span>
                            <span className="text-gray-400 flex-shrink-0">{p.vat||p.davcna||'brez davčne'} &middot; {p.dokumentov}x</span>
                          </div>
                        ))}
                        {vodPredogled.novi_partnerji.length>50&&(
                          <div className="px-3 py-1.5 text-xs text-gray-400">... in se {vodPredogled.novi_partnerji.length-50}</div>
                        )}
                      </div>
                      {!vodUstvari&&(
                        <div className="px-3 py-1.5 text-[11px] text-amber-600 border-t border-gray-200 dark:border-gray-700">
                          Brez tega bodo računi teh kupcev uvoženi brez partnerja in bodo končali v pregledu.
                        </div>
                      )}
                    </div>
                  )}

                  {Array.isArray(vodPredogled.dvojniki_sifranta)&&vodPredogled.dvojniki_sifranta.length>0&&(
                    <div className="rounded-xl border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-900/20">
                      <div className="px-3 py-2 text-xs font-semibold text-amber-800 dark:text-amber-400 border-b border-amber-200 dark:border-amber-800">
                        Zaznani dvojniki v šifrantu ({vodPredogled.dvojniki_sifranta.length}) &mdash; uvoz jih ne spreminja
                      </div>
                      <div className="max-h-36 overflow-y-auto p-2 space-y-1.5">
                        {vodPredogled.dvojniki_sifranta.map((d:any,i:number)=>(
                          <div key={i} className="text-[11px]">
                            <div className="text-amber-900 dark:text-amber-300 font-medium">{d.iskano}</div>
                            {(d.zapisi||[]).map((z:any,j:number)=>(
                              <div key={j} className="text-amber-700 dark:text-amber-400 pl-3">
                                {z.ime} {z.sifra?`(šifra ${z.sifra})`:''} {z.naslov?`\u2014 ${z.naslov}`:''}
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  <div>
                    <div className="flex items-center justify-between mb-1.5">
                      <span className="text-xs font-semibold text-gray-600 dark:text-gray-300">
                        {vodVse?'Vsi dokumenti':'Dokumenti, ki potrebujejo pozornost'}
                      </span>
                      <button onClick={()=>setVodVse(!vodVse)} className="text-[11px] text-blue-600 hover:underline">
                        {vodVse?'Prikaži samo problematične':'Prikaži vse'}
                      </button>
                    </div>
                    <div className="max-h-64 overflow-y-auto border border-gray-200 dark:border-gray-700 rounded-lg divide-y divide-gray-100 dark:divide-gray-800">
                      {vodPredogled.dokumenti.filter((d:any)=>vodVse||d.preskoci||d.predlagan_status==='review_needed').slice(0,300).map((d:any)=>(
                        <div key={d.zap} className="px-3 py-1.5 text-xs">
                          <div className="flex items-center justify-between gap-2">
                            <span className="text-gray-700 dark:text-gray-300 truncate">
                              {d.stevilka} &middot; {d.datum||''} &middot; {d.kupec||'brez kupca'}
                            </span>
                            <span className={clsx('font-medium flex-shrink-0',
                              d.preskoci?'text-red-600':d.predlagan_status==='approved'?'text-green-600':'text-amber-600')}>
                              {d.preskoci?'ne bo uvožen':d.predlagan_status==='approved'?'potrjen':'v pregled'}
                              {' '}{vodZnesek(d.skupaj)}
                            </span>
                          </div>
                          {d.preskoci&&d.razlog&&(<div className="text-red-500 mt-0.5 break-words">{d.razlog}</div>)}
                          {!d.preskoci&&d.razlog_pregleda&&(<div className="text-amber-600 mt-0.5 break-words">{d.razlog_pregleda}</div>)}
                          {!d.preskoci&&d.partner_nacin&&(<div className="text-gray-400 mt-0.5 break-words">kupec: {d.partner_nacin}</div>)}
                          {/* [PATCH vod-uvoz-davcna-krizno v1] O4: ujemanje po jedru davcne = vezava na obstojecega, nikoli nov partner */}
                          {!d.preskoci&&d.partner_oznaka&&(<div className="text-green-600 mt-0.5 break-words">{d.partner_oznaka}</div>)}
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="flex gap-2 pt-1">
                    <button onClick={()=>{setVodPredogled(null);setVodFile(null);}} disabled={vodBusy}
                      className="flex-1 py-2.5 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl text-sm font-semibold disabled:opacity-50">
                      Druga datoteka
                    </button>
                    <button onClick={vodUvozi} disabled={vodBusy||!vodPredogled.skupaj.uvozljivih}
                      className="flex-[2] py-2.5 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white font-semibold rounded-xl text-sm">
                      {vodBusy?'Uvažam…':`Uvozi ${vodPredogled.skupaj.uvozljivih} računov`}
                    </button>
                  </div>
                </div>
              )}

              {vodPorocilo&&(
                <div className="space-y-3">
                  <div className="px-4 py-3 rounded-xl bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800">
                    <div className="text-sm font-semibold text-green-800 dark:text-green-400">
                      Uvoženih {vodPorocilo.uvozenih} računov
                    </div>
                    <div className="text-xs text-green-700 dark:text-green-500 mt-0.5">
                      {vodPorocilo.approved} potrjenih &middot; {vodPorocilo.v_pregled} v pregledu
                      {vodPorocilo.ustvarjenih_partnerjev>0?` \u00b7 ${vodPorocilo.ustvarjenih_partnerjev} novih partnerjev`:''}
                    </div>
                  </div>
                  {vodPorocilo.napak>0&&(
                    <div className="px-3 py-2 rounded-xl bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800">
                      <div className="text-xs font-semibold text-red-700 dark:text-red-400 mb-1">{vodPorocilo.napak} napak</div>
                      <div className="max-h-32 overflow-y-auto space-y-0.5">
                        {(vodPorocilo.napake||[]).map((n:any,i:number)=>(
                          <div key={i} className="text-[11px] text-red-600 break-words">{n.stevilka}: {n.napaka}</div>
                        ))}
                      </div>
                    </div>
                  )}
                  <button onClick={()=>setVodOpen(false)}
                    className="w-full py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl text-sm">
                    Zapri
                  </button>
                </div>
              )}

            </div>
          </div>
        </div>
      )}

      {showSop&&(
        <div className="fixed inset-0 bg-black/60 z-[9998] flex items-center justify-center p-4">
          <div className="bg-white dark:bg-gray-900 rounded-2xl w-full max-w-lg border border-gray-200 dark:border-gray-700 shadow-2xl">
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-700">
              <h3 className="font-bold text-gray-900 dark:text-white">Uvoz računov</h3>
              <button onClick={()=>setShowSop(false)} title="Zapri — obdelava teče naprej v ozadju" className="text-gray-400 hover:text-white">✕</button>{/* [PATCH sop-ozadje v1] */}
            </div>
            <div className="p-5 space-y-4">
              {!sopBatch&&!sopBusy&&(
                <label className="block border-2 border-dashed rounded-2xl p-10 text-center cursor-pointer border-gray-300 dark:border-gray-700 hover:border-blue-400 transition-all">
                  <input type="file" accept=".pdf,.doc,.docx" multiple className="hidden" /* [PATCH sop-multi-fe v1] */ onChange={async e=>{const fs=Array.from(e.target.files||[]); if(!fs.length) return; /* [PATCH uvoz-iz-mape v3] dovoljenje se zahteva, dokler velja uporabnikova poteza */ const mapaOk=await mapaPripravi(); const bid=(fs.length===1&&/\.pdf$/i.test(fs[0].name))?await uploadSop(fs[0]):await uploadSopMulti(fs); if(bid&&mapaOk) await premakniPoslane(fs);}}/>
                  <Upload className="w-10 h-10 mx-auto mb-3 text-gray-400"/>
                  <p className="font-medium text-gray-700 dark:text-gray-300">Kliknite za izbiro datotek</p>
                  <p className="text-sm text-gray-400 mt-1">PDF ali Word (.doc, .docx) — lahko več datotek naenkrat</p>
                </label>
              )}
              {/* [PATCH uvoz-iz-mape v3] nastavitev mape s skeni (samo Chrome/Edge) */}
              {!sopBatch&&!sopBusy&&fsaNaVoljo&&(
                <div className="px-3 py-2.5 rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
                  <div className="flex items-center justify-between gap-3">
                    <div className="min-w-0">
                      <p className="text-xs text-gray-400">Mapa za {String(aktivniTip||'').startsWith('izdani')?'izdane':'prejete'} račune</p>
                      <p className="text-sm font-medium text-gray-700 dark:text-gray-300 truncate">{mapaIme||'ni nastavljena'}</p>
                    </div>
                    {/* [PATCH uvoz-iz-mape v4] Spremeni + Odstrani eden pod drugim */}
                    <div className="flex-shrink-0 flex flex-col gap-1.5">
                      <button onClick={nastaviMapo}
                        className="px-3 py-1.5 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg text-xs font-medium hover:border-blue-400 transition">
                        {mapaIme?'Spremeni':'Nastavi'}
                      </button>
                      {mapaIme&&(
                      <button onClick={odstraniMapo} title="Program ne bo vec premikal datotek"
                        className="px-3 py-1.5 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg text-xs font-medium text-red-600 hover:border-red-400 transition">
                        Odstrani
                      </button>)}
                    </div>
                  </div>
                  {mapaIme&&(
                    <p className="text-[11px] text-gray-400 mt-1.5">Naložene datoteke se po uvozu premaknejo v podmapo _UVOZENO.</p>
                  )}
                </div>
              )}
              {sopBusy&&!sopBatch&&(
                <div className="text-center py-8 text-gray-500 text-sm">Nalagam in pripravljam razrez...</div>
              )}
              {sopBatch&&(
                <div className="space-y-3">
                  <div className="flex items-center justify-between text-sm">
                    <span className="font-medium text-gray-700 dark:text-gray-300">Status: {oznakaStatusa(sopBatch.status)}</span>
                    <span className="text-gray-400">{(sopBatch.st_koncano||0)+(sopBatch.st_preskoceno||0)+(sopBatch.st_napak||0)} / {sopBatch.st_dokumentov||0}</span>
                  </div>
                  <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                    <div className="bg-blue-600 h-2 rounded-full transition-all" style={{width:`${sopBatch.st_dokumentov?Math.round(((sopBatch.st_koncano||0)+(sopBatch.st_preskoceno||0)+(sopBatch.st_napak||0))/sopBatch.st_dokumentov*100):0}%`}}></div>
                  </div>
                  <div className="flex gap-3 text-xs">
                    {/* [PATCH sop-kos-pdf v1] znacke so gumbi-filtri; klik na aktivnega ga izklopi */}
                    <button type="button" onClick={()=>setSopFilter(sopFilter==='koncano'?'':'koncano')} className={clsx('px-2 py-0.5 rounded-full text-green-600',sopFilter==='koncano'&&'bg-green-100 dark:bg-green-900/40 font-semibold')}>✓ {sopBatch.st_koncano||0} uvoženih</button>
                    <button type="button" onClick={()=>setSopFilter(sopFilter==='preskocen'?'':'preskocen')} className={clsx('px-2 py-0.5 rounded-full text-amber-600',sopFilter==='preskocen'&&'bg-amber-100 dark:bg-amber-900/40 font-semibold')}>↷ {sopBatch.st_preskoceno||0} preskočenih</button>
                    {(sopBatch.st_napak||0)>0&&<button type="button" onClick={()=>setSopFilter(sopFilter==='napaka'?'':'napaka')} className={clsx('px-2 py-0.5 rounded-full text-red-600',sopFilter==='napaka'&&'bg-red-100 dark:bg-red-900/40 font-semibold')}>✕ {sopBatch.st_napak} napak</button>}
                    {sopFilter&&<button type="button" onClick={()=>setSopFilter('')} className="text-gray-400 underline">vsi</button>}
                  </div>
                  {/* [PATCH izdani-ir2 v1] poročilo razreza izdanih */}
                  {Array.isArray(sopBatch.meta?.vrzeli)&&sopBatch.meta.vrzeli.length>0&&(
                    <p className="text-[11px] text-amber-600">⚠ Vrzeli v zaporedju (v tem šopu manjkajo): {sopBatch.meta.vrzeli.map((v:number)=>String(v).padStart(5,'0')).join(', ')}</p>
                  )}
                  {Array.isArray(sopBatch.meta?.rekonstruirane)&&sopBatch.meta.rekonstruirane.length>0&&(
                    <p className="text-[11px] text-red-600">⚠ Rekonstruirane številke (obvezno preveri): {sopBatch.meta.rekonstruirane.join(', ')}</p>
                  )}
                  {sopBatch.status!=='koncano'&&sopBatch.status!=='napaka'&&<p className="text-[11px] text-gray-400">Okno lahko zaprete — obdelava teče naprej, ob zaključku boste obveščeni.</p>}
                  {sopBatch.dokumenti&&(
                    <div className="max-h-56 overflow-y-auto border border-gray-200 dark:border-gray-700 rounded-lg divide-y divide-gray-100 dark:divide-gray-800">
                      {sopBatch.dokumenti.filter((it:any)=>/* [PATCH sop-kos-pdf v1] */!sopFilter||it.status===sopFilter||(sopFilter==='preskocen'&&it.status==='izpuscen')).map((it:any)=>(
                        <div key={it.zap} className="px-3 py-1.5 text-xs">{/* [PATCH sop-dnevnik-guard v2] razlog pri preskocenih/napakah */}
                          <div className="flex items-center justify-between">
                            <span className="text-gray-600 dark:text-gray-300 truncate">#{it.zap} · str. {Array.isArray(it.strani)?it.strani.join(','):''} · {it.st_racuna_zaznana||'—'}</span>
                            <span className={clsx('font-medium flex-shrink-0 ml-2',it.status==='koncano'?'text-green-600':it.status==='preskocen'?'text-amber-600':it.status==='napaka'?'text-red-600':'text-gray-400')}>{oznakaStatusa(it.status)}</span>{/* [PATCH sop-kos-pdf v1] */(it.status==='preskocen'||it.status==='napaka'||it.status==='izpuscen')&&sopBatch.batch_id&&(<button type="button" onClick={()=>odpriKosPdf(sopBatch.batch_id,it.zap)} className="ml-2 flex-shrink-0 text-blue-600 hover:underline">📄 PDF</button>)}{/* [PATCH vseeno-dvojnik v1] */it.status==='preskocen'&&sopBatch.batch_id&&(<button type="button" disabled={vseenoBusy!==null} onClick={()=>vseenoUvozi(sopBatch.batch_id,it.zap)} className="ml-2 flex-shrink-0 text-amber-700 hover:underline disabled:opacity-50">{vseenoBusy===it.zap?'Uvažam…':'Vseeno uvozi'}</button>)}
                          </div>
                          {/* [PATCH tuja-firma-opozorilo v1] 'koncano' + napaka = uvozen z opozorilom */}
                          {(it.status==='preskocen'||it.status==='napaka'||it.status==='koncano')&&it.napaka&&(
                            <div className={clsx('mt-0.5 break-words',it.status==='napaka'?'text-red-500':it.status==='koncano'?'text-orange-600':'text-amber-600')}>{it.status==='koncano'?'⚠ ':''}{it.napaka}</div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                  {(sopBatch.status==='koncano'||sopBatch.status==='napaka')&&(
                    <div className="flex gap-2"><button onClick={()=>sopBatch?.batch_id&&odpriRazveljavitev(sopBatch.batch_id)} disabled={razvBusy} className="flex-1 py-2.5 bg-red-600 hover:bg-red-700 disabled:opacity-50 text-white font-semibold rounded-xl text-sm">{razvBusy?'Pripravljam…':'Razveljavi uvoz'}</button><button onClick={()=>{ /* [PATCH sop-napredek-fe v1] okno se samo zapre; povzetek ostane v Mojih podjetjih do naslednjega uvoza */ setShowSop(false); }} className="flex-1 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl text-sm">Zapri</button></div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {/* [PATCH rocni-razrez-fe v1a] izbira mest reza */}
      {razrezOpen && razrezInfo && (
        <div className="fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center p-4" onClick={()=>{ if(!razrezBusy) setRazrezOpen(false); }}>
          <div className="bg-white dark:bg-gray-900 rounded-2xl w-full max-w-md border border-gray-200 dark:border-gray-700 shadow-2xl p-5" onClick={e=>e.stopPropagation()}>
            <h3 className="font-bold text-gray-900 dark:text-white mb-1">Razdeli dokument</h3>
            <p className="text-sm text-gray-500 mb-4">
              Dokument <b>{razrezInfo.doc_number||'brez številke'}</b> ima {razrezInfo.st_strani} strani.
            </p>
            <div className="mb-4">
              <div className="text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1.5">Na koliko delov razdelim?</div>
              <div className="flex flex-wrap gap-2">
                {Array.from({length:Math.max(0,Number(razrezInfo.st_strani||0)-1)},(_,i)=>i+2).map((k:number)=>(
                  <button key={k} onClick={()=>nastaviRazrezDelov(k)} disabled={razrezBusy}
                    className={clsx('px-3 py-1.5 rounded-lg border text-sm font-mono disabled:opacity-50',
                      razrezDelov===k?'bg-blue-600 text-white border-blue-600':'border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300')}>
                    {k}
                  </button>
                ))}
              </div>
            </div>
            <div className="space-y-1.5 mb-4">
              {Array.from({length:razrezDelov},(_,i)=>i).map((i:number)=>{
                const nStr=Number(razrezInfo.st_strani||0);
                const od=i===0?1:(razrezRezi[i-1]||i)+1;
                const zadnji=i===razrezDelov-1;
                const maxRez=nStr-(razrezDelov-1-i);
                const moznosti:number[]=[];
                for(let p=od;p<=maxRez;p++) moznosti.push(p);
                return (
                  <div key={i} className="flex items-center gap-2 text-sm">
                    <span className="w-14 text-gray-500">{i+1}. del</span>
                    <span className="text-gray-700 dark:text-gray-300">strani {od}</span>
                    <span className="text-gray-400">&ndash;</span>
                    {zadnji ? (
                      <span className="font-mono font-semibold text-gray-900 dark:text-white">{nStr}</span>
                    ) : (
                      <select value={razrezRezi[i]||od} disabled={razrezBusy}
                        onChange={e=>nastaviRez(i,Number(e.target.value))}
                        className="px-2 py-1 rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white font-mono disabled:opacity-50">
                        {moznosti.map((p:number)=>(<option key={p} value={p}>{p}</option>))}
                      </select>
                    )}
                  </div>
                );
              })}
            </div>
            <div className="bg-amber-50 dark:bg-amber-950 border border-amber-300 dark:border-amber-800 text-amber-800 dark:text-amber-300 rounded-xl px-3 py-2 text-xs mb-4">
              Izvirni dokument bo <b>izbrisan</b>. Vsak del gre znova skozi prepoznavo in kontiranje. Dejanja ni mogoče razveljaviti.
            </div>
            <button onClick={izvediRazrez} disabled={razrezBusy}
              className="w-full py-2.5 bg-red-600 hover:bg-red-700 disabled:opacity-50 text-white font-semibold rounded-xl text-sm">
              {razrezBusy?'Razdeljujem\u2026':`Razdeli na ${razrezDelov} dele`}
            </button>
            <button onClick={()=>setRazrezOpen(false)} disabled={razrezBusy} className="w-full mt-2 py-2 text-sm text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">Prekliči</button>
          </div>
        </div>
      )}
      {/* [PATCH zdruzi-fe v3] izbira dokumentov; vrstni red klikanja = vrstni red strani */}
      {zdruziOpen && zdruziInfo && (
        <div className="fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center p-4" onClick={()=>{ if(!zdruziBusy) setZdruziOpen(false); }}>
          <div className="bg-white dark:bg-gray-900 rounded-2xl w-full max-w-lg border border-gray-200 dark:border-gray-700 shadow-2xl p-5" onClick={e=>e.stopPropagation()}>
            <h3 className="font-bold text-gray-900 dark:text-white mb-1">Združi dokumente</h3>
            <p className="text-sm text-gray-500 mb-3">
              <b>{zdruziInfo.doc_number||'brez številke'}</b> ({zdruziRazpon(1,Number(zdruziInfo.st_strani||1))}) je prvi. Klikni dokumente v vrstnem redu, kot naj si sledijo; ponoven klik odznači.
            </p>
            <input value={zdruziQ} disabled={zdruziBusy} placeholder="Išči po partnerju, številki, znesku…"
              onChange={e=>{ const v=e.target.value; setZdruziQ(v); isciZdruziKand(v); }}
              className="w-full mb-3 px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white text-sm disabled:opacity-50"/>
            <div className="max-h-60 overflow-y-auto space-y-1 mb-3">
              {zdruziKand.length===0 && (
                <div className="text-center py-6 text-gray-500 text-sm">Ni zadetkov.</div>
              )}
              {zdruziKand.map((d:any)=>{
                const poz=zdruziPolozaj(d.id);
                const izbran=poz>=0;
                return (
                  <button key={d.id} type="button" disabled={zdruziBusy} onClick={()=>preklopiZdruziKand(d)}
                    className={clsx('w-full text-left px-3 py-2 rounded-lg border text-sm disabled:opacity-50',
                      izbran?'bg-blue-600 text-white border-blue-600':'border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800')}>
                    <div className="flex items-center justify-between gap-2">
                      <span className="flex items-center gap-2 min-w-0">
                        {izbran&&(<span className="flex-shrink-0 w-5 h-5 rounded-full bg-white text-blue-600 text-xs font-bold flex items-center justify-center">{poz+2}</span>)}
                        <span className="font-mono font-semibold truncate">{d.doc_number||d.ocr?.stevilka||'brez številke'}</span>
                      </span>
                      <span className="font-mono flex-shrink-0">{d.amount_total!=null?Number(d.amount_total).toLocaleString('sl-SI',{minimumFractionDigits:2,maximumFractionDigits:2}):''}</span>
                    </div>
                    <div className={clsx('text-xs truncate',izbran?'text-blue-100':'text-gray-500')}>
                      {izbran&&(<b className="mr-2">{zdruziRazpon(zdruziZacetnaStran(poz),Number(zdruziIzbrani[poz]?.st_strani||1))}</b>)}
                      {d.partner?.ime||d.ocr?.izdajatelj?.ime||d.file_name||'—'}
                      {d.status==='approved'&&(<span className="ml-2 text-amber-500">potrjen</span>)}
                      {d.exported_at&&(<span className="ml-2 text-amber-500">prenesen</span>)}
                    </div>
                  </button>
                );
              })}
            </div>
            {zdruziIzbrani.length>0 && (
              <div className="mb-3 rounded-xl border border-gray-200 dark:border-gray-700 px-3 py-2">
                <div className="text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1.5">Vrstni red strani</div>
                <div className="space-y-0.5 text-xs">
                  <div className="flex items-center gap-2">
                    <span className="text-gray-400 w-4 flex-shrink-0">1.</span>
                    <span className="font-mono truncate">{zdruziInfo.doc_number||'brez številke'}</span>
                    <span className="ml-auto text-gray-500 flex-shrink-0">{zdruziRazpon(1,Number(zdruziInfo.st_strani||1))}</span>
                  </div>
                  {zdruziIzbrani.map((x:any,i:number)=>(
                    <div key={x.id} className="flex items-center gap-2">
                      <span className="text-gray-400 w-4 flex-shrink-0">{i+2}.</span>
                      <span className="font-mono truncate">{x.doc_number}</span>
                      <span className="ml-auto text-gray-500 flex-shrink-0">{zdruziRazpon(zdruziZacetnaStran(i),Number(x.st_strani||1))}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className="bg-amber-50 dark:bg-amber-950 border border-amber-300 dark:border-amber-800 text-amber-800 dark:text-amber-300 rounded-xl px-3 py-2 text-xs mb-4">
              <b>Vsi izbrani dokumenti bodo izbrisani.</b> Iz združenega PDF nastane nov dokument, ki gre znova skozi prepoznavo in kontiranje — zneski se preberejo na novo. Dejanja ni mogoče razveljaviti.
            </div>
            <button onClick={izvediZdruzi} disabled={zdruziBusy||zdruziIzbrani.length===0}
              className="w-full py-2.5 bg-red-600 hover:bg-red-700 disabled:opacity-50 text-white font-semibold rounded-xl text-sm">
              {zdruziBusy?'Združujem…':(zdruziIzbrani.length===0?'Izberi vsaj en dokument':`Združi ${zdruziIzbrani.length+1} ${sklonDok(zdruziIzbrani.length+1)} (${zdruziSkupajStrani()} str.)`)}
            </button>
            <button onClick={()=>setZdruziOpen(false)} disabled={zdruziBusy} className="w-full mt-2 py-2 text-sm text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">Prekliči</button>
          </div>
        </div>
      )}
      {/* [PATCH razveljavi-uvoz-fe v1] izbira obsega razveljavitve */}
      {razvOpen && razvInfo && (
        <div className="fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center p-4" onClick={()=>setRazvOpen(false)}>
          <div className="bg-white dark:bg-gray-900 rounded-2xl w-full max-w-md border border-gray-200 dark:border-gray-700 shadow-2xl p-5" onClick={e=>e.stopPropagation()}>
            <h3 className="font-bold text-gray-900 dark:text-white mb-1">Razveljavi uvoz</h3>
            <p className="text-sm text-gray-500 mb-4">Trajno izbriše dokumente, ki so nastali iz tega šopa. Dejanja ni mogoče razveljaviti.</p>
            {razvInfo.ima_vec_uvozov ? (
              <div className="space-y-2">
                <button onClick={()=>izvediRazveljavitev('zadnji_uvoz')} disabled={razvBusy} className="w-full text-left px-4 py-3 rounded-xl border border-gray-200 dark:border-gray-700 hover:border-red-400 disabled:opacity-50">
                  <div className="font-semibold text-gray-900 dark:text-white text-sm">Samo zadnji uvoz</div>
                  <div className="text-xs text-gray-500">{razvInfo.zadnji_uvoz?.st_dokumentov||0} dokumentov iz zadnjega uvoza te datoteke</div>
                </button>
                <button onClick={()=>izvediRazveljavitev('cel_sop')} disabled={razvBusy} className="w-full text-left px-4 py-3 rounded-xl border border-gray-200 dark:border-gray-700 hover:border-red-400 disabled:opacity-50">
                  <div className="font-semibold text-gray-900 dark:text-white text-sm">Cel sop</div>
                  <div className="text-xs text-gray-500">{razvInfo.cel_sop?.st_dokumentov||0} dokumentov iz vseh {razvInfo.cel_sop?.st_uvozov||1} uvozov te datoteke</div>
                </button>
              </div>
            ) : (
              <button onClick={()=>izvediRazveljavitev('cel_sop')} disabled={razvBusy} className="w-full py-2.5 bg-red-600 hover:bg-red-700 disabled:opacity-50 text-white font-semibold rounded-xl text-sm">{razvBusy?'Brišem\u2026':`Razveljavi (${razvInfo.cel_sop?.st_dokumentov||0})`}</button>
            )}
            <button onClick={()=>setRazvOpen(false)} disabled={razvBusy} className="w-full mt-2 py-2 text-sm text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">Prekliči</button>
          </div>
        </div>
      )}
      {/* [PATCH razveljavi-uvoz-fe v1] blokade pri razveljavitvi */}
      {blokData && (
        <div className="fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center p-4" onClick={()=>setBlokData(null)}>
          <div className="bg-white dark:bg-gray-900 rounded-2xl w-full max-w-lg border border-gray-200 dark:border-gray-700 shadow-2xl p-5 max-h-[80vh] overflow-auto" onClick={e=>e.stopPropagation()}>
            <h3 className="font-bold text-gray-900 dark:text-white mb-1">Razveljavitev je blokirana</h3>
            <p className="text-sm text-gray-500 mb-3">Naslednji dokumenti so ze preneseni ali imajo povezave/placila. Odstrani oznako oz. povezave, nato poskusi znova.</p>
            {(blokData.preneseni||[]).length>0 && (
              <div className="mb-3">
                <div className="text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">Že preneseni v računovodski program</div>
                {blokData.preneseni.map((d:any)=>(
                  <div key={d.doc_id} className="flex items-center justify-between gap-2 p-2 rounded border border-gray-200 dark:border-gray-700 mb-1">
                    <span className="text-sm text-gray-700 dark:text-gray-300 flex-1 truncate">{d.doc_number||d.doc_id}</span>
                    <button onClick={()=>oznaciNeprenoseno(d.doc_id)} className="text-xs px-2 py-1 rounded bg-amber-100 text-amber-700 hover:bg-amber-200 dark:bg-amber-900/40 dark:text-amber-300 flex-shrink-0">Označi kot neprenešeno</button>
                  </div>
                ))}
              </div>
            )}
            {(blokData.povezave_placila||[]).length>0 && (
              <div className="mb-3">
                <div className="text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">Imajo povezave ali placila</div>
                {blokData.povezave_placila.map((d:any)=>(
                  <div key={d.doc_id} className="p-2 rounded border border-gray-200 dark:border-gray-700 mb-1 text-sm text-gray-700 dark:text-gray-300">
                    {d.doc_number||d.doc_id} — odstrani povezave/placila pri samem dokumentu
                  </div>
                ))}
              </div>
            )}
            <div className="flex gap-2 mt-2">
              <button onClick={()=>{ setBlokData(null); izvediRazveljavitev(blokObseg); }} disabled={(blokData.preneseni||[]).length>0 || razvBusy} className="flex-1 py-2.5 bg-red-600 hover:bg-red-700 disabled:opacity-50 text-white font-semibold rounded-xl text-sm">Poskusi znova</button>
              <button onClick={()=>setBlokData(null)} className="flex-1 py-2.5 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 font-semibold rounded-xl text-sm">Zapri</button>
            </div>
            {(blokData.povezave_placila||[]).length>0 && (blokData.preneseni||[]).length===0 && (
              <p className="text-[11px] text-amber-600 mt-2">Dokumenti s povezavami/placili bodo se vedno blokirani — najprej jih razvezi pri dokumentu.</p>
            )}
          </div>
        </div>
      )}
      {/* [PATCH nedavni-uvozi-fe v1] seznam nedavnih šop uvozov */}
      {nedavniOpen && (
        <div className="fixed inset-0 bg-black/60 z-[9998] flex items-center justify-center p-4" onClick={()=>setNedavniOpen(false)}>
          <div className="bg-white dark:bg-gray-900 rounded-2xl w-full max-w-2xl border border-gray-200 dark:border-gray-700 shadow-2xl max-h-[85vh] flex flex-col" onClick={e=>e.stopPropagation()}>
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-700">
              <h3 className="font-bold text-gray-900 dark:text-white">Nedavni uvozi šopov</h3>
              <button onClick={()=>setNedavniOpen(false)} className="text-gray-400 hover:text-white">✕</button>
            </div>
            <div className="p-4 overflow-auto">
              {nedavniBusy ? (
                <div className="text-center py-8 text-gray-500 text-sm">Nalagam...</div>
              ) : nedavni.length===0 ? (
                <div className="text-center py-8 text-gray-500 text-sm">Ni nedavnih šop uvozov.</div>
              ) : (
                <div className="divide-y divide-gray-100 dark:divide-gray-800">
                  {nedavni.map((b:any)=>(
                    <div key={b.batch_id} className="flex items-center justify-between gap-3 py-2.5">
                      <div className="min-w-0 flex-1">
                        <div className="flex items-center gap-2">
                          <span className="text-sm font-medium text-gray-900 dark:text-white truncate">{b.file_name||b.batch_id}</span>
                          <span className={clsx('text-[10px] px-1.5 py-0.5 rounded-full flex-shrink-0', b.doc_type==='izdani_racun'?'bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300':'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300')}>{b.doc_type==='izdani_racun'?'izdani':'prejeti'}</span>
                        </div>
                        <div className="text-[11px] text-gray-500 mt-0.5">
                          {b.status==='razveljavljen'?<span className="text-red-500 font-medium">razveljavljen</span>:<span>{oznakaStatusa(b.status)}</span>}
                          {' · '}✓ {b.st_koncano||0} uvoženih
                          {/* [PATCH sop-kos-pdf v1] */(b.st_preskoceno||0)>0&&(<>{' · '}<button type="button" onClick={()=>odpriSopIzNedavnih(b.batch_id)} className="text-amber-600 hover:underline">↷ {b.st_preskoceno} preskočenih</button></>)}
                          {b.created_at?` · ${new Date(b.created_at).toLocaleString('sl-SI')}`:''}
                        </div>
                      </div>
                      {/* [PATCH prestevilci-sop-fe v1] */}
                      {/* [PATCH vod-uvoz-partner-fe v1] VOD svezenj je izjema: njegovi
                          dokumenti dobijo interno stevilko ze ob uvozu, ne sele ob potrditvi */}
                      {(b.doc_type!=='izdani_racun'||b.meta?.vir==='vod-uvoz') && (<button onClick={()=>odpriPrestevilcenje(b.batch_id)} disabled={b.status==='razveljavljen'||prestBusy} className="text-xs px-3 py-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 disabled:opacity-40 disabled:cursor-not-allowed text-white font-semibold flex-shrink-0">Preštevilči</button>)}
                      <button onClick={()=>{ setNedavniOpen(false); odpriRazveljavitev(b.batch_id); }} disabled={b.status==='razveljavljen'||razvBusy} className="text-xs px-3 py-1.5 rounded-lg bg-red-600 hover:bg-red-700 disabled:opacity-40 disabled:cursor-not-allowed text-white font-semibold flex-shrink-0">Razveljavi</button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {/* [PATCH prestevilci-sop-fe v1] modal internega preštevilčenja šopa */}
      {prestOpen && prestInfo && (
        <div className="fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center p-4" onClick={()=>setPrestOpen(false)}>
          <div className="bg-white dark:bg-gray-900 rounded-2xl w-full max-w-lg border border-gray-200 dark:border-gray-700 shadow-2xl max-h-[85vh] flex flex-col" onClick={e=>e.stopPropagation()}>
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-700">
              <h3 className="font-bold text-gray-900 dark:text-white">Preštevilčenje internih številk</h3>
              <button onClick={()=>setPrestOpen(false)} className="text-gray-400 hover:text-white">✕</button>
            </div>
            <div className="p-4 overflow-auto space-y-3">
              {(prestInfo.serije||[]).length===0 ? (
                <div className="text-center py-6 text-gray-500 text-sm">Šop nima dokumentov z interno številko.</div>
              ) : (
                <>
                  <p className="text-xs text-gray-500">Vpišite novo začetno številko za serije, ki jih želite preštevilčiti. Prazno polje = serija ostane nespremenjena. Vrstni red dokumentov se ohrani.</p>
                  {(prestInfo.serije||[]).map((s:any)=>(
                    <div key={s.serija} className="rounded-lg border border-gray-200 dark:border-gray-700 p-3 flex items-center justify-between gap-3">
                      <div className="min-w-0 flex-1">
                        <div className="text-sm font-medium text-gray-900 dark:text-white">Serija {s.serija||'—'}</div>
                        <div className="text-[11px] text-gray-500 mt-0.5">{s.st_dokumentov} dok. · trenutno {s.min}–{s.max}{(s.izvozeni||[]).length>0?` · ⚠ ${s.izvozeni.length} izvoženih`:''}</div>
                      </div>
                      <input type="number" min={1} placeholder="nova začetna" value={prestVnos[s.serija]??''} onChange={e=>{const v=e.target.value; setPrestVnos(cur=>({...cur,[s.serija]:v}));}} className="w-32 px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white flex-shrink-0"/>
                    </div>
                  ))}
                </>
              )}
              {(prestInfo.brez_interne||0)>0 && (<div className="text-[11px] text-amber-600 dark:text-amber-400">⚠ {prestInfo.brez_interne} dokumentov šopa nima interne številke — ti se ne preštevilčijo.</div>)}
              {prestNapake && (
                <div className="rounded-lg border border-red-300 dark:border-red-800 bg-red-50 dark:bg-red-900/20 p-3 space-y-2">
                  <div className="text-sm font-semibold text-red-700 dark:text-red-300">Preštevilčenje blokirano</div>
                  {(prestNapake.napake||[]).map((n:string,i:number)=>(<div key={i} className="text-xs text-red-600 dark:text-red-300">{n}</div>))}
                  {(prestNapake.zasedene||[]).map((z:any)=>(
                    <div key={z.serija} className="text-xs text-red-600 dark:text-red-300">
                      Serija {z.serija||'—'}: zasedene številke {z.stevilke.map((k:any)=>`${k.interno_st} (${k.doc_number||'brez št. dokumenta'})`).join(', ')}
                    </div>
                  ))}
                  {(prestNapake.izvozeni||[]).map((d:any)=>(
                    <div key={d.doc_id} className="flex items-center justify-between gap-2 text-xs text-red-600 dark:text-red-300">
                      <span>Izvožen: {d.interno_st}/{d.serija||''} — {d.doc_number||''}</span>
                      <button onClick={()=>prestOznaciNeprenoseno(d.doc_id)} className="px-2 py-1 rounded bg-red-100 text-red-700 hover:bg-red-200 dark:bg-red-900/40 dark:text-red-300 flex-shrink-0">Označi neprenešeno</button>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="px-5 py-4 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-2">
              <button onClick={()=>setPrestOpen(false)} className="text-xs px-3 py-1.5 rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300">Prekliči</button>
              <button onClick={izvediPrestevilcenje} disabled={prestBusy||(prestInfo.serije||[]).length===0} className="text-xs px-3 py-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 disabled:opacity-40 disabled:cursor-not-allowed text-white font-semibold">{prestBusy?'Preštevilčujem...':'Preštevilči'}</button>
            </div>
          </div>
        </div>
      )}
      {preklicModal&&(
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={()=>{ if(!preklicBusy){ setPreklicModal(false); setPreklicPrenos(null); } }}>
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-5 w-[480px] max-h-[80vh] overflow-auto" onClick={e=>e.stopPropagation()}>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-1">Preklic potrditve</h3>
            <p className="text-sm text-gray-500 mb-3">Dokument se vrne v pregled. Učenje iz te potrditve se razveljavi, če ni novejšega učenja istega dobavitelja.</p>
            <div className="rounded-lg border border-gray-200 dark:border-gray-700 p-3 mb-3 text-sm space-y-1">
              <div className="flex justify-between gap-3"><span className="text-gray-400">Interna št.</span><span className="font-medium text-gray-900 dark:text-white font-mono">{internaPrikaz(selected)}{/* [PATCH interne-predpone v1] */}</span></div>
              <div className="flex justify-between gap-3"><span className="text-gray-400 flex-shrink-0">Partner</span><span className="font-medium text-gray-900 dark:text-white text-right ml-3">{selected?.partner?.ime||selected?.partner?.name||selected?.ocr?.izdajatelj?.ime||'—'}</span></div>
              <div className="flex justify-between gap-3"><span className="text-gray-400">Znesek</span><span className="font-medium text-gray-900 dark:text-white font-mono">{fmt(selected?.ocr?.zneski?.skupaj_z_ddv||selected?.amount_total||0)} €</span></div>
            </div>
            {preklicPrenos&&(
              <div className="rounded-lg border border-amber-300 dark:border-amber-800 bg-amber-50 dark:bg-amber-950 p-3 mb-3 text-sm">
                <div className="font-semibold text-amber-800 dark:text-amber-300">Račun je že prenesen</div>
                <div className="text-xs font-mono text-amber-700 dark:text-amber-400 mt-0.5 mb-2">{[preklicPrenos.export_format,preklicPrenos.exported_at?String(preklicPrenos.exported_at).slice(0,16).replace('T',' '):null].filter(Boolean).join(' · ')||'—'}</div>
                <div className="text-amber-800 dark:text-amber-300">Ob preklicu se oznaka prenosa odstrani in račun bo ob naslednjem prenosu izvožen znova. Prejšnji zapis v računovodskem programu je treba počistiti ročno.</div>
              </div>
            )}
            <div className="flex justify-end gap-2 mt-4">
              <button onClick={()=>{ setPreklicModal(false); setPreklicPrenos(null); }} disabled={preklicBusy} className="text-sm px-3 py-1.5 rounded text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 disabled:opacity-40">Zapri</button>
              <button onClick={izvediPreklic} disabled={preklicBusy} className="text-sm px-3 py-1.5 rounded bg-red-600 text-white hover:bg-red-700 disabled:opacity-40">{preklicBusy?'Prekličem…':(preklicPrenos?'Odznači in prekliči':'Prekliči potrditev')}</button>
            </div>
          </div>
        </div>
      )}
      {brisanjeModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setBrisanjeModal(false)}>
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-5 w-[480px] max-h-[80vh] overflow-auto" onClick={e => e.stopPropagation()}>
            {brisanjeOdv.lahko_brisati ? (
              <>
                <h3 className="font-semibold text-gray-900 dark:text-white mb-1">Brisanje dokumenta</h3>
                <p className="text-sm text-gray-500 mb-3">Ali res želite izbrisati ta dokument? Dejanja ni mogoče razveljaviti.</p>
                <div className="rounded-lg border border-gray-200 dark:border-gray-700 p-3 mb-3 text-sm space-y-1">
                  <div className="flex justify-between gap-3"><span className="text-gray-400">Interna št.</span><span className="font-medium text-gray-900 dark:text-white font-mono">{internaPrikaz(brisanjeDoc)}{/* [PATCH interne-predpone v1] */}</span></div>
                  <div className="flex justify-between gap-3"><span className="text-gray-400 flex-shrink-0">Dobavitelj</span><span className="font-medium text-gray-900 dark:text-white text-right ml-3">{brisanjeDoc?.partner?.ime||brisanjeDoc?.ocr?.izdajatelj?.ime||brisanjeDoc?.file_name||'—'}</span></div>
                  <div className="flex justify-between gap-3"><span className="text-gray-400">Znesek</span><span className="font-medium text-gray-900 dark:text-white font-mono">{fmt(brisanjeDoc?.ocr?.zneski?.skupaj_z_ddv||0)} €</span></div>
                </div>
              </>
            ) : (
              <>
                <h3 className="font-semibold text-gray-900 dark:text-white mb-1">Brisanje ni mogoče</h3>
                {/* [PATCH brisanje-sporocila v1] neuspel klic /odvisnosti ni razlog o povezavah */}
                {(brisanjeOdv as any)?.napaka ? (
                  <p className="text-sm text-gray-500 mb-3">{(brisanjeOdv as any).napaka === 'ni_dokumenta'
                    ? 'Tega dokumenta ni več. Osvežite seznam.'
                    : 'Odvisnosti dokumenta ni bilo mogoče preveriti. Poskusite znova.'}</p>
                ) : jeStranka ? (
                  <p className="text-sm text-gray-500 mb-3">{brisanjeDoc?.status === 'approved'
                    ? 'Račun je že potrjen, zato ga ni več mogoče izbrisati. Lahko pa dodate opombo za računovodstvo.'
                    : ((brisanjeOdv as any)?.stranka_sme===false && (brisanjeOdv.povezave||[]).length===0 && (brisanjeOdv.placila||[]).length===0)
                      ? 'Dokument iz sistemskega uvoza (ročni vnos, VOD, izdaja) lahko izbriše samo računovodstvo. Lahko pa dodate opombo za računovodstvo.'  /* [PATCH likvidacija-fe v1] vir */
                      : 'Dokumenta ni mogoče izbrisati, ker je vezan na druge dokumente ali plačila. Obrnite se na svoje računovodstvo.'}</p>
                ) : (
                  <p className="text-sm text-gray-500 mb-3">Dokument {brisanjeDoc?.doc_number || ''} ima aktivne povezave ali plačila. Najprej jih odstranite, da ga lahko izbrišete.</p>
                )}{/* [PATCH stranka-brisanje-besedilo v1] */}
              </>
            )}
            {(brisanjeOdv.povezave||[]).length > 0 && (
              <div className="mb-3">
                <div className="text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">Povezave na dokumente</div>
                {brisanjeOdv.povezave.map((pv:any) => (
                  <div key={pv.link_id} className="flex items-center justify-between gap-2 p-2 rounded border border-gray-200 dark:border-gray-700 mb-1">
                    <span className="text-sm text-gray-700 dark:text-gray-300 flex-1">{pv.kind === 'avans' ? 'Avans' : pv.kind === 'credit_note' ? 'Dobropis' : 'Storno'} {pv.dokument_st || ''} — {fmt(Number(pv.znesek))} €</span>
                    <button onClick={() => odstraniPovezavoBris(pv.link_id)} className="text-xs px-2 py-1 rounded bg-red-100 text-red-700 hover:bg-red-200 dark:bg-red-900/40 dark:text-red-300">Odstrani</button>
                  </div>
                ))}
              </div>
            )}
            {(brisanjeOdv.placila||[]).length > 0 && (
              <div className="mb-3">
                <div className="text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">Plačila</div>
                {brisanjeOdv.placila.map((pl:any) => (
                  <div key={pl.placilo_id} className="flex items-center justify-between gap-2 p-2 rounded border border-gray-200 dark:border-gray-700 mb-1">
                    <span className="text-sm text-gray-700 dark:text-gray-300 flex-1">{fmt(Number(pl.znesek))} € {pl.datum ? '(' + pl.datum + ')' : ''}</span>
                    <button onClick={() => odstraniPlaciloBris(pl.placilo_id)} className="text-xs px-2 py-1 rounded bg-red-100 text-red-700 hover:bg-red-200 dark:bg-red-900/40 dark:text-red-300">Izbriši</button>
                  </div>
                ))}
              </div>
            )}
            <div className="flex justify-end gap-2 mt-4">
              <button onClick={() => setBrisanjeModal(false)} className="text-sm px-3 py-1.5 rounded text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">{brisanjeOdv.lahko_brisati ? 'Prekliči' : 'Zapri'}</button>
              {!(jeStranka && !brisanjeOdv.lahko_brisati) && (
                <button onClick={() => brisanjeDoc && dejanskoIzbrisi(brisanjeDoc)} disabled={!brisanjeOdv.lahko_brisati} className="text-sm px-3 py-1.5 rounded bg-red-600 text-white hover:bg-red-700 disabled:opacity-40">Izbriši dokument</button>
              )}{/* [PATCH stranka-brisanje-besedilo v1] za stranko skrit, ne le onemogočen */}
            </div>
          </div>
        </div>
      )}
      {racunModal&&(
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setRacunModal(false)}>
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-5 w-[480px] max-h-[80vh] overflow-auto" onClick={e => e.stopPropagation()}>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Poveži {selected?.doc_type === 'avans' ? 'avans' : 'dobropis'} na račun</h3>
            {odprtiRacuni.length === 0 ? (
              <p className="text-sm text-gray-500">Ta dobavitelj nima odprtih računov.</p>
            ) : (
              <div className="space-y-2">
                {odprtiRacuni.map((o: any) => (
                  <label key={o.id} className="flex items-center gap-2 p-2 rounded border border-gray-200 dark:border-gray-700 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700">
                    <input type="checkbox" checked={racunIzbrani.includes(o.id)} onChange={() => { toggleRacun(o.id); setRacunZnesek(Math.min(Number(o.odprto), Math.abs(Number(selected?.amount_total || 0))).toFixed(2).replace('.', ',')); }} />
                    <span className="text-sm text-gray-700 dark:text-gray-300 flex-1">Račun {o.doc_number || ''} {o.datum ? '(' + fmtDatum(o.datum) + ')' : ''}</span>
                    <span className="text-sm font-mono text-gray-900 dark:text-white">odprto {fmt(Number(o.odprto))} €</span>
                  </label>
                ))}
                {racunIzbrani.length === 1 && (
                  <div className="flex items-center justify-between gap-2 mt-2">
                    <span className="text-sm text-gray-600 dark:text-gray-300">Znesek pobota (€)</span>
                    <input value={racunZnesek} onChange={e => setRacunZnesek(e.target.value)} className="w-28 px-2 py-1 rounded border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white text-right text-sm font-mono" />
                  </div>
                )}
                <label className="flex items-center gap-2 mt-3 text-sm text-gray-700 dark:text-gray-300 cursor-pointer">
                  <input type="checkbox" checked={zmanjsajNalog} onChange={e => setZmanjsajNalog(e.target.checked)} />
                  Zmanjšam nalog za plačilo
                </label>
                <div className="flex justify-end gap-2 mt-4">
                  <button onClick={() => setRacunModal(false)} className="text-sm px-3 py-1.5 rounded text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">Prekliči</button>
                  <button onClick={potrdiVezavoNaRacun} disabled={racunIzbrani.length === 0} className="text-sm px-3 py-1.5 rounded bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-40">Poveži</button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {veziModal&&(
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setVeziModal(false)}>
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-5 w-[480px] max-h-[80vh] overflow-auto" onClick={e => e.stopPropagation()}>
            <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Veži dobropis / avans na račun</h3>
            {odprtiDobropisi.length === 0 ? (
              <p className="text-sm text-gray-500">Ta dobavitelj nima odprtih dobropisov ali avansov.</p>
            ) : (
              <div className="space-y-2">
                {odprtiDobropisi.map((o: any) => (
                  <label key={o.id} className="flex items-center gap-2 p-2 rounded border border-gray-200 dark:border-gray-700 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700">
                    <input type="checkbox" checked={veziIzbrani.includes(o.id)} onChange={() => { toggleVezi(o.id); setVeziZnesek(String(o.znesek).replace('.', ',')); }} />
                    <span className="text-sm text-gray-700 dark:text-gray-300 flex-1">{o.doc_type === 'credit_note' ? 'Dobropis' : 'Avans'} {o.doc_number || ''} {o.datum ? '(' + fmtDatum(o.datum) + ')' : ''}</span>
                    <span className="text-sm font-mono text-gray-900 dark:text-white">{fmt(Number(o.znesek))} €</span>
                  </label>
                ))}
                {veziIzbrani.length === 1 && (
                  <div className="flex items-center justify-between gap-2 mt-2">
                    <span className="text-sm text-gray-600 dark:text-gray-300">Znesek pobota (€)</span>
                    <input value={veziZnesek} onChange={e => setVeziZnesek(e.target.value)} className="w-28 px-2 py-1 rounded border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white text-right text-sm font-mono" />
                  </div>
                )}
                <label className="flex items-center gap-2 mt-3 text-sm text-gray-700 dark:text-gray-300 cursor-pointer">
                  <input type="checkbox" checked={zmanjsajNalog} onChange={e => setZmanjsajNalog(e.target.checked)} />
                  Zmanjšam nalog za plačilo
                </label>
                <div className="flex justify-end gap-2 mt-4">
                  <button onClick={() => setVeziModal(false)} className="text-sm px-3 py-1.5 rounded text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">Prekliči</button>
                  <button onClick={potrdiVezavo} disabled={veziIzbrani.length === 0} className="text-sm px-3 py-1.5 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-40">Poveži</button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {/* [PATCH ddv-obdobje-opomnik-fe v1] predlog premika davcne blokade */}
      {opomnikBlok && (
        <div className="fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center p-4">
          <div className="bg-white dark:bg-gray-900 rounded-2xl w-full max-w-lg border border-gray-200 dark:border-gray-700 p-6 space-y-4">
            <div>
              <h3 className="font-semibold text-gray-900 dark:text-white">Davčna blokada zaostaja</h3>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                Trenutno: {opomnikBlok.stara ? `${opomnikBlok.stara.slice(5,7)}.${opomnikBlok.stara.slice(0,4)}` : 'ni nastavljena'}
              </p>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Zakleni do vključno (MM.YYYY)</label>
              <input autoFocus value={opomnikVnos} onChange={e=>setOpomnikVnos(e.target.value)}
                onKeyDown={e=>{ if(e.key==='Enter') prestaviBlokado(); }}
                className="w-44 px-3 py-2 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white outline-none focus:border-blue-500 text-sm font-mono" />
            </div>
            {typeof opomnikBlok.skupaj === 'number' && (
              <div className="text-xs text-gray-600 dark:text-gray-300 bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-900 rounded-lg p-3 space-y-1">
                <div>
                  Nepotrjenih dokumentov v obdobjih do vključno {opomnikVnos}: <b>{opomnikBlok.skupaj}</b>
                  {opomnikBlok.novo!==opomnikBlok.skupaj ? ` (ta premik na novo zaklene: ${opomnikBlok.novo})` : ''}
                </div>
                <div>Ob odprtju jim bo datum za DDV prestavljen v prvo odprto obdobje.</div>
                {opomnikBlok.brez_datuma>0 && (
                  <div>Dodatno {opomnikBlok.brez_datuma} brez zabeleženega datuma — teh števec ne vidi.</div>
                )}
              </div>
            )}
            <div className="flex items-center justify-end gap-2 pt-2">
              <button onClick={()=>setOpomnikBlok(null)} className="text-sm px-4 py-2 rounded-lg text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">Prekliči</button>
              <button onClick={prestaviBlokado} disabled={opomnikBusy} className="text-sm px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-semibold disabled:opacity-50">{opomnikBusy?'Shranjujem...':'Prestavi blokado'}</button>
            </div>
          </div>
        </div>
      )}
      {/* [PATCH partner-uredi-z-racuna v1] maska za urejanje obstojecega partnerja */}
      {urediPartnerja&&(
        <PartnerFursModal companyId={companyId} initial={urediPartnerja}
          onClose={()=>setUrediPartnerja(null)}
          onSaved={partnerShranjen}/>
      )}
      {showPartnerModal&&(
        <div className="fixed inset-0 bg-black/70 z-[9999] flex items-center justify-center p-4">
          <div className="bg-gray-900 rounded-2xl w-full max-w-2xl border border-gray-700 max-h-[85vh] flex flex-col">{/* [PATCH_ROCNI_UVOZ_PARTNER_V1] sirse za FURS masko */}
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-700">
              <h3 className="font-bold text-white">{jeIzdaniTip(selected?.doc_type)?'Izberi kupca':'Izberi dobavitelja'}</h3>{/* [PATCH izdani-partner-isci-fe v1] */}
              <button onClick={()=>{setShowPartnerModal(false);setPartnerModalNacin('obstojeci');}} className="text-gray-400 hover:text-white">✕</button>
            </div>
            <PartnerSelector companyId={companyId} zacetniNacin={partnerModalNacin} predlog={selected?.ocr?.partner_predlog} izvozProgram={izvozProgram} onSelect={(p)=>{
              uporabiPartnerja(p); // [PATCH rocni-vnos-fe v3]
              setShowPartnerModal(false);
              setPartnerModalNacin('obstojeci');
            }}/>
          </div>
        </div>
      )}

      {pogledIzdani!=='prenos'&&(<div className="overflow-auto" style={{height: contentH || undefined}}><IzdajaPage vgrajen skupina={pogledIzdani as any} /></div>)}{/* [PATCH izdaja-dokumenti v1] rocni vnos izdanih namesto mreze */}
      <div className={clsx('flex gap-0 min-w-0 h-[calc(100vh-155px)]',pogledIzdani!=='prenos'&&'hidden')} style={{height: contentH || undefined}} ref={containerRef}>
        <div ref={listPanelRef} className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 overflow-hidden flex-shrink-0 flex flex-col" style={{width: panelWidths.list}}>
          <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-800 flex justify-between items-center">
            <h3 className="font-semibold text-sm flex items-center gap-2">
              <Receipt className="w-4 h-4 text-blue-500"/>
              {TIPI_DOKUMENTOV.find(t=>t.id===aktivniTip)?.label}
            </h3>
            {/* [PATCH seznam-limit-fe v1] stevec + gumb za naslednjih 100 */}
            <span className="flex items-center gap-2">
              <span className="text-xs text-gray-400">{dokumenti.filter((d:any)=>_isceSe()||serijaDok(d)===izbranoLeto).length}</span>
              {dokumenti.length>=limitSez&&(
                <button
                  onClick={async()=>{ limitSezRef.current=limitSezRef.current+LIMIT_KORAK_SEZ; setLimitSez(limitSezRef.current); await naloziDokumente(companyId, aktivniTip, iskanje); }}
                  title={`Prikazanih ${dokumenti.length} — naloži naslednjih ${LIMIT_KORAK_SEZ}`}
                  className="text-[10px] font-mono px-1.5 py-0.5 rounded-md border border-gray-300 dark:border-gray-600 text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800 transition">
                  +{LIMIT_KORAK_SEZ}
                </button>
              )}
            </span>
          </div>
          {(()=>{
            const tekoce=String(new Date().getFullYear());
            const letaNaVoljo=dokumenti.map((d:any)=>serijaDok(d)||null).filter(Boolean).filter((v:any,i:number,a:any[])=>a.indexOf(v)===i).sort().reverse();
            if(letaNaVoljo.length===0) return null;
            const baza=[tekoce, ...letaNaVoljo];  /* [PATCH leta-cipi v1] vsa leta kot čipi (prej tekoče+prejšnje+izbrano, ostala v ▾) */
            const vidnaLeta=baza.filter((v:string,i:number,a:string[])=>a.indexOf(v)===i).sort().reverse();
            const ostalaLeta=letaNaVoljo.filter((l:string)=>!vidnaLeta.includes(l));
            return (
              <div className="px-3 py-1.5 border-b border-gray-200 dark:border-gray-800 flex items-center gap-1.5">
                {vidnaLeta.map((leto:string)=>(
                  <button key={leto} onClick={()=>setIzbranoLeto(leto)}
                    className={clsx('text-xs font-mono px-2 py-0.5 rounded-md transition border', izbranoLeto===leto?'bg-blue-500 text-white font-bold border-blue-500':'bg-white text-gray-600 border-gray-200 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-300 dark:border-gray-700 dark:hover:bg-gray-800')}>{leto}</button>
                ))}
                {ostalaLeta.length>0&&(
                  <div className="relative">
                    <button onClick={()=>setShowLeta((v:boolean)=>!v)} title="Ostala leta" className="text-xs px-1.5 py-0.5 rounded-md text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800">▾</button>
                    {showLeta&&(
                      <div className="absolute z-20 mt-1 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg py-1 min-w-[70px]">
                        {ostalaLeta.map((leto:string)=>(
                          <button key={leto} onClick={()=>{setIzbranoLeto(leto);setShowLeta(false);}}
                            className={clsx('block w-full text-left text-xs font-mono px-3 py-1 hover:bg-gray-100 dark:hover:bg-gray-700', izbranoLeto===leto?'text-blue-500 font-bold':'text-gray-600 dark:text-gray-300')}>{leto}</button>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })()}
          {/* [PATCH seznam-stanje-filter-fe v1] filter stanja: Vsi / Neprenešeni / Nepotrjeni */}
          <div className="px-3 py-1.5 border-b border-gray-200 dark:border-gray-800 flex items-center gap-1.5">
            {([{id:'vsi',label:'Vsi'},{id:'neprenesen',label:'Neprenešeni'},{id:'nepotrjen',label:'Nepotrjeni'},
               ...((likvStanje.modul&&!jeIzdaniTip(aktivniTip))?[{id:'nelikvidiran',label:'Nelikvidirani'}]:[])] as {id:StanjeFilter;label:string}[]).map(o=>(  /* [PATCH likvidacija-fe v1] filter Nelikvidirani samo pri prejetih */
              <button key={o.id}
                onClick={()=>{ if(stanjeRef.current===o.id) return; stanjeRef.current=o.id; _stanjeSticky=o.id; setStanjeFilter(o.id); naloziDokumente(companyId, aktivniTip, iskanje); }}
                className={clsx('text-xs px-2 py-0.5 rounded-md transition', stanjeFilter===o.id?'bg-blue-500 text-white font-bold':'text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800')}>{o.label}</button>
            ))}
            {/* [PATCH likv-kljukice-stran v1] gumb 'Likvidiraj izbrane' odstranjen */}
          </div>
          <div className="px-3 py-2 border-b border-gray-200 dark:border-gray-800">
            <div className="relative">
              <Search className="w-3.5 h-3.5 text-gray-400 absolute left-2.5 top-1/2 -translate-y-1/2"/>
              <input value={iskanje} onChange={e=>setIskanje(e.target.value)}
                placeholder="Išči po partnerju, znesku, postavkah, kontih..."
                className="w-full pl-8 pr-7 py-1.5 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-400 outline-none focus:border-blue-400"/>
              {iskanje&&(
                <button onClick={()=>setIskanje('')} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                  <X className="w-3.5 h-3.5"/>
                </button>
              )}
            </div>
          </div>
          {dokumenti.filter((d:any)=>_isceSe()||serijaDok(d)===izbranoLeto).length===0?(
            <div className="flex flex-col items-center justify-center h-48 text-gray-400 gap-3">
              <FileText className="w-10 h-10 opacity-20"/>
              <p className="text-sm">{nalagam?'Nalagam dokumente…':'Ni dokumentov'}</p>
              <button onClick={()=>setShowUpload(true)} className="flex items-center gap-1 text-xs text-blue-400 hover:text-blue-300">
                <Plus className="w-3 h-3"/> Naloži
              </button>
            </div>
          ):(
            <div className="divide-y divide-gray-100 dark:divide-gray-800 overflow-y-auto flex-1">
              {dokumenti.filter((d:any)=>_isceSe()||serijaDok(d)===izbranoLeto).sort((a:any,b:any)=>{/* [PATCH izdani-nepotrjeni-vrh v1] nepotrjeni IZDANI racuni gredo na vrh; znotraj skupine ostane primerjava nespremenjena, zato so potrjeni razvrsceni tako kot do sedaj. Prejeti se ne dotaknejo (oba kljuca 1). */const _npIzd=(d:any)=>(jeIzdaniTip(d?.doc_type)&&d?.status!=='approved')?0:1;const _na=_npIzd(a),_nb=_npIzd(b);if(_na!==_nb)return _na-_nb;const ai=(a.interno_st===null||a.interno_st===undefined)?null:Number(a.interno_st);const bi=(b.interno_st===null||b.interno_st===undefined)?null:Number(b.interno_st);if(ai===null&&bi===null){/* [PATCH uvoz-zaporedje v1] prejeti iz sopa: najnovejsi sop zgoraj, znotraj sopa po straneh PDF */if(!jeIzdaniTip(a?.doc_type)&&!jeIzdaniTip(b?.doc_type)){const _ua=uvozZap[String(a.id)],_ub=uvozZap[String(b.id)];if(_ua||_ub){const _ka=_ua?String(_ua.ob||''):String(a.created_at||''),_kb=_ub?String(_ub.ob||''):String(b.created_at||'');if(_ka!==_kb)return _kb.localeCompare(_ka);if(_ua&&_ub&&_ua.zap!==_ub.zap)return _ua.zap-_ub.zap;}}const an=_stIzdanega(a),bn=_stIzdanega(b);if(an!==null&&bn!==null&&an!==bn)return bn-an;return String(b.created_at||'').localeCompare(String(a.created_at||''));}if(ai===null)return -1;if(bi===null)return 1;return bi-ai;}).map((doc:any,i:number)=>{
                const s=statusConfig[doc.status]||statusConfig.uploaded;
                return(
                  <div key={i} role="button" tabIndex={0} onClick={async()=>{ if(await varnoZapustiDokument()) izberiDokument(doc); }}
                    className={clsx('w-full text-left px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-800 transition border-l-2',selected?.id===doc.id?'bg-blue-50 dark:bg-blue-950 border-blue-500':'border-transparent')}>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        {/* [PATCH likv-kljukice-stran v1] kljukica za mnozicno likvidacijo odstranjena */}
                        {doc.doc_type && doc.doc_type !== 'prejeti_racun' && doc.doc_type !== 'izdani_racun' && (
                          <span className={clsx(/* [PATCH izdani-doctype-fe v2] barva in oznaka
                              iz skupnega vira; pokrije tudi izdani_avans in izdani_dobropis */
                            'text-[10px] px-1.5 py-0.5 rounded-full font-semibold', barvaTipa(doc.doc_type))}>
                            {oznakaKratka(doc.doc_type)}
                          </span>
                        )}
                        <span className="text-base font-bold text-blue-500 font-mono">{internaPrikaz(doc)}{/* [PATCH interne-predpone v1] */}</span>{jeIzdaniTip(doc.doc_type)&&(<span className="text-xs text-gray-400 font-mono" title="Številka računa">{doc.doc_number||doc.ocr?.stevilka||''}</span>)}{/* [PATCH ir3a-fix5 v1] */}{/* [PATCH opal-st-fe v1] */}<MailVhodOznaka companyId={companyId} docId={doc.id}/>{/* [PATCH mail-vhod-D3 v1] */}
                        <span className="text-base font-bold text-gray-900 dark:text-white font-mono">{/* [PATCH seznam-znesek v1] leva = desna: kontiranje.ocr_zneski -> ocr.zneski -> amount_total */}{fmt(Number(doc.kontiranje?.ocr_zneski?.skupaj_z_ddv)||Number(doc.ocr?.zneski?.skupaj_z_ddv)||Number(doc.amount_total)||0)}</span>
                        <span className="text-xs text-gray-400">EUR</span>
                      </div>
                      <div className="flex items-center gap-1">
                        {/* [PATCH ai-preverbe-fe v1] znacka preverbe */}{aiZnacke[String(doc.id)]&&(<span title={aiZnacke[String(doc.id)]==='rdeca'?'Preverba: napake':aiZnacke[String(doc.id)]==='rumena'?'Preverba: opozorila':'Preverba: v redu'} className={clsx('inline-block w-2.5 h-2.5 rounded-full mr-1', aiZnacke[String(doc.id)]==='rdeca'?'bg-red-500':aiZnacke[String(doc.id)]==='rumena'?'bg-amber-400':'bg-green-500')}/>)}{(()=>{/* [PATCH placano-znesek v1] znacka iz dejanskih placil+vezav */
                          const _tot=Number(doc.amount_total||0);const _pl=Number(doc.placano_znesek||0);
                          const _full=doc.status==='placano'||(_tot>0.01&&_pl>=_tot-0.01);
                          const _del=!_full&&_tot>0.01&&_pl>0.01;
                          if(_full)return <span title={_pl>0?`Plačano: ${fmt(_pl)} EUR`:'Plačano'} className="text-xs px-1.5 py-0.5 rounded-full bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300 font-medium">Plačano</span>;
                          if(_del)return <span title={`Plačano ${fmt(_pl)} od ${fmt(_tot)} EUR`} className="text-xs px-1.5 py-0.5 rounded-full bg-amber-100 text-amber-700 dark:bg-amber-900 dark:text-amber-300 font-medium">Delno {fmt(_pl)}</span>;
                          return null;})()}
                        {/* [PATCH likvidacija-fe v1] oznaka stanja: nelikvidiran / likvidiran / potrjen (prejeti, modul vklopljen) */}
                        {likvPredmet(doc)&&(doc.status==='approved'
                          ?<span className="text-[10px] px-1.5 py-0.5 rounded-full bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300 font-semibold whitespace-nowrap" title="Potrjeno s strani računovodstva">Potrjen</span>
                          :likvidiranDok(doc)
                            ?<span className="text-[10px] px-1.5 py-0.5 rounded-full bg-emerald-100 text-emerald-700 dark:bg-emerald-900 dark:text-emerald-300 font-semibold whitespace-nowrap" title={`Likvidiral: ${doc.likvidiral||'—'}`}>Likvidiran</span>
                            :<span className="text-[10px] px-1.5 py-0.5 rounded-full bg-orange-100 text-orange-700 dark:bg-orange-900 dark:text-orange-300 font-semibold whitespace-nowrap" title="Stranka računa še ni likvidirala">Nelikvidiran</span>)}
                        <StatusIkona doc={doc}/>
                        {strankaSmeUrejati(doc)&&(  /* [PATCH likvidacija-fe v1] kos samo, ko stranka sme brisati */
                        <button onClick={(e)=>izbrisiDokument(e,doc)} className="p-1 hover:text-red-500 text-gray-400 transition">
                          <Trash2 className="w-3 h-3"/>
                        </button>
                        )}
                      </div>
                    </div>
                    <div className="flex items-center justify-between mt-0.5">
                      <span className="text-sm text-gray-700 dark:text-gray-300 font-medium truncate max-w-[160px]">
                        {/* [PATCH opombe-pogoj v1] */}{opombeStatus[doc.id] && !jeIzdaniTip(doc.doc_type) && (jeStranka||opombeNaVoljo) && <span className={'inline-block w-2 h-2 rounded-full mr-1.5 align-middle '+(opombeStatus[doc.id]==='odgovorjena'?'bg-blue-500':'bg-amber-500')} title={opombeStatus[doc.id]==='odgovorjena'?'Stranka je odgovorila na opombo':(jeStranka?'Računovodstvo prosi za ureditev':'Opomba za stranko — čaka stranko')}></span>}{/* [PATCH opombe-stranka-fe v1] */}{doc.opomba && <span className="inline-block w-2 h-2 rounded-full bg-red-500 mr-1.5 align-middle" title="Opomba stranke"></span>}{/* [PATCH seznam-kupec-sifrant v1] izdani: ime KUPCA z racuna namesto imena datoteke */}{doc.partner?.ime||(jeIzdaniTip(doc.doc_type)?doc.ocr?.kupec_naziv:null)||doc.ocr?.izdajatelj?.ime||doc.file_name||'Dokument'}
                      </span>
                      {!jeIzdaniTip(doc.doc_type)&&<span className="text-xs text-gray-400 font-mono">{doc.doc_number||doc.ocr?.stevilka||'—'}</span>}{/* [PATCH ir3a-fix5 v1] */}{jeIzdaniTip(doc.doc_type)&&!doc.partner_najden&&(<span className="text-[10px] px-1.5 py-0.5 rounded bg-red-100 text-red-600 dark:bg-red-950 dark:text-red-300 font-semibold whitespace-nowrap flex-shrink-0" title="Kupca ni v šifrantu">NI V ŠIFRANTU</span>)}{/* [PATCH seznam-kupec-sifrant v1] */}
                    </div>
                    <div className="flex gap-3 mt-0.5 text-xs text-gray-400">
                      {doc.ocr?.datum&&<span>{fmtDatum(doc.ocr.datum)}</span>}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Drag handle - seznam */}
        <div onMouseDown={onMouseDown('list')}
          className="w-1.5 mx-1 cursor-col-resize hover:bg-blue-400 active:bg-blue-500 rounded-full transition-colors flex-shrink-0 self-stretch bg-gray-200 dark:bg-gray-700"/>
        <div className="flex gap-0 min-w-0 flex-1">
          <div className="flex-1 min-w-0 flex flex-col bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 overflow-hidden">
            {!selected?(
              <div className="flex flex-col items-center justify-center h-full py-20 text-gray-400 gap-3">
                <Eye className="w-12 h-12 opacity-20"/>
                <p className="text-sm">Izberite dokument za pregled</p>
              </div>
            ):(
              <div className="overflow-y-auto flex-1 min-h-0">
                <div className="px-5 py-4 border-b border-gray-200 dark:border-gray-800">
                  {/* Vrstica 1: Številka računa */}
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-3">
                      {jeStranka?null:jeRocni?(<span className="text-base font-bold text-emerald-500 font-mono">NOVO</span>):(<InternoStBadge doc={selected} companyId={companyId} onSaved={(n:number,ser?:string)=>{ setSelected((s:any)=>({...s,interno_st:n,interno_st_serija:ser??s?.interno_st_serija})); setDokumenti(prev=>prev.map(d=>d.id===selected.id?{...d,interno_st:n,interno_st_serija:ser??d.interno_st_serija}:d)); }}/>)}{!jeStranka&&!jeRocni&&selected?.doc_type==='izdani_racun'&&(<GotovinskiBadge doc={selected} companyId={companyId} onSaved={(g:boolean)=>{ setSelected((s:any)=>({...s,gotovinski:g})); setDokumenti(prev=>prev.map(d=>d.id===selected.id?{...d,gotovinski:g}:d)); }}/>)}{/* [PATCH gotovinski-predpona v2] */}{!jeRocni&&(<MailVhodOznaka companyId={companyId} docId={selected?.id} velika/>)}{/* [PATCH mail-vhod-D3 v1] */}
                      {!jeRocni&&(<TipDokumentaBadge samoBranje={jeStranka} doc={selected} companyId={companyId} onSaved={(t:string)=>{ setSelected((s:any)=>({...s,doc_type:t})); setDokumenti(prev=>prev.map(d=>d.id===selected.id?{...d,doc_type:t}:d)); }}/>)}{/* [PATCH dokument-tip v1] */}
                      {urejanje?(<>
                        <input id="vt-stevilka" tabIndex={1} value={stevilkaEdit} onChange={e=>setStevilkaEdit(e.target.value)} placeholder="Številka računa"
                          className="font-bold text-lg font-mono w-56 px-2 py-0.5 rounded border border-blue-400 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
                          title="Popravljena številka se v dokument zapiše ob potrditvi (pred učenjem predloge)"/>
                        {/* [PATCH rocni-vnos-fe v3] inline partner (tab 2) + ＋ nov */}
                        <PartnerIsci id="vt-partner" tabIndex={2} companyId={companyId}
                          vrednost={selected.partner?.ime||selected.partner?.name||kontiranje?.partner_ime||''}
                          onIzberi={uporabiPartnerja}
                          onNov={()=>{setPartnerModalNacin('nov');setShowPartnerModal(true);}}/>
                        {/* [PATCH_OPISI_KONTO_PLUS_V1] gumb + ob partnerju odstranjen — iskalnik pokriva iskanje in novega (FURS maska) */}
                      </>):(<>
                        <h3 className="font-bold text-gray-900 dark:text-white text-lg font-mono">{stevilkaEdit||stDok(selected)||'Račun'}</h3>{/* [PATCH opal-st-fe v1] Opalova primarno */}{/* [PATCH vseeno-dvojnik v1] */(/DVOJNIK/.test(stDok(selected)))&&(<span className="ml-2 px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 text-xs font-semibold align-middle" title="Račun s to številko je za tega dobavitelja že v bazi">DVOJNIK</span>)}
                      </>)}
                      {stevilkaEdit&&!editMode&&stevilkaEdit!==stDok(selected)&&(
                        <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-amber-100 text-amber-700 dark:bg-amber-900 dark:text-amber-300">popravek ob potrditvi</span>
                      )}
                    </div>
                    <div className="flex items-center gap-2">
                      {selected.ocr?.datum&&<span className="text-xs text-gray-500">Datum: <b>{fmtDatum(selected.ocr?.datum)}</b></span>}
                      {selected.partner_najden?(
                        <span className="flex items-center gap-1 text-xs text-green-600 bg-green-50 dark:bg-green-950 px-2 py-1 rounded-full">
                          <CheckCircle className="w-3 h-3"/> V šifrantu
                        </span>
                      ):(
                        <span className="flex items-center gap-1 text-xs text-red-600 bg-red-50 dark:bg-red-950 px-2 py-1 rounded-full">
                          ⚠ Ni v šifrantu
                        </span>
                      )}
                      {selected.file_path && pdfOdprto && (
                        <button onClick={()=>setPdfOdprtoShranjeno(false)} className="text-xs text-blue-400 hover:text-blue-300 mr-2">← PDF nazaj</button>
                      )}
                      {jeRocni&&(<span className="inline-flex items-center mr-2">{/* [PATCH rocni-vnos-fe v1] priponka */}
                        <input ref={rocniFileRef} type="file" accept="application/pdf,image/*" className="hidden" onChange={e=>setRocniFile(e.target.files?.[0]||null)}/>
                        <button tabIndex={-1} onClick={()=>rocniFileRef.current?.click()} className="text-xs px-2 py-0.5 rounded border border-blue-400 text-blue-500 hover:bg-blue-50 dark:hover:bg-blue-950">
                          {rocniFile?('\ud83d\udcce '+rocniFile.name):'Naloži račun (priponka)'}
                        </button>
                      </span>)}
                      {/* [PATCH rocni-razrez-fe v1a] */}
                      {/* [PATCH razdeli-izdani-fe v1] guard !jeIzdaniTip odstranjen — razrez odslej dela tudi na izdanih; backend delegira po doc_type v rocni_razrez_service. Gumb Zdruzi ostane NAMENOMA skrit za izdane. */}
                      {!jeRocni&&selected?.status!=='approved'&&selected?.file_path&&strankaSmeUrejati(selected)&&!zaklenjenIzdaja/* [PATCH prodajni-tok v3] */&&(<button tabIndex={-1} onClick={odpriRazrez} title="Razdeli PDF na več računov" className="text-xs px-2 py-0.5 rounded text-blue-400 hover:text-blue-300 mr-2">
                        &#9986; Razdeli
                      </button>)}
                      {/* [PATCH zdruzi-fe v3] */}
                      {!jeRocni&&selected?.status!=='approved'&&!jeIzdaniTip(selected?.doc_type)&&selected?.file_path&&strankaSmeUrejati(selected)&&!zaklenjenIzdaja/* [PATCH prodajni-tok v3] */&&(<button tabIndex={-1} onClick={odpriZdruzi} title="Ta dokument je del drugega — združi ju v enega" className="text-xs px-2 py-0.5 rounded text-blue-400 hover:text-blue-300 mr-2">
                        &#8853; Združi
                      </button>)}
                      {/* [PATCH stranka-brez-urejanja v1] RAZVELJAVLJENO z [PATCH likvidacija-fe v1]: stranka ureja glavo, dokler racun ni likvidiran/potrjen */}
                      {/* [PATCH likvidacija-fe v2] samo "Uredi"; zgornji "Koncaj" odstranjen -> Shrani / Preklici na dnu detajla */}
                      {!jeRocni&&!editMode&&selected?.status!=='approved'&&strankaSmeUrejati(selected)&&(<button tabIndex={-1} onClick={vstopiUrejanje} className="text-xs px-2 py-0.5 rounded text-blue-400 hover:text-blue-300 mr-2">
                        ✎ Uredi
                      </button>)}
                      {/* [PATCH likvidacija-fe v2] zgornji gumb Likvidiraj / Preklici likvidacijo odstranjen -> velik gumb na dnu detajla */}
                                            {/* [PATCH rocni-vnos-fe v3] gumb odstranjen — partner se isce inline ob stevilki */}
                    </div>
                  </div>
                  {/* Opozorilo: insolventnost dobavitelja */}
                  <div className="mb-2">
                    <InsolventnostOpozorilo partnerId={_pidPov()} davcna={kontiranje?.partner_davcna || selected?.ocr?.izdajatelj?.davcna} />
                    {/* [PATCH likvidacija-fe v1] pasice stanja: stranka (zaklep) in racunovodja (kdo je likvidiral / manjka) */}
                    {!jeRocni&&jeStranka&&selected?.status==='approved'&&(
                      <div className="flex items-center gap-2 bg-green-50 dark:bg-green-950 border border-green-300 dark:border-green-800 text-green-800 dark:text-green-300 rounded-xl px-3 py-2 text-xs mt-2">
                        <CheckCircle className="w-4 h-4 flex-shrink-0"/><span><b>Potrjeno s strani računovodstva.</b> Račun je zaklenjen; opombo za računovodstvo lahko še vedno dopolnite.</span>
                      </div>
                    )}
                    {!jeRocni&&jeStranka&&selected?.status!=='approved'&&likvPredmet(selected)&&likvidiranDok(selected)&&(
                      <div className="flex items-center gap-2 bg-emerald-50 dark:bg-emerald-950 border border-emerald-300 dark:border-emerald-800 text-emerald-800 dark:text-emerald-300 rounded-xl px-3 py-2 text-xs mt-2">
                        <CheckCircle className="w-4 h-4 flex-shrink-0"/><span><b>Likvidirano</b>{selected.likvidiral?` (${selected.likvidiral})`:''} — za urejanje prekliči likvidacijo.</span>
                      </div>
                    )}
                    {!jeRocni&&!jeStranka&&selected?.status!=='approved'&&likvPredmet(selected)&&(likvidiranDok(selected)
                      ?<div className="text-[11px] text-emerald-700 dark:text-emerald-400 mt-1">✓ Likvidiral{selected.likvidiral?` ${selected.likvidiral}`:''}{selected.likvidiran_at?` · ${fmtDatum(String(selected.likvidiran_at).slice(0,10))}`:''}</div>
                      :<div className="flex items-center gap-2 bg-orange-50 dark:bg-orange-950 border border-orange-300 dark:border-orange-800 text-orange-800 dark:text-orange-300 rounded-xl px-3 py-2 text-xs mt-2"><AlertTriangle className="w-4 h-4 flex-shrink-0"/><span><b>Stranka računa še ni likvidirala.</b> Potrditev in plačilo sta do likvidacije zaprta.</span></div>)}
                    {/* [PATCH tuja-firma-opozorilo v1] racun ni naslovljen na to bazo; ugasne ga potrditev */}
                    {kontiranje?.tuja_firma?.aktivno&&(
                      <div className="flex items-start gap-2 bg-orange-50 dark:bg-orange-950 border border-orange-300 dark:border-orange-800 text-orange-800 dark:text-orange-300 rounded-xl px-3 py-2 text-xs mt-2">
                        <AlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5"/>
                        <span><b>Preverite bazo.</b> {kontiranje.tuja_firma.sporocilo} Opozorilo izgine, ko račun potrdite.</span>
                      </div>
                    )}
                  </div>
                  {/* [PATCH vod-uvoz-partner-fe v1] Kadar uvoz kupca ni mogel
                      enolicno dolociti (vec zapisov z istim nazivom, zamenjan vrstni
                      red imena, neujemanje naslova), so kandidati shranjeni na
                      dokumentu. Klik izbere -- brez rocnega iskanja po sifrantu. */}
                  {pasKandidati.length>0&&selected?.status!=='approved'&&(  /* [PATCH soimenjaki v1] prej samo ocr.partner_kandidati */
                    <div className="mb-2 rounded-xl border border-amber-300 dark:border-amber-800 bg-amber-50 dark:bg-amber-900/20 px-3 py-2">
                      <div className="text-[11px] font-semibold text-amber-800 dark:text-amber-400 mb-1.5">
                        Predlog kupca — klikni za izbiro
                        {selected?.ocr?.partner_nacin?<span className="font-normal"> ({selected.ocr.partner_nacin})</span>:null}
                      </div>
                      <div className="flex flex-wrap gap-1.5">
                        {pasKandidati.map((k:any,i:number)=>(  /* [PATCH soimenjaki v1] */
                          <button key={i} type="button"
                            onClick={async ()=>{
                              /* [PATCH predlog-kupca-shrani v1] Klik SHRANI takoj.
                                 Doslej je uporabiPartnerja() nastavil samo lokalno React
                                 stanje; dokler uporabnik ni pritisnil "Shrani" (prej "Koncaj") ali "Potrdi",
                                 se izbira NI shranila -- na zaslonu je bil izbran kupec,
                                 dokument pa ga ni imel (tiha izguba, Janez 27.08.2026).
                                 partner_id gre v payload EKSPLICITNO: setKontiranje() v
                                 istem tiku se ni vidno (React state se posodobi sele ob
                                 naslednjem renderju), zato bi shraniPopravke() poslal
                                 STAREGA partnerja.
                                 Kandidatov NE brisemo -> rumeni pas ostane viden in
                                 zamenjava je se naprej mozna. */
                              uporabiPartnerja({id:k.id,name:k.ime,ime:k.ime,tax_number:k.davcna,vat_number:k.vat,vasco_code:k.sifra});
                              try{
                                await api.post(`/dokumenti/${companyId}/${selected.id}/shrani`,
                                  {...kontiranje, partner_id:k.id, partner_ime:k.ime, partner_davcna:k.davcna,
                                   datumi, sklic:sestaviSklic(), trr:(trrEdit||'').trim(), opis:(opisVnos||'').trim()});
                                toast.success('Kupec izbran in shranjen: '+(k.ime||''));
                                naloziDokumente(companyId, aktivniTip, iskanje);
                              }catch(e:any){
                                toast.error(e?.response?.data?.detail||'Kupec NI bil shranjen — poskusi znova');
                              }
                            }}
                            className="px-2.5 py-1.5 rounded-lg border border-amber-400 dark:border-amber-700 bg-white dark:bg-gray-900 text-xs text-left hover:border-blue-500 hover:text-blue-600 dark:hover:text-blue-400 transition">
                            <span className="font-medium text-gray-900 dark:text-white">{k.ime}</span>
                            {k.sifra?<span className="text-gray-400"> · šifra {k.sifra}</span>:null}
                            {k.davcna?<span className="text-gray-400"> · {k.davcna}</span>:null}
                            {k.naslov?<span className="text-gray-400"> · {k.naslov}</span>:null}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                  {/* Vrstica 2: Šifra | Naziv | Davčna */}
                  <div className="flex items-center gap-3 mb-1">
                    {!jeStranka&&(
                    <VascoSifraBadge key={selected.partner?.id||'brez'} /* [PATCH sifra-znacka-key v2] nova instanca ob menjavi partnerja */ companyId={companyId} partner={selected.partner} izvozProgram={izvozProgram}
                      onSaved={(code:string)=>setSelected((s:any)=>s?{...s,partner:{...(s.partner||{}),vasco_code:code},partner_najden:true}:s)} />
                    )}{/* [PATCH stranka-skrij-sifro-interno v1] sifra partnerja je sifrantski podatek */}
                    {/* [PATCH izdani-partner-isci-fe v1] izdani: klik na naziv = urejanje s fokusom na iskalniku partnerja (avto-kupec je lahko napacen) */}
                    {/* [PATCH stranka-brez-urejanja v1] klik na kupca odpre urejanje — ne za stranko */}
                    {!jeStranka&&jeIzdaniTip(selected.doc_type)&&!urejanje&&selected?.status!=='approved'?(
                      <button type="button" title="Klikni za izbiro / zamenjavo kupca"
                        onClick={()=>{ vstopiUrejanje(); /* [PATCH likvidacija-fe v2] posnetek za Preklici */ setTimeout(()=>document.getElementById('vt-partner')?.focus(),120); }}
                        className="font-bold text-gray-900 dark:text-white text-sm border-b border-dotted border-gray-400 hover:text-blue-500 dark:hover:text-blue-400 text-left">
                        {selected.partner?.ime||selected.partner?.name||kontiranje?.partner_ime||selected.ocr?.kupec_naziv||'—'}
                      </button>
                    ):(
                    <span className="font-bold text-gray-900 dark:text-white text-sm">
                      {selected.partner?.ime||selected.partner?.name||kontiranje?.partner_ime||(jeIzdaniTip(selected.doc_type)?selected.ocr?.kupec_naziv:selected.ocr?.izdajatelj?.ime)||'—'}
                    </span>
                    )}
                    {/* [PATCH partner-uredi-premik v2] svincnik tik ob nazivu partnerja, pred davcno.
                        Vidno tudi na potrjenih dokumentih in pri izdanih — ureja se
                        SIFRANT, ne dokument. */}
                    {/* [PATCH stranka-brez-urejanja v1] svincnik ureja sifrant partnerjev — RAZVELJAVLJENO z [PATCH stranka-partnerji v1]:
                        stranka dodaja in ureja partnerje enako kot racunovodja (Janez 08.09.2026); BE bel seznam core/deps.py */}
                    {selected.partner?.id&&(
                      <button type="button" tabIndex={-1} disabled={nalagamPartnerja}
                        onClick={odpriUrediPartnerja}
                        title="Uredi podatke partnerja v sifrantu"
                        className="-ml-2 text-xs text-gray-400 hover:text-blue-500 dark:hover:text-blue-400 disabled:opacity-40">
                        {nalagamPartnerja?'...':'\u270E'}
                      </button>
                    )}
                    {(selected.partner?.vat_number||selected.partner?.tax_number||kontiranje?.partner_davcna||(jeIzdaniTip(selected.doc_type)?(selected.ocr?.kupec_id_ddv||selected.ocr?.kupec_davcna):selected.ocr?.izdajatelj?.davcna))&&(
                      <span className="text-xs text-gray-400 font-mono">{(()=>{
                        const d = selected.partner?.vat_number||selected.partner?.tax_number||kontiranje?.partner_davcna||(jeIzdaniTip(selected.doc_type)?(selected.ocr?.kupec_id_ddv||selected.ocr?.kupec_davcna):selected.ocr?.izdajatelj?.davcna)||''; // [PATCH izdani-partner-isci-fe v1] davcna KUPCA pri izdanih
                        return d; /* [PATCH partner-davcna-brez-si v1] predpona je podatek (vat_number), ne oblikovanje - nikoli je ne sestavljaj */
                      })()}</span>
                    )}
                  </div>
                  {/* Vrstica 3: TRR | Referenca */}
                  <div className="flex items-center gap-3 text-xs text-gray-400 font-mono mb-1">
                    {urejanje?(
                      <span className="flex items-center gap-1">{/* [PATCH rocni-vnos-fe v1] TRR vnos */}
                        <input tabIndex={-1} disabled={zaklenjenIzdaja} value={trrEdit} onChange={e=>setTrrEdit(e.target.value)} placeholder="TRR (IBAN)"/* [PATCH prodajni-tok v3] */
                          className="w-56 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 px-1 py-0.5 rounded text-xs outline-none font-mono"/>
                        {partnerIbani.length>1&&(
                          <select tabIndex={-1} disabled={zaklenjenIzdaja} value="" onChange={e=>{if(e.target.value)setTrrEdit(e.target.value);}} title="IBAN-i partnerja"/* [PATCH prodajni-tok v3] */
                            className="bg-gray-100 dark:bg-gray-700 text-gray-500 px-1 py-0.5 rounded text-xs border-0 outline-none max-w-[90px]">
                            <option value="">\u25be IBAN</option>
                            {partnerIbani.map(ib=>(<option key={ib} value={ib}>{ib}</option>))}
                          </select>
                        )}
                      </span>
                    ):((selected.ocr?.trr||selected.partner?.iban)&&(
                      <span>{selected.ocr?.trr||selected.partner?.iban}</span>
                    ))}
                    <div className="flex items-center gap-1">
                      <select id="vt-sklic-model" disabled={zaklenjenGlava} tabIndex={urejanje?3:undefined} value={sklicData.model} onChange={e=>setSklicData(s=>({...s,model:e.target.value}))} className="bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 px-1 py-0.5 rounded text-xs border-0 outline-none">
                        <option>SI</option><option>RF</option><option>NRC</option>
                      </select>
                      <input disabled={zaklenjenGlava} tabIndex={urejanje?4:undefined} value={sklicData.modelSt} onChange={e=>setSklicData(s=>({...s,modelSt:e.target.value}))} maxLength={2} className="w-10 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 px-1 py-0.5 rounded text-xs text-center outline-none" placeholder="00"/>
                      {sklicData.modelSt!=='99'&&(
                        <input disabled={zaklenjenGlava} tabIndex={urejanje?5:undefined} value={sklicData.sklicSt} onChange={e=>setSklicData(s=>({...s,sklicSt:e.target.value}))} className="w-40 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 px-1 py-0.5 rounded text-xs outline-none" placeholder="Sklic"/>
                      )}
                    </div>
                  </div>
                </div>

                {/* ===== Vezave dobropis/avans (samo racuni) ===== */}
                {!jeRocni && (!selected.doc_type || selected.doc_type === 'prejeti_racun') && (
                  <div className="px-4 py-2 border-b border-gray-200 dark:border-gray-800 space-y-2">
                    {odprtiDobropisi.length > 0 ? (
                      <div className="flex items-center justify-between bg-amber-50 dark:bg-amber-950 border border-amber-200 dark:border-amber-800 rounded-lg px-3 py-2">
                        <span className="text-xs text-amber-700 dark:text-amber-300">📋 Ta dobavitelj ima {odprtiDobropisi.length} odprtih dobropisov/avansov</span>
                        {!strankaZaklenjen&&<button onClick={() => { setVeziIzbrani([]); setZmanjsajNalog(true); setVeziModal(true); }} className="text-xs px-2.5 py-1 rounded bg-amber-600 text-white hover:bg-amber-700">Veži</button>}{/* [PATCH likvidacija-fe v1] */}
                      </div>
                    ) : (!strankaZaklenjen&&
                      <button onClick={() => { setVeziIzbrani([]); setZmanjsajNalog(true); setVeziModal(true); }} className="text-xs text-blue-500 hover:underline">+ Veži dobropis / avans</button>
                    )}
                    {vezave.length > 0 && (
                      <div className="space-y-1">
                        {vezave.map((v: any) => (
                          <div key={v.link_id} className="flex items-center justify-between text-xs bg-blue-50 dark:bg-blue-950 rounded px-2 py-1">
                            <span className="text-blue-700 dark:text-blue-300">{v.kind === 'credit_note' ? 'Dobropis' : v.kind === 'avans' ? 'Avans' : v.kind} {v.doc_number || ''} · -{fmt(Number(v.znesek))} €{v.reduce_payment ? '' : ' (ne zmanjša naloga)'}</span>
                            {!strankaZaklenjen&&<button onClick={() => odpniVezavo(v.link_id)} className="text-red-500 hover:text-red-700 ml-2">✕ odpni</button>}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* ===== Vezava dobropisa/avansa na racun ===== */}
                {(selected.doc_type === 'credit_note' || selected.doc_type === 'avans') && (
                  <div className="px-4 py-2 border-b border-gray-200 dark:border-gray-800 space-y-2">
                    {(vezanNa?.povezave || []).map((pv: any) => (
                      <div key={pv.link_id} className="flex items-center justify-between bg-blue-50 dark:bg-blue-950 rounded-lg px-3 py-2">
                        <span className="text-xs text-blue-700 dark:text-blue-300">🔗 Vezano na račun {pv.racun_st || ''} (-{fmt(Number(pv.znesek))} €)</span>
                        {!strankaZaklenjen&&<button onClick={() => odpniVezavo(pv.link_id)} className="text-xs text-red-500 hover:text-red-700">✕ odpni</button>}
                      </div>
                    ))}
                    {Number(vezanNa?.preostali || 0) > 0.005 && !strankaZaklenjen && (
                      <button onClick={() => { setRacunIzbrani([]); setZmanjsajNalog(true); setRacunModal(true); }} className="text-xs px-2.5 py-1 rounded bg-indigo-600 text-white hover:bg-indigo-700">🔗 Poveži na račun{(vezanNa?.povezave || []).length ? ' (preostanek ' + fmt(Number(vezanNa.preostali)) + ' €)' : ''}</button>
                    )}
                  </div>
                )}

                {/* [PATCH rocni-vnos-fe v1] Opis (tab 6) — na mestu postavk */}
                {/* [PATCH opis-dokumenta v1] Opis je odslej na VSEH dokumentih (prejeti + izdani),
                    ne le pri rocnem vnosu. Po potrditvi zaklenjen (kot datumi in zneski).
                    predlagajKonte se sprozi SAMO pri rocnem vnosu: pri skeniranem racunu
                    bi popravek opisa povozil ze pregledano kontiranje.
                    Prazno polje -> ob prenosu gre v Opal/Vasco stevilka racuna. */}
                {!!selected&&(
                  <div className="px-4 py-2 border-b border-gray-200 dark:border-gray-800 flex items-center gap-2">
                    <span className="text-xs text-gray-400 w-10 flex-shrink-0">Opis</span>
                    <input tabIndex={6} disabled={zaklenjenDok} maxLength={80} value={opisVnos} onChange={e=>setOpisVnos(e.target.value)} onBlur={()=>{ if(jeRocniDok) predlagajKonte(undefined,opisVnos); }} placeholder={selected?.doc_number ? `Prazno \u2192 prenese se \u0161t. ${selected.doc_number}` : 'Opis ra\u010duna / postavke'}
                      className="flex-1 px-2 py-1 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 dark:text-white outline-none focus:border-blue-400 disabled:opacity-60"/>
                    <span className="text-[10px] text-gray-400 w-12 text-right flex-shrink-0">{(opisVnos||'').length}/80</span>
                  </div>
                )}
                {/* Postavke računa - zlozljiv box */}
                {selected.ocr?.postavke?.length>0&&(
                  <div className="border-b border-gray-200 dark:border-gray-800">
                    <button onClick={()=>setPostavkeOdprte(o=>!o)}
                      className="w-full flex items-center justify-between px-4 py-2.5 text-sm text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition">
                      <span className="font-medium">Postavke računa ({selected.ocr.postavke.length})</span>
                      <span className="text-gray-400">{postavkeOdprte?'\u25B2':'\u25BC'}</span>
                    </button>
                    {postavkeOdprte&&(
                      <div className="px-4 pb-3 overflow-x-auto">
                        <table className="w-full text-xs">
                          <thead>
                            <tr className="text-gray-400 border-b border-gray-200 dark:border-gray-700">
                              <th className="text-left py-1.5 pr-2 font-medium">Naziv</th>
                              <th className="text-right py-1.5 px-2 font-medium">Kol.</th>
                              <th className="text-right py-1.5 px-2 font-medium">Cena</th>
                              <th className="text-right py-1.5 px-2 font-medium">DDV</th>
                              <th className="text-right py-1.5 pl-2 font-medium">Vrednost</th>
                              {jeIzdaniTip(selected.doc_type)&&ir4aPk().length>0&&(<th className="text-left py-1.5 pl-3 font-medium">Konto</th>)}{/* [PATCH ir4a-ui-postavke v1] */}
                            </tr>
                          </thead>
                          <tbody>
                            {selected.ocr.postavke.map((pst:any,idx:number)=>{
                              return (
                              <tr key={idx} className="border-b border-gray-100 dark:border-gray-800 last:border-0">
                                <td className="py-1.5 pr-2 text-gray-700 dark:text-gray-300 whitespace-pre-line">{pst.naziv||'\u2014'}</td>
                                <td className="py-1.5 px-2 text-right font-mono text-gray-500">{pst.kolicina||''}</td>
                                <td className="py-1.5 px-2 text-right font-mono text-gray-500">{pst.cena?fmt(pst.cena):''}</td>
                                <td className="py-1.5 px-2 text-right font-mono text-gray-500">{/* [PATCH ddv-vejica-na v1] */ pst.ddv_stopnja!=null?String(pst.ddv_stopnja).replace('.',',')+'%':'N/A'}</td>
                                <td className="py-1.5 pl-2 text-right font-mono text-gray-700 dark:text-gray-300">{fmt(pst.znesek||0)}</td>
                                {jeIzdaniTip(selected.doc_type)&&ir4aPk().length>0&&(()=>{const _e=ir4aPkZa(pst,idx);return (
                                  <td className="py-1.5 pl-3 whitespace-nowrap">{/* [PATCH ir4a-ui-postavke v1] */}
                                    <span className="inline-flex items-center gap-1">
                                      {urejanje?(
                                        <input key={`irk${idx}-${_e?.konto||''}`} tabIndex={-1} defaultValue={_e?.konto||''}
                                          onBlur={e=>ir4aSpremeniKonto(idx,pst,e.target.value)}
                                          onKeyDown={e=>{if(e.key==='Enter'){(e.target as HTMLInputElement).blur();}}}
                                          className="w-16 px-1 py-0.5 rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 font-mono text-[11px] text-blue-600 dark:text-blue-400 outline-none focus:border-blue-500"/>
                                      ):(<span className="font-mono text-[11px] font-bold text-blue-600 dark:text-blue-400">{_e?.konto||'\u2014'}</span>)}
                                      <span title={_e?.beseda?`pravilo: ${_e.beseda}`:String(_e?.vir||'')} className={'text-[9px] px-1 py-0.5 rounded uppercase '+(String(_e?.vir||'').startsWith('pravilo')?'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300':_e?.vir==='rocno'?'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300':_e?.vir==='konflikt'?'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300':'bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400')}>{String(_e?.vir||'').startsWith('pravilo')?'P':_e?.vir==='rocno'?'R':_e?.vir==='konflikt'?'!':'Z'}</span>
                                      <button tabIndex={-1} onClick={()=>{const kk=_e?.konto||'';if(!kk){toast.error('Najprej vpi\u0161i konto');return;}setPostavkaOpisi({konto:kk,kategorija:_e?.kategorija||ir4aKat(pst)});}} title="Opisi za konto (pravila razbitja)"
                                        className="w-4 h-4 flex items-center justify-center rounded border border-blue-400/50 text-blue-500 hover:bg-blue-500/20 text-[11px] leading-none">+</button>
                                    </span>
                                  </td>
                                );})()}
                              </tr>
                            );})}
                          </tbody>
                        </table>
                        {jeIzdaniTip(selected.doc_type)&&ir4aPk().length>0&&(()=>{/* [PATCH ir4a-ui-postavke v1] sestevek po kontih */
                          const sk:Record<string,number>={};(selected.ocr.postavke||[]).forEach((p:any,j:number)=>{const el=ir4aPkZa(p,j);const k=String(el?.konto||'');if(!k)return;sk[k]=Number(((sk[k]||0)+Number(p?.znesek||0)).toFixed(2));});
                          const pari:any[]=Object.entries(sk).sort((x:any,y:any)=>Number(y[1])-Number(x[1]));
                          const vs=Number(pari.reduce((s:number,par:any)=>s+Number(par[1]),0).toFixed(2));
                          const osn=Number(selected.ocr?.zneski?.skupaj_brez_ddv||0);
                          const ok=Math.abs(vs-osn)<=0.02;
                          return (<div className="mt-2 pt-2 border-t border-gray-200 dark:border-gray-700 flex flex-wrap items-center gap-3 text-[11px]">
                            {pari.map((par:any)=>(<span key={String(par[0])} className="font-mono text-gray-600 dark:text-gray-300"><span className="font-bold text-blue-600 dark:text-blue-400">{String(par[0])}</span> = {fmt(Number(par[1]))}</span>))}
                            <span className={'ml-auto font-mono font-bold '+(ok?'text-emerald-600':'text-red-500')}>{'\u03a3'} {fmt(vs)} / {fmt(osn)} {ok?'\u2713':'\u2717'}</span>
                          </div>);})()}
                      </div>
                    )}
                  </div>
                )}

                <div className="p-4 space-y-4">
{/* [PATCH rocni-vnos-fe v5] devizna sekcija prestavljena PRED zneske */}
                  {/* [PATCH rocni-vnos-fe v4] kljukica Devizni racun (urejanje; izven tab-verige) */}
                  {urejanje&&(
                    <div className="flex items-center gap-2">
                      <input type="checkbox" tabIndex={-1} className="w-3.5 h-3.5 accent-amber-500 cursor-pointer"
                        checked={Boolean(kontiranje?.devizno&&(kontiranje.devizno.valuta||kontiranje.devizno._vklop))}
                        onChange={e=>{
                          if(e.target.checked){
                            setDevValuta(''); setDevZnesek('');
                            setDevDatum(datumi.datum_racuna?fmtDatum(datumi.datum_racuna):''); // [PATCH rocni-vnos-fe v5]
                            setKontiranje((k:any)=>({...k,devizno:{...((k&&k.devizno)||{}),_vklop:true}}));
                          } else {
                            setKontiranje((k:any)=>{const nk:any={...k}; delete nk.devizno; return nk;});
                          }
                        }}/>
                      <span className="text-xs font-medium text-amber-600 dark:text-amber-400 uppercase">Devizni račun</span>
                      {Boolean(kontiranje?.devizno?._vklop&&!kontiranje?.devizno?.valuta)&&(<>
                        {/* [PATCH rocni-vnos-fe v5] mini-vnos: valuta | znesek | datum | ✓ */}
                        <input id="vt-dev-valuta" tabIndex={-1} maxLength={3} placeholder="USD" autoFocus value={devValuta}
                          onChange={e=>setDevValuta(e.target.value.toUpperCase().replace(/[^A-Z]/g,''))}
                          onKeyDown={e=>{if(e.key==='Enter'||e.key==='Tab'){e.preventDefault();document.getElementById('vt-dev-znesek')?.focus();}}}
                          className="w-16 px-1.5 py-0.5 rounded border border-amber-400 bg-white dark:bg-gray-800 text-amber-700 dark:text-amber-300 text-xs font-mono uppercase outline-none"/>
                        <input id="vt-dev-znesek" tabIndex={-1} placeholder="Znesek v valuti" inputMode="decimal" value={devZnesek}
                          onChange={e=>setDevZnesek(e.target.value)}
                          onKeyDown={e=>{if(e.key==='Enter'||e.key==='Tab'){e.preventDefault();document.getElementById('vt-dev-datum')?.focus();}}}
                          className="w-28 px-1.5 py-0.5 rounded border border-amber-400 bg-white dark:bg-gray-800 text-amber-700 dark:text-amber-300 text-xs font-mono text-right outline-none"/>
                        <input id="vt-dev-datum" tabIndex={-1} placeholder="DD.MM.YYYY" value={devDatum}
                          onChange={e=>setDevDatum(e.target.value)}
                          onKeyDown={e=>{if(e.key==='Enter'||e.key==='Tab'){e.preventDefault();deviznoPotrdiVnos();}}}
                          onBlur={()=>{const p=parseDatumVnos(String(devDatum||'').trim()); if(p) setDevDatum(p.split('-').reverse().join('.'));}}
                          className="w-28 px-1.5 py-0.5 rounded border border-amber-400 bg-white dark:bg-gray-800 text-amber-700 dark:text-amber-300 text-xs font-mono outline-none"/>
                        <button tabIndex={-1} onClick={deviznoPotrdiVnos} title="Preračunaj v EUR"
                          className="px-2 py-0.5 rounded bg-amber-500 hover:bg-amber-600 text-white text-xs font-bold">✓</button>
                      </>)}
                    </div>
                  )}
                  {/* [PATCH fe-bsi-valuta v2] devizni racun: klik-za-urejanje, decimalna vejica (nadgradnja [PATCH fe-bsi-valuta v1]) */}
                  {(kontiranje?.devizno?.valuta || selected.ocr?.devizno?.valuta) && (()=>{
                    const dv:any = kontiranje?.devizno || selected.ocr?.devizno || {};
                    const eurSkupaj = Number(kontiranje?.ocr_zneski?.skupaj_z_ddv ?? selected.ocr?.zneski?.skupaj_z_ddv ?? 0);
                    return (
                      <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-xl p-3 space-y-1.5">
                        <h4 className="text-xs font-medium text-amber-600 dark:text-amber-400 uppercase mb-1">Devizni račun · {dv.valuta}</h4>
                        {!dv.tecaj && (
                          <div className="text-xs text-red-500">⚠️ Tečaja BSI ni — zneski so še v {dv.valuta}. Klikni tečaj ali datum tečaja in vnesi ročno.</div>
                        )}
                        <div className="flex justify-between text-sm items-center">
                          <span className="text-gray-500">Znesek v {dv.valuta}</span>
                          <DevZnesek value={dv.znesek_valuta} bold sufiks={dv.valuta} onCommit={deviznoZvChange}/>
                        </div>
                        <div className="flex justify-between text-sm items-center">
                          <span className="text-gray-500">Tečaj ({dv.tecaj_vir||'BSI'})</span>
                          <DevZnesek value={dv.tecaj} decimals={6} onCommit={deviznoTecajChange}/>
                        </div>
                        <div className="flex justify-between text-sm items-center">
                          <span className="text-gray-500">Datum tečaja</span>
                          <DevDatum value={dv.tecaj_datum} onCommit={deviznoDatumChange}/>
                        </div>
                        <div className="flex justify-between text-sm items-center border-t border-amber-200 dark:border-amber-800 pt-1.5">
                          <span className="text-gray-500">= v EUR</span>
                          <DevZnesek value={eurSkupaj} bold sufiks="EUR" onCommit={deviznoEurChange}/>
                        </div>
                      </div>
                    );
                  })()}

                  <div className="bg-gray-50 dark:bg-gray-800 rounded-xl p-3 space-y-1.5">
                    {['skupaj_brez_ddv','znesek_ddv','skupaj_z_ddv'].map(kljuc=>(
                      <div key={kljuc} className="flex justify-between text-sm items-center">
                        <span className="text-gray-500">
                          {kljuc==='skupaj_brez_ddv'?'Osnova brez DDV':kljuc==='znesek_ddv'?'DDV':'Skupaj z DDV'}
                        </span>
                        {urejanje ? (
                          <ZnesekInput
                            id={kljuc==='skupaj_brez_ddv'?'vt-osnova':undefined}
                            tabIndex={kljuc==='skupaj_z_ddv'?-1:(kljuc==='skupaj_brez_ddv'?7:8)}
                            value={Number(kontiranje?.ocr_zneski?.[kljuc]??selected.ocr?.zneski?.[kljuc]??0)}
                            onChange={v=>nastaviZnesek(kljuc,v)}
                            className="w-28"
                            bold={kljuc==='skupaj_z_ddv'}
                            napaka={napakaZa('zneski')}
                          />
                        ) : (
                          <span title={napakaZa('zneski')} className={clsx('font-mono',kljuc==='skupaj_z_ddv'&&'font-bold',napakaZa('zneski')&&'text-red-600 dark:text-red-400')}>{/* [PATCH likvidacija-fe v3] */}
                            {fmt(kontiranje?.ocr_zneski?.[kljuc] ?? selected.ocr?.zneski?.[kljuc] ?? 0)} EUR
                          </span>
                        )}
                      </div>
                    ))}
                    {/* [PATCH likvidacija-fe v4] ostalo (neobdavceno): postavke izven DDV; privzeto skrito, gumb + ga pokaze,
                        vrednost != 0 ga pokaze tudi brez klika; x ga skrije, ko je 0. OCR ga ne polni. */}
                    {ostaloVidno&&(
                      <div className="flex justify-between text-sm items-center">
                        <span className="text-gray-500 flex items-center gap-1" title="Za postavke izven DDV — obroki, prenos stanja ipd. Osnova + DDV + ostalo = skupaj z DDV.">
                          Ostalo (neobdavčeno)
                          {urejanje&&ostaloGlave()===0&&(<button type="button" tabIndex={-1} onClick={()=>setOstaloOdprto(false)} title="Skrij polje" className="text-gray-400 hover:text-red-500 text-xs leading-none px-1">×</button>)}
                        </span>
                        {urejanje ? (
                          <ZnesekInput id="vt-ostalo" tabIndex={-1} value={ostaloGlave()} onChange={v=>nastaviZnesek('ostalo',v)} className="w-28" napaka={napakaZa('zneski')}/>
                        ) : (
                          <span title={napakaZa('zneski')} className={clsx('font-mono',napakaZa('zneski')&&'text-red-600 dark:text-red-400')}>{fmt(ostaloGlave())} EUR</span>
                        )}
                      </div>
                    )}
                    {urejanje&&!ostaloVidno&&(
                      <button type="button" tabIndex={-1} onClick={()=>setOstaloOdprto(true)} title="Za postavke izven DDV — obroki, prenos stanja ipd." className="text-[11px] text-blue-500 hover:underline">+ ostalo (neobdavčeno)</button>
                    )}
                  </div>
                  
                                    <div className="bg-gray-50 dark:bg-gray-800 rounded-xl p-3">
                    <h4 className="text-xs font-medium text-gray-400 uppercase mb-2">Datumi</h4>
                    {zaklenjenIzdaja&&(/* [PATCH prodajni-tok v3] pasica zaklepa (Janez 24.09.: izdan dokument je nespremenljiv povsod; popravek = storno/dobropis) */
                      <div className="mb-2 flex items-center gap-2 rounded-lg border border-violet-200 dark:border-violet-500/30 bg-violet-50 dark:bg-violet-500/15 px-3 py-2 text-xs text-violet-900 dark:text-violet-200">
                        <span className="text-base">🔒</span>
                        <span className="flex-1"><b>Izdano v Prodaji</b>{izIzdaje?.stevilka?` (št. ${izIzdaje.stevilka})`:''} — podatki izdanega dokumenta so zaklenjeni. V računovodstvu lahko urejate samo računovodske podatke (konti, SM, projekt, opis).</span>
                        {izIzdaje?.poslovni_dok_id&&(<button type="button" onClick={()=>window.location.assign(`/izdaja/${izIzdaje.poslovni_dok_id}`)} className="px-2 py-1 rounded-md bg-violet-600 hover:bg-violet-700 text-white font-medium whitespace-nowrap">Odpri v Prodaji</button>)}
                      </div>
                    )}
                    <fieldset disabled={zaklenjenGlava} className={zaklenjenGlava ? 'border-0 p-0 m-0 min-w-0 opacity-60' : 'border-0 p-0 m-0 min-w-0'}>{/* [PATCH likvidacija-fe v1] datumi: tudi za stranko po likvidaciji */}{/* [PATCH prodajni-tok v3] + zaklep iz izdaje (datum knjizenja v UI zaklenjen skupaj s fieldsetom; backend ga dovoli) */}
                    <div className="grid grid-cols-3 gap-2 mb-2">
                      <DatumInput id="vt-datum-racuna" napaka={napakaZa('datum_racuna')} tabIndex={urejanje?9:undefined} label="Datum računa" value={datumi.datum_racuna} onChange={v=>{ let _dd=v,_ob=obdobjeIzDatuma(v); if(!jeIzdaniTip(selected?.doc_type) && jeZaklenjeno(v,ddvBlokada)){/* [PATCH izdani-blokada-dialog-fe v2] */ _dd=prviOdprtiDan(ddvBlokada); /* [PATCH prejeti-obdobje-storitev v1] */ toast(`Datum za DDV → ${_dd.split('-').reverse().join('.')} — obdobje ostane ${_ob}`,{icon:'\ud83d\udd12'}); } setDatumi(d=>({...d,datum_racuna:v,datum_ddv:_dd,datum_storitve:v,obdobje:_ob})); }}/>
                      <DatumInput napaka={napakaZa('datum_storitve')} tabIndex={urejanje?10:undefined} label="Datum storitve" value={datumi.datum_storitve} onChange={v=>{ if(/* [PATCH zaklep-leta-izdani v1] obe smeri */ letoZaklenjeno>0&&/^\d{4}-/.test(String(v||''))&&Number(String(v).slice(0,4))<=letoZaklenjeno){toast(`Leto ${String(v).slice(0,4)} je zaklenjeno (do vključno ${letoZaklenjeno}) — datum storitve vpisan ročno`,{icon:'\u26a0\ufe0f',id:'zaklep-leta-rocno'});} /* [PATCH zaklep-leta-fe v1] O7: opozorilo, ne blokada */ let _dd=v,_ob=obdobjeIzDatuma(v); if(!jeIzdaniTip(selected?.doc_type) && jeZaklenjeno(v,ddvBlokada)){/* [PATCH izdani-blokada-dialog-fe v2] */ _dd=prviOdprtiDan(ddvBlokada); /* [PATCH prejeti-obdobje-storitev v1] */ toast(`Datum za DDV → ${_dd.split('-').reverse().join('.')} — obdobje ostane ${_ob}`,{icon:'\ud83d\udd12'}); } setDatumi(d=>({...d,datum_storitve:v,datum_ddv:_dd,obdobje:_ob})); }}/>
                      <DatumInput napaka={napakaZa('datum_valute')} tabIndex={urejanje?11:undefined} label="Datum valute" value={datumi.datum_valute} onChange={v=>setDatumi(d=>({...d,datum_valute:v}))}/>
                    </div>
                    <div className="grid grid-cols-3 gap-2">
                      <DatumInput napaka={napakaZa('datum_knjizenja')} tabIndex={-1} label="Datum knjiženja" value={datumi.datum_knjizenja} onChange={v=>setDatumi(d=>({...d,datum_knjizenja:v}))}/>
                      <DatumInput napaka={napakaZa('datum_ddv')} tabIndex={-1} label="Datum za DDV" value={datumi.datum_ddv} onChange={v=>{ if(jeZaklenjeno(v,ddvBlokada)){ toast.error(`Datum za DDV do ${mmyyyy(ddvBlokada)} je davčno zaklenjen`); return; } setDatumi(d=>({...d,datum_ddv:v,obdobje:d.obdobje||obdobjeIzDatuma(d.datum_storitve)})); /* [PATCH prejeti-obdobje-storitev v1] datum za DDV ne prestavlja obdobja */ }}/>
                      <ObdobjeInput napaka={napakaZa('obdobje')} tabIndex={-1} label="Obdobje (MM.YYYY)" value={datumi.obdobje} onChange={v=>{ const m=/^(\d{2})\.(\d{4})$/.exec(v||''); if(m&&ddvBlokada&&jeIzdaniTip(selected?.doc_type)&&(`${m[2]}-${m[1]}`<=ddvBlokada)){ /* [PATCH prejeti-obdobje-storitev v1] prejeti: obdobje sme biti v zaklenjenem mesecu, ker sledi storitvi */ toast.error(`Obdobja do ${mmyyyy(ddvBlokada)} so davčno zaklenjena`); return; } setDatumi(d=>({...d,obdobje:v})); }}/>
                  </div>
                    </fieldset>
                  </div>

                  {kontiranje&&(
                    <>
                      {/* [PATCH rocni-vnos-fe v1] DDV evidenca prestavljena PRED kontiranje */}
                      <div>
                        {!jeStranka && (<h4 className="text-xs font-medium text-gray-400 uppercase mb-2">DDV Evidenca — {jeIzdaniTip(selected?.doc_type) ? 'KIR' : 'KPR'}</h4>)}{/* [PATCH kir-naslov v1] */}{/* [PATCH stranka-skrij-kontiranje v1] naslov brez vsebine stranki nic ne pove */}
                        {!jeStranka && (
                        <fieldset disabled={potrjenDok} className={potrjenDok ? 'border-0 p-0 m-0 min-w-0 opacity-60' : 'border-0 p-0 m-0 min-w-0'}>
                        <DdvKnjiga tabVnos={urejanje} kontiranje={kontiranje} selected={selected} onChange={handleDdvChangeZ} ddvKonti={ddvKonti} companyId={companyId}/>{/* [PATCH oss-temelji v1] C5 */}
                        </fieldset>
                      )}
                      {jeStranka && selected?.id && !selected?._rocni && companyId && <OpombeNit companyId={companyId} docId={selected.id} jeStranka={true}/>}{/* [PATCH opombe-stranka-fe v1] [PATCH opombe-dno v1] samo stranka; racunovodja na dnu */}
                      {!jeStranka && selected?.opomba && (
                        <div className="mt-3 p-3 rounded-lg bg-red-50 dark:bg-red-950 border border-red-200 dark:border-red-800 text-sm">
                          <div className="font-semibold text-red-700 dark:text-red-300 mb-1">Opomba stranke</div>
                          <div className="text-gray-700 dark:text-gray-200 whitespace-pre-wrap">{selected.opomba}</div>
                        </div>
                      )}
                      </div>
                      <div>
                        <div className="flex items-center justify-between mb-2">
                          {!jeStranka && (<h4 className="text-xs font-medium text-gray-400 uppercase">Kontiranje</h4>)}{/* [PATCH fe-odstrani-zaupanje-ddv v1] */}{/* [PATCH stranka-skrij-kontiranje v1] */}
                        </div>
                        {jeStranka ? (
                        <div>
                          <div className="text-xs font-semibold text-gray-500 dark:text-gray-400 mb-1">OPOMBA ZA RAČUNOVODSTVO</div>
                          <textarea value={opombaText} onChange={(e)=>setOpombaText(e.target.value)} rows={3}
                            placeholder="Npr. račun se nanaša na ..."
                            className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white text-sm"/>
                          {/* [PATCH likvidacija-fe v2] gumb "Shrani opombo" prestavljen v skupno spodnjo vrstico (glej likvGumbViden) */}
                        </div>
                      ) : (
                        /* [PATCH razdeli-ddv-fe v2] prop ddvVrstice za gumb Razdeli */
                        <fieldset disabled={potrjenDok} className={potrjenDok ? 'border-0 p-0 m-0 min-w-0 opacity-60' : 'border-0 p-0 m-0 min-w-0'}>
                        <KontiranjeEditor tabVnos={urejanje} knjizbe={kontiranje.knjizbe||[]} companyId={companyId} ddvVrstice={kontiranje.ddv_knjiga||[]} docType={selected?.doc_type /* [PATCH razdeli-ddv-pogoji v1] izdani brez gumba in statusa */} docPartnerId={selected?.partner?.id || kontiranje?.partner_id || selected?.partner_id /* [PATCH partner-prevezava-varovalka v1] isti vir kot glava */} docPartnerNaziv={selected?.partner?.ime || selected?.partner?.name || kontiranje?.partner_ime || '' /* [PATCH partner-prevezava-varovalka v1] enak vrstni red kot glava (:3704), sicer glava in knjizba pokazeta razlicnega partnerja */} onChange={(knjizbe)=>setKontiranje({...kontiranje,knjizbe})}/>
                        </fieldset>
                      )}
                      {postavkaOpisi&&(<KontoBesedePopup companyId={companyId} konto={postavkaOpisi.konto} smer="izdani" ddvKategorija={postavkaOpisi.kategorija} onClose={()=>setPostavkaOpisi(null)}/>)}{/* [PATCH ir4a-ui-postavke v1a] */}
                        {/* [PATCH stranka-skrij-kontiranje v1] opozorilo 'Avtomatsko kontiranje ni uspelo' (BE razlog_pregleda) je za racunovodjo, ne za stranko */}
                        {!jeStranka&&kontiranje.zahteva_pregled&&(
                          <div className="flex items-start gap-2 bg-amber-50 dark:bg-amber-950 text-amber-700 rounded-xl p-3 text-xs mt-2">
                            <AlertTriangle className="w-4 h-4 flex-shrink-0"/><span>{kontiranje.razlog_pregleda}</span>
                          </div>
                        )}
                      </div>
                      {!jeStranka && ((jeRocni||selected.status!=='approved')?(
                        <button id="vt-potrdi" tabIndex={urejanje?17:undefined} disabled={potrditevBlokirana||glavaNapacna} title={potrditevBlokirana?'Stranka računa še ni likvidirala':(glavaNapacna?('Račun ima napake: '+napakeGlaveTxt):undefined)}
                          onClick={()=>{ if(potrditevBlokirana){ toast.error('Stranka računa še ni likvidirala'); return; } if(jeRocni) potrdiRocni(); else potrdiKontiranje(); }}
                          className={clsx('w-full py-2.5 text-white font-semibold rounded-xl transition text-sm focus:ring-2 focus:ring-blue-400', (potrditevBlokirana||glavaNapacna)?'bg-gray-400 dark:bg-gray-600 cursor-not-allowed':'bg-blue-600 hover:bg-blue-700')}>{/* [PATCH likvidacija-fe v1] siv, dokler stranka ne likvidira; [PATCH likvidacija-fe v3] siv ob napakah glave */}
                          ✓ Potrdi račun
                        </button>
                      ):(
                        <div>{/* [PATCH u7b-preklic-fe v1] */}
                          <div className="w-full py-2.5 bg-green-50 dark:bg-green-950 text-green-700 font-semibold rounded-xl text-sm text-center">✓ Potrjeno</div>
                          <button onClick={prekliciPotrditev} className="w-full mt-2 py-2.5 bg-red-50 dark:bg-red-950 text-red-600 font-semibold rounded-xl text-sm hover:bg-red-100 dark:hover:bg-red-900 transition">⟲ Prekliči potrditev</button>{/* [PATCH u7b-preklic-fe v3] rdec, kot znacka */}
                        </div>
                      ))}
                    </>
                  )}
                  {/* [PATCH likvidacija-fe v2] spodnja vrstica gumbov: levo Shrani/Preklici (urejanje) ali Shrani opombo (stranka),
                      desno velik gumb Likvidiraj racun / Preklici likvidacijo. Med urejanjem sta opomba in likvidacija skriti. */}
                  {/* [PATCH racun-placan-gumb v1] vrstica se pokaze tudi zaradi gumba Racun je placan */}
                  {!jeRocni&&(editMode||(jeStranka&&!!kontiranje)||likvGumbViden||placanGumbViden)&&(
                    <div className="flex items-start justify-between gap-3 pt-1">
                      {editMode?(
                        <div className="flex items-center gap-2">
                          <button id="vt-shrani-urejanje" onClick={shraniUrejanje} disabled={glavaNapacna} title={glavaNapacna?('Račun ima napake: '+napakeGlaveTxt):'Shrani popravke glave (isto kot prejšnji »Končaj«)'} className={clsx('px-4 py-1.5 rounded-lg text-white text-sm font-medium', glavaNapacna?'bg-gray-400 dark:bg-gray-600 cursor-not-allowed':'bg-blue-600 hover:bg-blue-700')}>Shrani</button>{/* [PATCH likvidacija-fe v3] siv ob napakah */}
                          <button id="vt-preklici-urejanje" onClick={prekliciUrejanje} title="Zavrzi spremembe in vrni prejšnje vrednosti (Esc)" className="px-4 py-1.5 rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 text-sm">Prekliči</button>
                          <span className="text-[11px] text-gray-400">Esc = Prekliči</span>
                          {glavaNapacna&&(<span className="text-[11px] text-red-600 dark:text-red-400 max-w-md">{napakeGlaveTxt}</span>)}{/* [PATCH likvidacija-fe v3] */}
                        </div>
                      ):(jeStranka&&!!kontiranje?(
                        <button onClick={shraniOpombo} className="px-4 py-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm">Shrani opombo</button>
                      ):<span/>)}
                      {/* [PATCH racun-placan-gumb v1] */}
                      {placanGumbViden&&(
                        <button id="vt-racun-placan" disabled={placanBusy} onClick={oznaciRacunPlacan} title="Označi račun kot plačan v celoti (danes). Enako kot »Označi za plačano« v Plačilih." className="px-4 py-1.5 rounded-lg bg-green-600 hover:bg-green-700 text-white text-sm font-medium disabled:opacity-40">✓ Račun je plačan</button>
                      )}
                      {likvGumbViden&&(
                        <div className="flex flex-col items-end text-right">
                          {likvidiranDok(selected)
                            ?<button id="vt-likvidacija" disabled={likvBusy} onClick={()=>prekliciLikvidacijo(selected)} title="Prekliči likvidacijo, da lahko račun spet urejate" className="px-4 py-1.5 rounded-lg border-2 border-amber-500 text-amber-600 hover:bg-amber-50 dark:hover:bg-amber-950 text-sm font-medium disabled:opacity-40">⟲ Prekliči likvidacijo</button>
                            :<button id="vt-likvidacija" disabled={likvBusy||glavaNapacna} onClick={()=>likvidirajDokument(selected)} title={glavaNapacna?('Račun ima napake: '+napakeGlaveTxt):'S tem računovodstvu sporočite, da je račun v redu.'} className={clsx('px-4 py-1.5 rounded-lg text-white text-sm font-medium disabled:opacity-40', glavaNapacna?'bg-gray-400 dark:bg-gray-600 cursor-not-allowed':'bg-emerald-600 hover:bg-emerald-700')}>✓ Likvidiraj račun</button>}{/* [PATCH likvidacija-fe v3] siv ob napakah */}
                          <span className={clsx('text-[11px] mt-1', (glavaNapacna&&!likvidiranDok(selected))?'text-red-600 dark:text-red-400 max-w-md':'text-gray-400')}>{likvidiranDok(selected)?'Za urejanje računa likvidacijo prekličite.':(glavaNapacna?('Račun ima napake: '+napakeGlaveTxt):'S tem računovodstvu sporočite, da je račun v redu.')}</span>
                        </div>
                      )}
                    </div>
                  )}
                  {/* [PATCH ai-preverbe-fe v1] blok Preverba racuna (Python, samo branje) */}{!jeStranka && aiVklop && selected?.id && !selected?._rocni && aiJePrejeti(selected) && (
                    <div id="vt-ai-preverba" className={clsx('mt-4 rounded-xl border p-3', aiPrev?.ocena==='rdeca'?'border-red-300 bg-red-50 dark:border-red-800 dark:bg-red-950/40':aiPrev?.ocena==='rumena'?'border-amber-300 bg-amber-50 dark:border-amber-800 dark:bg-amber-950/40':'border-gray-200 dark:border-gray-700')}>
                      <div className="flex items-center justify-between gap-2">
                        <div className="flex items-center gap-2 text-sm font-semibold text-gray-800 dark:text-gray-100">
                          <span className={clsx('w-2.5 h-2.5 rounded-full', aiPrev?.ocena==='rdeca'?'bg-red-500':aiPrev?.ocena==='rumena'?'bg-amber-400':aiPrev?.ocena==='zelena'?'bg-green-500':'bg-gray-300')}/>
                          Preverba računa
                        </div>
                        <span className="text-[11px] text-gray-500 dark:text-gray-400">{aiPrevNal?'preverjam…':(aiPrev?.povzetek||'')}</span>
                      </div>
                      {(aiPrev?.ugotovitve||[]).filter((u:any)=>u.resnost!=='info').map((u:any,ix:number)=>(
                        <div key={ix} className="mt-2 flex items-start gap-2 text-sm">
                          <span className={clsx('mt-0.5 text-[10px] px-1.5 py-0.5 rounded font-semibold flex-shrink-0', u.resnost==='napaka'?'bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-200':'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200')}>{u.resnost==='napaka'?'NAPAKA':'OPOZORILO'}</span>
                          <div className="min-w-0">
                            <span className="font-medium text-gray-800 dark:text-gray-100">{u.polje}: </span>
                            <span className={clsx('text-gray-600 dark:text-gray-300', u.resnost==='napaka'&&u.predlog&&'line-through decoration-red-400')}>{u.trenutno}</span>
                            {u.predlog&&(<><span className="mx-1 text-gray-400">→</span><span className="font-semibold text-gray-900 dark:text-white">{u.predlog}</span></>)}
                            <div className="text-[11px] text-gray-500 dark:text-gray-400">{u.razlog}{u.dokaz?` · ${u.dokaz}`:''}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  {/* [PATCH opombe-pogoj v1] */}{!jeStranka && opombeNaVoljo && !jeIzdaniTip(selected?.doc_type||'') && selected?.id && !selected?._rocni && companyId && <div className="mt-4"><OpombeNit companyId={companyId} docId={selected.id} jeStranka={false} kompaktno/></div>}{/* [PATCH opombe-dno v1] opombe za stranko — racunovodja, dno maske */}
                </div>
              </div>
            )}
          </div>

          {/* Drag handle - detail/pdf */}
          {selected?.file_path && !pdfOdprto && (
            <div onMouseDown={onMouseDown('detail')}
              className="w-1.5 mx-1 cursor-col-resize hover:bg-blue-400 active:bg-blue-500 rounded-full transition-colors flex-shrink-0 self-stretch bg-gray-200 dark:bg-gray-700"/>
          )}
          {selected?.file_path && !pdfOdprto && (
            <div ref={detailPanelRef} className="flex-shrink-0 flex flex-col bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 overflow-hidden" style={{width: panelWidths.detail}}>
              <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-800 flex items-center justify-between">
                <span className="text-xs font-medium text-gray-500">PDF Predogled</span>
                <button onClick={async()=>{
                  try {
                    const r = await api.get(`/dokumenti/${companyId}/${selected.id}/pdf-token`);
                    localStorage.setItem('aicount_pdf_doc', JSON.stringify({companyId, docId: selected.id, token: r.data.token}));
                    window.open('/pdf-viewer', 'aicount_pdf_window', 'width=900,height=1100');
                    setPdfOdprtoShranjeno(true);
                  } catch(e) { console.error(e); }
                }} className="text-xs text-blue-400 hover:text-blue-300 flex items-center gap-1">
                  ↗ Odpri v novem oknu
                </button>
              </div>
              <div className="flex-1 min-h-0"><PdfViewer key={selected.id} companyId={companyId} docId={selected.id}/></div>
            </div>
          )}
          {/* [PATCH rocni-vnos-fe v2] predogled prilozene datoteke pri rocnem vnosu */}
          {jeRocni && rocniPreviewUrl && (
            <div className="w-1.5 mx-1 rounded-full flex-shrink-0 self-stretch bg-gray-200 dark:bg-gray-700"/>
          )}
          {jeRocni && rocniPreviewUrl && (
            <div className="flex-shrink-0 flex flex-col bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 overflow-hidden" style={{width: panelWidths.detail}}>
              <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-800 flex items-center justify-between gap-2">
                <span className="text-xs font-medium text-gray-500 truncate">Priponka: {rocniFile?.name}</span>
                <button tabIndex={-1} onClick={()=>setRocniFile(null)} className="text-xs text-red-400 hover:text-red-300 flex-shrink-0">✕ odstrani</button>
              </div>
              <div className="flex-1 min-h-0 bg-gray-100 dark:bg-gray-800">
                {rocniFile&&rocniFile.type&&rocniFile.type.startsWith('image/')?(
                  <img src={rocniPreviewUrl} alt="priponka" className="w-full h-full object-contain"/>
                ):(
                  <iframe src={rocniPreviewUrl} title="priponka" className="w-full h-full border-0"/>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
// [PATCH partner-vat-glava v1] vat_number v verigi davcne v glavi (glej dokumenti.py:~2229)
// [PATCH partner-vat-glava v2] vat_number se prenese tudi ob izbiri partnerja iz seznama (880/882/886)
